export default {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [117.6272, -8.5064],
              [117.6347, -8.5577],
              [117.7339, -8.56494],
              [117.7511, -8.59203],
              [117.7476, -8.65059],
              [117.7706, -8.71411],
              [117.8005, -8.72671],
              [117.8649, -8.69836],
              [117.9643, -8.74235],
              [118.042, -8.66336],
              [118.1307, -8.65005],
              [118.1907, -8.67446],
              [118.2592, -8.65611],
              [118.2602, -8.58876],
              [118.0921, -8.49019],
              [118.0745, -8.45144],
              [117.9755, -8.46654],
              [117.8264, -8.36613],
              [117.69, -8.23815],
              [117.7187, -8.16267],
              [117.7737, -8.12987],
              [117.8297, -8.12762],
              [117.923, -8.08018],
              [117.9477, -8.1023],
              [118.0027, -8.09299],
              [118.0848, -8.11166],
              [118.1397, -8.13938],
              [118.1403, -8.20128],
              [118.1771, -8.26983],
              [118.2107, -8.28859],
              [118.2371, -8.34483],
              [118.3065, -8.37104],
              [118.376, -8.3322],
              [118.3766, -8.30573],
              [118.4821, -8.24431],
              [118.6543, -8.28915],
              [118.6959, -8.3531],
              [118.696, -8.43382],
              [118.666, -8.49455],
              [118.7134, -8.49515],
              [118.7031, -8.40608],
              [118.7351, -8.33774],
              [118.8045, -8.28351],
              [118.8935, -8.28139],
              [119.0086, -8.3121],
              [118.9956, -8.37304],
              [119.0554, -8.44954],
              [119.058, -8.5075],
              [119.0193, -8.52801],
              [119.0157, -8.56836],
              [119.0402, -8.64027],
              [119.0823, -8.64853],
              [119.1626, -8.63554],
              [119.1608, -8.70023],
              [119.136, -8.7498],
              [119.0251, -8.73356],
              [118.9733, -8.74543],
              [118.9094, -8.67704],
              [118.8719, -8.72035],
              [118.814, -8.69996],
              [118.7487, -8.69728],
              [118.7364, -8.75995],
              [118.8394, -8.76959],
              [118.9111, -8.7657],
              [118.952, -8.80798],
              [118.9095, -8.84041],
              [118.823, -8.83576],
              [118.7604, -8.79343],
              [118.6678, -8.8026],
              [118.5264, -8.87052],
              [118.4338, -8.88751],
              [118.368, -8.84007],
              [118.3683, -8.76699],
              [118.4155, -8.7207],
              [118.4147, -8.64578],
              [118.3432, -8.68399],
              [118.313, -8.72504],
              [118.2689, -8.74803],
              [118.1936, -8.83756],
              [118.1125, -8.88099],
              [118.0707, -8.84253],
              [117.994, -8.85823],
              [117.9719, -8.89648],
              [117.8884, -8.92488],
              [117.7711, -8.93188],
              [117.6781, -8.92221],
              [117.5918, -8.98328],
              [117.4106, -9.05105],
              [117.3334, -9.05713],
              [117.206, -9.02215],
              [117.1763, -9.02927],
              [117.1348, -9.08871],
              [117.0162, -9.11278],
              [116.9575, -9.06298],
              [116.8858, -9.06688],
              [116.7943, -9.04135],
              [116.7278, -8.98057],
              [116.7335, -8.87307],
              [116.7631, -8.86169],
              [116.8032, -8.79202],
              [116.7648, -8.74296],
              [116.7527, -8.67578],
              [116.7814, -8.59762],
              [116.831, -8.54152],
              [116.9356, -8.52108],
              [116.9938, -8.49331],
              [117.0946, -8.4171],
              [117.1216, -8.37079],
              [117.2359, -8.40081],
              [117.39, -8.47539],
              [117.4425, -8.40256],
              [117.4728, -8.41637],
              [117.5649, -8.40792],
              [117.6245, -8.44271],
              [117.6272, -8.5064],
            ],
          ],
          [
            [
              [116.3869, -8.95521],
              [116.3737, -8.90937],
              [116.3083, -8.9054],
              [116.2538, -8.91775],
              [116.1917, -8.91269],
              [116.1736, -8.86446],
              [116.0229, -8.90188],
              [115.9412, -8.83306],
              [115.833, -8.7992],
              [115.8193, -8.74502],
              [115.852, -8.71975],
              [115.913, -8.77189],
              [116.0066, -8.73022],
              [116.0682, -8.72393],
              [116.0982, -8.66515],
              [116.0939, -8.52486],
              [116.0652, -8.49738],
              [116.058, -8.44775],
              [116.0852, -8.40538],
              [116.1331, -8.39276],
              [116.2819, -8.25297],
              [116.37, -8.2136],
              [116.4473, -8.2233],
              [116.6033, -8.28462],
              [116.6502, -8.2903],
              [116.7153, -8.35162],
              [116.7078, -8.44609],
              [116.6622, -8.48923],
              [116.6654, -8.55788],
              [116.6227, -8.60767],
              [116.5379, -8.76436],
              [116.5104, -8.78135],
              [116.5681, -8.89245],
              [116.4771, -8.92124],
              [116.4524, -8.89981],
              [116.475, -8.82107],
              [116.4287, -8.82842],
              [116.3951, -8.86296],
              [116.4041, -8.94031],
              [116.3869, -8.95521],
            ],
          ],
          [
            [
              [117.5764, -8.1487],
              [117.6696, -8.15196],
              [117.6882, -8.17372],
              [117.6109, -8.23826],
              [117.5718, -8.33329],
              [117.5289, -8.39122],
              [117.4692, -8.35647],
              [117.509, -8.27402],
              [117.478, -8.25889],
              [117.4797, -8.19131],
              [117.5179, -8.16035],
              [117.5764, -8.1487],
            ],
          ],
          [
            [
              [119.0875, -8.12935],
              [119.1209, -8.16271],
              [119.1206, -8.22137],
              [119.0524, -8.26051],
              [119.0052, -8.23024],
              [119.0052, -8.17625],
              [119.0592, -8.12652],
              [119.0875, -8.12935],
            ],
          ],
        ],
      },
      id: 52,
      properties: {
        ID: 2,
        kode: 52,
        provinsi: "NUSA TENGGARA BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [122.188141, 1.045298],
            [122.226273, 1.00335],
            [122.320999, 1.010509],
            [122.375313, 0.997158],
            [122.4674, 1.025363],
            [122.494095, 0.990939],
            [122.589439, 0.954507],
            [122.653801, 0.949849],
            [122.690964, 0.895421],
            [122.718719, 0.895446],
            [122.847275, 0.816487],
            [122.925346, 0.861357],
            [122.950432, 0.910492],
            [122.948494, 0.965814],
            [122.989319, 0.968382],
            [123.028053, 0.933226],
            [123.088364, 0.911231],
            [123.117294, 0.92862],
            [123.1465, 0.881753],
            [123.240799, 0.83596],
            [123.257477, 0.749624],
            [123.368813, 0.661965],
            [123.494171, 0.636227],
            [123.527229, 0.57175],
            [123.51918, 0.449638],
            [123.465736, 0.330308],
            [123.416306, 0.313156],
            [123.343658, 0.309153],
            [123.269981, 0.325868],
            [123.199982, 0.396042],
            [123.165573, 0.404253],
            [123.122955, 0.465821],
            [123.071152, 0.510825],
            [123.000008, 0.484606],
            [122.895432, 0.484932],
            [122.836777, 0.495058],
            [122.712585, 0.478211],
            [122.548058, 0.493073],
            [122.535942, 0.507037],
            [122.423508, 0.502104],
            [122.406532, 0.518997],
            [122.280655, 0.475349],
            [122.228798, 0.486402],
            [122.177422, 0.471345],
            [122.138397, 0.491899],
            [122.056122, 0.479517],
            [121.949081, 0.445606],
            [121.876221, 0.44692],
            [121.814293, 0.414142],
            [121.717461, 0.521079],
            [121.572685, 0.536764],
            [121.534134, 0.550474],
            [121.528786, 0.49727],
            [121.45018, 0.468869],
            [121.419083, 0.484982],
            [121.345665, 0.474487],
            [121.35453, 0.571319],
            [121.247383, 0.597502],
            [121.168579, 0.690562],
            [121.225578, 0.708211],
            [121.260277, 0.78299],
            [121.294579, 0.82408],
            [121.386032, 0.870693],
            [121.499672, 0.850688],
            [121.620621, 0.883505],
            [121.673096, 0.914232],
            [121.754608, 0.926077],
            [121.831047, 0.963612],
            [121.882187, 0.9727],
            [121.925529, 0.946584],
            [121.968292, 0.894658],
            [121.993927, 0.94102],
            [122.02533, 0.949058],
            [122.067818, 0.997213],
            [122.188141, 1.045298],
          ],
          [
            [122.957306, 0.584448],
            [122.980988, 0.556596],
            [123.020927, 0.563377],
            [123.007317, 0.617577],
            [122.957306, 0.584448],
          ],
        ],
      },
      id: 75,
      properties: {
        ID: 3,
        kode: 75,
        provinsi: "GORONTALO",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [120.98423, -2.835341],
              [121.078339, -2.778087],
              [121.133423, -2.87806],
              [121.167259, -2.970928],
              [121.210396, -2.97805],
              [121.255768, -3.057803],
              [121.315308, -3.065957],
              [121.355957, -3.019798],
              [121.486954, -2.992209],
              [121.568336, -2.914573],
              [121.645721, -2.883784],
              [121.703339, -2.811771],
              [121.724182, -2.759546],
              [121.760185, -2.71899],
              [121.797012, -2.710249],
              [121.81871, -2.763949],
              [121.872299, -2.777285],
              [121.899376, -2.80432],
              [121.940231, -2.932159],
              [122.000359, -2.962439],
              [122.090057, -2.961801],
              [122.130539, -3.015782],
              [122.191582, -3.032609],
              [122.190437, -3.094346],
              [122.241173, -3.138603],
              [122.274086, -3.138374],
              [122.294449, -3.195179],
              [122.285965, -3.253934],
              [122.312798, -3.271106],
              [122.288254, -3.309927],
              [122.292755, -3.35732],
              [122.373749, -3.379456],
              [122.390915, -3.405149],
              [122.372299, -3.463288],
              [122.330208, -3.423481],
              [122.322395, -3.380808],
              [122.277771, -3.365802],
              [122.238159, -3.398722],
              [122.302132, -3.471626],
              [122.275734, -3.552534],
              [122.198738, -3.56528],
              [122.195618, -3.608036],
              [122.248512, -3.666231],
              [122.308617, -3.691788],
              [122.367409, -3.752801],
              [122.4011, -3.737035],
              [122.448067, -3.749501],
              [122.465042, -3.795845],
              [122.512268, -3.854226],
              [122.515129, -3.882586],
              [122.671906, -3.897003],
              [122.603531, -3.976277],
              [122.663445, -4.008508],
              [122.643234, -4.129524],
              [122.704361, -4.158368],
              [122.792816, -4.1576],
              [122.843758, -4.125524],
              [122.771515, -4.059357],
              [122.842255, -4.057042],
              [122.8918, -4.125212],
              [122.905563, -4.196556],
              [122.88662, -4.297779],
              [122.904427, -4.377195],
              [122.840179, -4.445022],
              [122.773346, -4.407986],
              [122.683952, -4.323638],
              [122.663979, -4.351196],
              [122.701942, -4.401843],
              [122.767426, -4.449976],
              [122.746147, -4.507518],
              [122.681007, -4.479528],
              [122.613434, -4.401861],
              [122.586288, -4.393665],
              [122.503342, -4.448484],
              [122.42131, -4.430861],
              [122.36808, -4.461316],
              [122.257019, -4.487848],
              [122.224892, -4.476355],
              [122.174736, -4.514592],
              [122.082832, -4.536929],
              [122.025444, -4.649319],
              [122.023575, -4.716242],
              [122.04731, -4.770176],
              [122.108398, -4.812253],
              [122.079865, -4.843765],
              [121.992233, -4.894716],
              [121.904724, -4.88616],
              [121.818916, -4.84867],
              [121.808197, -4.830569],
              [121.724449, -4.830998],
              [121.662598, -4.848654],
              [121.651039, -4.805225],
              [121.56263, -4.786319],
              [121.455299, -4.681352],
              [121.45945, -4.585207],
              [121.506104, -4.435465],
              [121.507233, -4.331302],
              [121.522499, -4.277308],
              [121.564728, -4.245612],
              [121.608521, -4.13802],
              [121.599144, -4.055925],
              [121.499374, -4.014913],
              [121.337173, -3.98036],
              [121.293785, -3.888254],
              [121.226234, -3.822368],
              [121.181694, -3.828741],
              [121.061172, -3.703674],
              [121.020912, -3.690099],
              [120.910744, -3.582204],
              [120.876328, -3.525793],
              [120.858788, -3.440268],
              [120.928894, -3.342],
              [120.95388, -3.329225],
              [120.966698, -3.26637],
              [121.016693, -3.244607],
              [121.051331, -3.184905],
              [121.056152, -3.070598],
              [121.084557, -2.923684],
              [121.071167, -2.89214],
              [120.98423, -2.835341],
            ],
          ],
          [
            [
              [122.97496, -5.080378],
              [122.974899, -5.114667],
              [122.942909, -5.160937],
              [122.962776, -5.195495],
              [123.032532, -5.13616],
              [123.085037, -5.172699],
              [123.151733, -5.246449],
              [123.176643, -5.245639],
              [123.21479, -5.304791],
              [123.135201, -5.395737],
              [123.014626, -5.44086],
              [122.972809, -5.394393],
              [122.921967, -5.43637],
              [122.888062, -5.441972],
              [122.846359, -5.485299],
              [122.897339, -5.518404],
              [122.897095, -5.56276],
              [122.815216, -5.65809],
              [122.797371, -5.695441],
              [122.744087, -5.637722],
              [122.661079, -5.689842],
              [122.623024, -5.679935],
              [122.578278, -5.571494],
              [122.563545, -5.480018],
              [122.647797, -5.425014],
              [122.617264, -5.403909],
              [122.646088, -5.356668],
              [122.651276, -5.326329],
              [122.682716, -5.320218],
              [122.732628, -5.241536],
              [122.793892, -5.241115],
              [122.806274, -5.200619],
              [122.737282, -5.170575],
              [122.788528, -5.106222],
              [122.80249, -5.037634],
              [122.768929, -5.008087],
              [122.811577, -4.978685],
              [122.832375, -4.890354],
              [122.807869, -4.866568],
              [122.858742, -4.783739],
              [122.831207, -4.679556],
              [122.850807, -4.590418],
              [122.910202, -4.460138],
              [123.040962, -4.370708],
              [123.080978, -4.45977],
              [123.136269, -4.483249],
              [123.199295, -4.605664],
              [123.21109, -4.722411],
              [123.201141, -4.780681],
              [123.171539, -4.834829],
              [123.149704, -4.735183],
              [123.103752, -4.713612],
              [123.038658, -4.800051],
              [122.993774, -4.828905],
              [123.001671, -4.93299],
              [122.969612, -4.950684],
              [122.955971, -5.000822],
              [122.97496, -5.080378],
            ],
          ],
          [
            [
              [122.311989, -5.189582],
              [122.322166, -5.108933],
              [122.382103, -5.084469],
              [122.377975, -4.944457],
              [122.353973, -4.920957],
              [122.321449, -4.834823],
              [122.374245, -4.743024],
              [122.451523, -4.74067],
              [122.536934, -4.704957],
              [122.596466, -4.641494],
              [122.668556, -4.609775],
              [122.730896, -4.638964],
              [122.721161, -4.689926],
              [122.747383, -4.792154],
              [122.727425, -4.832773],
              [122.762848, -4.887722],
              [122.735123, -4.955379],
              [122.679199, -5.035037],
              [122.637512, -5.059143],
              [122.58609, -5.182532],
              [122.637917, -5.2589],
              [122.640091, -5.352726],
              [122.599274, -5.35376],
              [122.592781, -5.388764],
              [122.545418, -5.438321],
              [122.511826, -5.402669],
              [122.539757, -5.326673],
              [122.524986, -5.288412],
              [122.481499, -5.295955],
              [122.495522, -5.34572],
              [122.463638, -5.400284],
              [122.363136, -5.385505],
              [122.275864, -5.388109],
              [122.268753, -5.306668],
              [122.315941, -5.233175],
              [122.311989, -5.189582],
            ],
          ],
          [
            [
              [121.805817, -5.245513],
              [121.808357, -5.201829],
              [121.843086, -5.139951],
              [121.859879, -5.074867],
              [121.930122, -5.102027],
              [121.94725, -5.05961],
              [121.986343, -5.092185],
              [121.992439, -5.15234],
              [122.026848, -5.14409],
              [122.060753, -5.18434],
              [122.051247, -5.260043],
              [122.043472, -5.455512],
              [122.029358, -5.46955],
              [121.944969, -5.474207],
              [121.945465, -5.446015],
              [121.875435, -5.380198],
              [121.802193, -5.27901],
              [121.805817, -5.245513],
            ],
          ],
          [
            [
              [123.003357, -3.999794],
              [123.03022, -3.981664],
              [123.086868, -4.022165],
              [123.144112, -4.010673],
              [123.215721, -4.022439],
              [123.254143, -4.066495],
              [123.254288, -4.114],
              [123.149765, -4.243471],
              [123.118874, -4.261611],
              [123.073792, -4.249185],
              [122.996155, -4.201651],
              [122.945335, -4.099027],
              [122.980415, -4.061724],
              [123.003357, -3.999794],
            ],
          ],
          [
            [
              [123.537064, -5.338479],
              [123.51709, -5.270007],
              [123.581436, -5.249413],
              [123.647369, -5.299086],
              [123.618355, -5.385718],
              [123.581528, -5.386153],
              [123.537064, -5.338479],
            ],
          ],
          [
            [
              [124.07579, -5.99996],
              [123.987404, -5.965688],
              [123.973602, -5.935432],
              [123.991692, -5.87584],
              [124.050156, -5.91096],
              [124.07579, -5.99996],
            ],
          ],
          [
            [
              [123.092873, -3.570833],
              [123.161133, -3.560991],
              [123.181412, -3.602412],
              [123.133232, -3.610474],
              [123.113304, -3.638883],
              [123.045197, -3.594425],
              [123.092873, -3.570833],
            ],
          ],
          [
            [
              [123.721954, -5.477765],
              [123.767891, -5.50372],
              [123.827209, -5.571645],
              [123.784508, -5.591027],
              [123.718681, -5.512402],
              [123.721954, -5.477765],
            ],
          ],
          [
            [
              [123.959496, -5.727983],
              [123.997734, -5.768229],
              [123.928597, -5.776584],
              [123.896194, -5.737903],
              [123.959496, -5.727983],
            ],
          ],
          [
            [
              [122.547577, -5.634616],
              [122.532173, -5.690142],
              [122.487648, -5.661558],
              [122.507607, -5.62051],
              [122.547577, -5.634616],
            ],
          ],
          [
            [
              [122.417923, -3.397853],
              [122.470146, -3.466125],
              [122.436958, -3.505473],
              [122.400879, -3.439657],
              [122.417923, -3.397853],
            ],
          ],
          [
            [
              [123.062531, -4.839228],
              [123.079178, -4.794402],
              [123.115738, -4.797104],
              [123.108261, -4.845974],
              [123.062531, -4.839228],
            ],
          ],
        ],
      },
      id: 74,
      properties: {
        ID: 4,
        kode: 74,
        provinsi: "SULAWESI TENGGARA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [110.011826, -7.886903],
            [110.042953, -7.89204],
            [110.06321, -7.813906],
            [110.132286, -7.741732],
            [110.142883, -7.645877],
            [110.25954, -7.645667],
            [110.254532, -7.683113],
            [110.379147, -7.595244],
            [110.444958, -7.536631],
            [110.498291, -7.745311],
            [110.54336, -7.798195],
            [110.588886, -7.804361],
            [110.657083, -7.785867],
            [110.723794, -7.791503],
            [110.750929, -7.82466],
            [110.786538, -7.818944],
            [110.771225, -7.899249],
            [110.758797, -8.030742],
            [110.790009, -8.1165],
            [110.788666, -8.154592],
            [110.836136, -8.202934],
            [110.677467, -8.182687],
            [110.584984, -8.139478],
            [110.438988, -8.095153],
            [110.37883, -8.066612],
            [110.345947, -8.028257],
            [110.217957, -7.985723],
            [110.116516, -7.927296],
            [110.011826, -7.886903],
          ],
        ],
      },
      id: 34,
      properties: {
        ID: 5,
        kode: 34,
        provinsi: "DAERAH ISTIMEWA YOGYAKARTA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [108.829338, -6.74608],
              [108.854889, -6.799195],
              [108.952652, -6.83733],
              [109.027512, -6.774646],
              [109.116945, -6.849453],
              [109.284729, -6.873732],
              [109.375954, -6.859314],
              [109.444908, -6.835716],
              [109.525772, -6.783483],
              [109.574196, -6.837207],
              [109.704632, -6.859836],
              [109.83173, -6.91085],
              [109.994609, -6.926026],
              [110.135114, -6.886767],
              [110.161217, -6.857075],
              [110.218449, -6.858777],
              [110.224055, -6.898671],
              [110.282545, -6.910134],
              [110.360636, -6.958464],
              [110.439422, -6.946518],
              [110.482428, -6.918728],
              [110.567362, -6.805168],
              [110.593362, -6.738227],
              [110.63764, -6.680221],
              [110.692026, -6.53139],
              [110.686522, -6.496921],
              [110.72816, -6.449049],
              [110.8402, -6.409402],
              [110.920682, -6.406552],
              [111.03451, -6.421138],
              [111.051265, -6.504015],
              [111.089495, -6.595203],
              [111.135153, -6.652081],
              [111.208681, -6.687917],
              [111.288116, -6.682676],
              [111.353966, -6.700903],
              [111.460175, -6.661293],
              [111.493095, -6.616364],
              [111.563789, -6.638492],
              [111.694595, -6.752857],
              [111.659874, -6.780993],
              [111.648499, -6.828923],
              [111.615326, -6.836943],
              [111.609039, -6.903624],
              [111.566604, -6.951681],
              [111.612236, -6.971057],
              [111.62486, -7.065532],
              [111.580716, -7.201196],
              [111.544593, -7.209885],
              [111.448722, -7.280662],
              [111.438232, -7.353508],
              [111.346387, -7.352231],
              [111.219641, -7.295056],
              [111.241771, -7.24923],
              [111.146592, -7.262771],
              [111.133153, -7.30824],
              [111.132803, -7.386832],
              [111.112659, -7.415796],
              [111.151654, -7.563807],
              [111.189209, -7.603958],
              [111.180164, -7.709611],
              [111.230736, -7.747669],
              [111.283073, -7.744789],
              [111.281219, -7.782755],
              [111.314003, -7.85079],
              [111.269707, -7.930492],
              [111.231346, -7.948041],
              [111.181503, -7.916514],
              [111.140442, -7.938492],
              [111.134033, -8.020032],
              [111.108658, -8.065952],
              [111.072105, -8.050748],
              [111.031685, -8.082599],
              [110.956131, -8.063713],
              [110.911171, -8.121149],
              [110.904457, -8.210409],
              [110.836136, -8.202934],
              [110.788666, -8.154592],
              [110.790009, -8.1165],
              [110.758797, -8.030742],
              [110.771225, -7.899249],
              [110.786538, -7.818944],
              [110.750929, -7.82466],
              [110.723794, -7.791503],
              [110.657083, -7.785867],
              [110.588886, -7.804361],
              [110.54336, -7.798195],
              [110.498291, -7.745311],
              [110.444958, -7.536631],
              [110.379147, -7.595244],
              [110.254532, -7.683113],
              [110.25954, -7.645667],
              [110.142883, -7.645877],
              [110.132286, -7.741732],
              [110.06321, -7.813906],
              [110.042953, -7.89204],
              [110.011826, -7.886903],
              [109.896675, -7.844425],
              [109.690193, -7.792683],
              [109.47419, -7.756908],
              [109.424683, -7.76845],
              [109.380403, -7.724499],
              [109.277812, -7.701472],
              [109.105467, -7.685618],
              [109.048995, -7.697629],
              [108.993577, -7.744561],
              [108.96375, -7.715322],
              [108.933997, -7.720566],
              [108.93102, -7.713349],
              [108.919786, -7.706645],
              [108.896909, -7.70961],
              [108.876058, -7.694295],
              [108.865476, -7.611036],
              [108.827862, -7.599123],
              [108.804252, -7.673145],
              [108.738433, -7.609161],
              [108.753132, -7.543514],
              [108.724345, -7.486524],
              [108.714968, -7.421927],
              [108.662295, -7.340506],
              [108.603483, -7.350607],
              [108.560766, -7.334588],
              [108.555715, -7.290434],
              [108.582017, -7.240565],
              [108.556373, -7.171165],
              [108.628929, -7.137631],
              [108.696854, -7.151166],
              [108.726479, -7.116722],
              [108.777687, -7.104835],
              [108.798622, -7.004968],
              [108.761101, -6.98307],
              [108.76516, -6.896383],
              [108.824615, -6.829293],
              [108.829338, -6.74608],
            ],
          ],
          [
            [
              [108.864219, -7.706541],
              [108.870832, -7.712705],
              [108.910178, -7.708335],
              [108.92574, -7.719276],
              [108.932456, -7.721225],
              [108.947685, -7.721218],
              [108.957728, -7.718627],
              [108.98867, -7.776379],
              [108.907681, -7.751549],
              [108.811508, -7.734937],
              [108.828885, -7.685307],
              [108.864219, -7.706541],
            ],
          ],
        ],
      },
      id: 33,
      properties: {
        ID: 6,
        kode: 33,
        provinsi: "JAWA TENGAH",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [106.721344, -6.089998],
              [106.692719, -6.095602],
              [106.688759, -6.174209],
              [106.718864, -6.185875],
              [106.775894, -6.316725],
              [106.767433, -6.361234],
              [106.599113, -6.361764],
              [106.532104, -6.333633],
              [106.500175, -6.356728],
              [106.466515, -6.313413],
              [106.432259, -6.359931],
              [106.45713, -6.419496],
              [106.404884, -6.453141],
              [106.401779, -6.529884],
              [106.431358, -6.583818],
              [106.429398, -6.695778],
              [106.511475, -6.765959],
              [106.43618, -6.818825],
              [106.427551, -6.865082],
              [106.390602, -6.90497],
              [106.396103, -6.979798],
              [106.379082, -6.995171],
              [106.263062, -6.972657],
              [106.236198, -6.931706],
              [106.145668, -6.902672],
              [106.093071, -6.874006],
              [106.060333, -6.833915],
              [105.988388, -6.814358],
              [105.913567, -6.815527],
              [105.775536, -6.849614],
              [105.684792, -6.836181],
              [105.604584, -6.845806],
              [105.546936, -6.867788],
              [105.476051, -6.862449],
              [105.372208, -6.813282],
              [105.300941, -6.801612],
              [105.269058, -6.843428],
              [105.241913, -6.822674],
              [105.218208, -6.747766],
              [105.263069, -6.761764],
              [105.374222, -6.655813],
              [105.392738, -6.691132],
              [105.38649, -6.738562],
              [105.467102, -6.827007],
              [105.509209, -6.757093],
              [105.505432, -6.729187],
              [105.595924, -6.650365],
              [105.625389, -6.585471],
              [105.615372, -6.561943],
              [105.648323, -6.488072],
              [105.713791, -6.53336],
              [105.771484, -6.516271],
              [105.813004, -6.468743],
              [105.825912, -6.429081],
              [105.818306, -6.370665],
              [105.825676, -6.252214],
              [105.883545, -6.074547],
              [105.976501, -5.999971],
              [106.021919, -5.888695],
              [106.074554, -5.885445],
              [106.113579, -5.930358],
              [106.099228, -5.986111],
              [106.165306, -6.02962],
              [106.222588, -6.015579],
              [106.245636, -5.961533],
              [106.292465, -5.950864],
              [106.388206, -5.992125],
              [106.396767, -6.018975],
              [106.472466, -6.052454],
              [106.534706, -6.012048],
              [106.570259, -6.035616],
              [106.634544, -6.014261],
              [106.684662, -6.016144],
              [106.721344, -6.089998],
            ],
          ],
          [
            [
              [105.246979, -6.565058],
              [105.242393, -6.63545],
              [105.204712, -6.650276],
              [105.167686, -6.576644],
              [105.183006, -6.542505],
              [105.250877, -6.532654],
              [105.246979, -6.565058],
            ],
          ],
        ],
      },
      id: 36,
      properties: {
        ID: 7,
        kode: 36,
        provinsi: "BANTEN",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [111.694595, -6.752857],
              [111.832825, -6.799014],
              [111.939568, -6.764695],
              [111.972176, -6.765804],
              [112.027229, -6.859045],
              [112.060112, -6.890543],
              [112.16993, -6.89966],
              [112.23793, -6.871494],
              [112.411819, -6.865529],
              [112.5198, -6.905662],
              [112.544864, -6.848775],
              [112.602792, -6.89387],
              [112.608869, -6.982774],
              [112.652966, -7.041649],
              [112.625006, -7.126014],
              [112.66918, -7.166654],
              [112.674713, -7.225679],
              [112.727264, -7.199742],
              [112.782669, -7.214118],
              [112.836922, -7.30876],
              [112.826752, -7.347414],
              [112.830528, -7.46781],
              [112.816696, -7.488018],
              [112.857704, -7.548725],
              [112.843674, -7.586721],
              [112.901512, -7.62622],
              [112.994942, -7.657773],
              [113.048615, -7.659442],
              [113.110321, -7.72505],
              [113.154587, -7.746615],
              [113.212761, -7.73906],
              [113.280533, -7.786507],
              [113.337135, -7.77614],
              [113.481895, -7.698964],
              [113.575294, -7.711989],
              [113.667999, -7.736984],
              [113.706665, -7.709392],
              [113.784576, -7.733948],
              [113.838509, -7.684821],
              [113.931564, -7.699339],
              [114.0299, -7.606591],
              [114.065537, -7.637639],
              [114.095688, -7.699542],
              [114.137779, -7.71711],
              [114.208633, -7.719072],
              [114.239769, -7.700929],
              [114.286819, -7.74787],
              [114.368515, -7.751497],
              [114.449234, -7.804945],
              [114.460304, -7.88781],
              [114.41713, -7.920804],
              [114.42569, -8.064825],
              [114.395546, -8.121264],
              [114.337181, -8.422754],
              [114.372826, -8.53333],
              [114.443161, -8.637075],
              [114.467758, -8.61793],
              [114.513489, -8.648381],
              [114.569321, -8.661139],
              [114.602242, -8.715033],
              [114.591324, -8.750443],
              [114.530891, -8.780732],
              [114.416534, -8.748014],
              [114.349121, -8.744769],
              [114.375259, -8.698574],
              [114.361153, -8.65963],
              [114.317375, -8.624228],
              [114.225525, -8.602414],
              [114.216881, -8.643929],
              [114.090469, -8.615832],
              [114.045151, -8.639547],
              [114.021385, -8.595541],
              [113.970848, -8.609504],
              [113.942947, -8.56012],
              [113.905838, -8.579295],
              [113.8125, -8.546223],
              [113.79007, -8.488746],
              [113.73201, -8.526714],
              [113.646294, -8.494339],
              [113.61882, -8.442991],
              [113.524757, -8.430819],
              [113.425812, -8.380055],
              [113.387894, -8.398775],
              [113.364845, -8.353276],
              [113.284279, -8.295891],
              [113.243156, -8.284298],
              [113.072037, -8.284934],
              [112.972435, -8.326396],
              [112.937477, -8.383437],
              [112.875587, -8.409164],
              [112.781456, -8.387782],
              [112.74437, -8.419105],
              [112.670242, -8.446231],
              [112.552414, -8.401976],
              [112.44194, -8.398211],
              [112.37439, -8.376492],
              [112.329979, -8.334126],
              [112.265106, -8.349245],
              [112.142982, -8.318054],
              [112.031502, -8.319978],
              [111.969475, -8.282909],
              [111.897675, -8.301271],
              [111.776794, -8.257344],
              [111.769699, -8.290105],
              [111.710297, -8.294887],
              [111.710007, -8.325211],
              [111.672142, -8.373858],
              [111.625053, -8.325221],
              [111.513535, -8.335917],
              [111.41066, -8.279475],
              [111.254616, -8.248837],
              [111.188499, -8.278602],
              [111.118698, -8.254065],
              [111.023735, -8.252783],
              [110.904457, -8.210409],
              [110.911171, -8.121149],
              [110.956131, -8.063713],
              [111.031685, -8.082599],
              [111.072105, -8.050748],
              [111.108658, -8.065952],
              [111.134033, -8.020032],
              [111.140442, -7.938492],
              [111.181503, -7.916514],
              [111.231346, -7.948041],
              [111.269707, -7.930492],
              [111.314003, -7.85079],
              [111.281219, -7.782755],
              [111.283073, -7.744789],
              [111.230736, -7.747669],
              [111.180164, -7.709611],
              [111.189209, -7.603958],
              [111.151654, -7.563807],
              [111.112659, -7.415796],
              [111.132803, -7.386832],
              [111.133153, -7.30824],
              [111.146592, -7.262771],
              [111.241771, -7.24923],
              [111.219641, -7.295056],
              [111.346387, -7.352231],
              [111.438232, -7.353508],
              [111.448722, -7.280662],
              [111.544593, -7.209885],
              [111.580716, -7.201196],
              [111.62486, -7.065532],
              [111.612236, -6.971057],
              [111.566604, -6.951681],
              [111.609039, -6.903624],
              [111.615326, -6.836943],
              [111.648499, -6.828923],
              [111.659874, -6.780993],
              [111.694595, -6.752857],
            ],
          ],
          [
            [
              [113.638163, -6.887474],
              [113.797623, -6.884495],
              [113.912071, -6.864436],
              [113.992722, -6.884586],
              [114.086349, -6.927759],
              [114.121918, -6.980549],
              [114.035805, -7.008666],
              [113.985703, -7.011945],
              [113.941284, -7.057282],
              [113.880783, -7.07095],
              [113.883873, -7.135548],
              [113.678551, -7.110577],
              [113.604645, -7.127305],
              [113.573105, -7.163429],
              [113.551178, -7.2346],
              [113.328033, -7.214845],
              [113.092392, -7.229101],
              [112.962181, -7.200501],
              [112.866043, -7.164714],
              [112.801178, -7.157979],
              [112.721176, -7.174918],
              [112.690369, -7.151152],
              [112.708206, -7.102842],
              [112.673004, -7.075121],
              [112.683548, -7.031513],
              [112.725105, -7.040094],
              [112.787674, -6.985271],
              [112.845161, -6.898797],
              [113.042206, -6.880765],
              [113.118645, -6.894146],
              [113.42231, -6.88627],
              [113.499718, -6.897233],
              [113.638163, -6.887474],
            ],
          ],
          [
            [
              [115.499336, -6.946886],
              [115.4478, -6.919424],
              [115.38356, -6.911211],
              [115.390144, -6.98852],
              [115.320747, -6.993716],
              [115.193825, -6.931066],
              [115.233414, -6.885417],
              [115.251526, -6.826602],
              [115.394707, -6.834252],
              [115.439651, -6.846564],
              [115.553787, -6.90412],
              [115.534569, -6.96106],
              [115.499336, -6.946886],
            ],
          ],
          [
            [
              [112.67501, -5.859471],
              [112.564216, -5.833381],
              [112.578552, -5.779873],
              [112.671714, -5.72369],
              [112.71614, -5.742655],
              [112.731986, -5.793182],
              [112.722518, -5.834838],
              [112.67501, -5.859471],
            ],
          ],
          [
            [
              [114.28257, -7.073864],
              [114.325409, -7.053657],
              [114.362137, -7.081872],
              [114.404289, -7.172804],
              [114.383644, -7.186969],
              [114.3144, -7.167445],
              [114.267868, -7.098571],
              [114.28257, -7.073864],
            ],
          ],
          [
            [
              [115.899406, -7.107687],
              [115.891769, -7.186985],
              [115.832756, -7.205947],
              [115.736443, -7.153445],
              [115.778282, -7.109709],
              [115.804092, -7.15064],
              [115.843468, -7.16076],
              [115.899406, -7.107687],
            ],
          ],
          [
            [
              [113.271072, -8.464405],
              [113.306946, -8.450875],
              [113.400581, -8.458902],
              [113.399284, -8.49789],
              [113.30629, -8.509363],
              [113.271072, -8.464405],
            ],
          ],
          [
            [
              [114.48246, -7.141308],
              [114.538559, -7.120292],
              [114.604576, -7.134747],
              [114.60331, -7.171029],
              [114.48246, -7.141308],
            ],
          ],
        ],
      },
      id: 35,
      properties: {
        ID: 8,
        kode: 35,
        provinsi: "JAWA TIMUR",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [127.742072, 0.816295],
              [127.7974, 0.7996],
              [127.8397, 0.80633],
              [127.932, 0.88722],
              [127.9239, 0.95794],
              [127.98, 1.08488],
              [128.0237, 1.11131],
              [128.0883, 1.12649],
              [128.1659, 1.12245],
              [128.2007, 1.19261],
              [128.18, 1.23451],
              [128.1092, 1.23794],
              [128.0916, 1.26956],
              [128.1347, 1.30145],
              [128.1604, 1.36163],
              [128.2424, 1.41862],
              [128.3401, 1.45979],
              [128.3597, 1.49011],
              [128.4626, 1.54464],
              [128.5052, 1.52351],
              [128.5524, 1.56312],
              [128.6649, 1.58865],
              [128.7197, 1.57194],
              [128.6797, 1.48842],
              [128.6905, 1.44729],
              [128.7364, 1.3984],
              [128.7418, 1.33011],
              [128.7071, 1.29313],
              [128.7158, 1.25066],
              [128.6878, 1.19439],
              [128.6842, 1.07075],
              [128.5998, 1.04118],
              [128.5361, 0.97025],
              [128.5073, 0.969],
              [128.3849, 0.91071],
              [128.3338, 0.91042],
              [128.2815, 0.86741],
              [128.3166, 0.81788],
              [128.2052, 0.80334],
              [128.2201, 0.756],
              [128.2597, 0.73909],
              [128.3137, 0.6577],
              [128.4445, 0.62671],
              [128.5697, 0.56647],
              [128.6909, 0.54882],
              [128.6694, 0.49282],
              [128.6897, 0.46074],
              [128.6767, 0.33845],
              [128.7976, 0.31372],
              [128.8473, 0.26065],
              [128.6011, 0.31807],
              [128.5584, 0.31668],
              [128.4994, 0.35481],
              [128.4753, 0.39434],
              [128.3869, 0.40178],
              [128.3124, 0.39049],
              [128.2183, 0.4098],
              [128.1369, 0.46332],
              [128.1165, 0.45372],
              [128.0398, 0.47984],
              [127.9746, 0.4816],
              [127.9154, 0.45615],
              [127.9102, 0.39127],
              [127.8716, 0.30896],
              [127.9191, 0.27721],
              [127.9243, 0.13099],
              [127.8861, 0.07639],
              [127.8873, 0.00948],
              [127.9483, -0.11003],
              [127.9867, -0.26911],
              [128.0997, -0.50944],
              [128.1851, -0.62383],
              [128.2195, -0.70072],
              [128.3036, -0.76573],
              [128.3741, -0.84649],
              [128.3489, -0.88716],
              [128.29, -0.87902],
              [128.2325, -0.8483],
              [128.2714, -0.82066],
              [128.239, -0.77439],
              [128.063, -0.7163],
              [128.0045, -0.66521],
              [127.936, -0.49685],
              [127.8621, -0.36417],
              [127.7496, -0.31774],
              [127.6863, -0.26548],
              [127.6595, -0.21024],
              [127.6996, -0.08177],
              [127.6984, 0.01083],
              [127.7194, 0.06459],
              [127.6883, 0.10672],
              [127.6981, 0.19853],
              [127.7323, 0.31467],
              [127.7144, 0.3493],
              [127.619, 0.36049],
              [127.5751, 0.41658],
              [127.5623, 0.5117],
              [127.5249, 0.55191],
              [127.549, 0.67995],
              [127.5449, 0.72851],
              [127.6029, 0.76229],
              [127.6378, 0.83297],
              [127.5627, 0.8698],
              [127.5083, 0.85684],
              [127.4906, 0.92754],
              [127.51, 0.95334],
              [127.4721, 1.059],
              [127.4192, 1.02931],
              [127.3987, 1.0772],
              [127.4301, 1.14734],
              [127.3989, 1.18898],
              [127.4067, 1.22822],
              [127.5177, 1.42418],
              [127.5333, 1.48478],
              [127.5242, 1.57819],
              [127.5751, 1.68532],
              [127.5565, 1.70354],
              [127.5795, 1.76204],
              [127.607, 1.77525],
              [127.7001, 1.93801],
              [127.7764, 1.99706],
              [127.8375, 2.09089],
              [127.9303, 2.16371],
              [128.0521, 2.20415],
              [128.0675, 2.17477],
              [128.0163, 2.09971],
              [127.9575, 2.04664],
              [127.9438, 1.98637],
              [127.8478, 1.92255],
              [127.8422, 1.81305],
              [127.8788, 1.79133],
              [127.9263, 1.80236],
              [127.9917, 1.76257],
              [128.0203, 1.70558],
              [127.9918, 1.66442],
              [127.9915, 1.61054],
              [128.0335, 1.58746],
              [128.0265, 1.47197],
              [127.9907, 1.36575],
              [127.9981, 1.3337],
              [127.9776, 1.27595],
              [127.9317, 1.236],
              [127.8934, 1.14881],
              [127.8325, 1.14733],
              [127.7644, 1.06888],
              [127.6534, 1.0226],
              [127.6247, 0.96958],
              [127.6535, 0.90266],
              [127.697, 0.87726],
              [127.742072, 0.816295],
            ],
          ],
          [
            [
              [124.936874, -1.929927],
              [124.889656, -1.92754],
              [124.865112, -1.893923],
              [124.77874, -1.916949],
              [124.669197, -1.977551],
              [124.590477, -2.003751],
              [124.534431, -2.007188],
              [124.449631, -2.030549],
              [124.398903, -2.024912],
              [124.384331, -1.94311],
              [124.339363, -1.883676],
              [124.344444, -1.811057],
              [124.375023, -1.733304],
              [124.363998, -1.71271],
              [124.398499, -1.661184],
              [124.473778, -1.65911],
              [124.52462, -1.634892],
              [124.636864, -1.644307],
              [124.798882, -1.686176],
              [124.869881, -1.68325],
              [124.897141, -1.711954],
              [124.955513, -1.699806],
              [125.076996, -1.762628],
              [125.131844, -1.686383],
              [125.202957, -1.727396],
              [125.292274, -1.733136],
              [125.32077, -1.784913],
              [125.311661, -1.895589],
              [125.233017, -1.87573],
              [125.167656, -1.875936],
              [125.108589, -1.898453],
              [125.059608, -1.88656],
              [125.020279, -1.930932],
              [124.936874, -1.929927],
            ],
          ],
          [
            [
              [127.5001, -1.72513],
              [127.4048, -1.66221],
              [127.3915, -1.61568],
              [127.41, -1.56593],
              [127.4126, -1.48042],
              [127.4573, -1.4385],
              [127.5097, -1.41778],
              [127.5734, -1.36802],
              [127.71, -1.33658],
              [127.7904, -1.37072],
              [127.7995, -1.41196],
              [127.8465, -1.43784],
              [127.8983, -1.43163],
              [127.9399, -1.45149],
              [128.0786, -1.57834],
              [128.1245, -1.56462],
              [128.1673, -1.6148],
              [128.159, -1.67794],
              [128.0989, -1.71322],
              [128.0372, -1.71459],
              [127.885, -1.68033],
              [127.8162, -1.69945],
              [127.7037, -1.6869],
              [127.6446, -1.72921],
              [127.5001, -1.72513],
            ],
          ],
          [
            [
              [128.2792, 2.00001],
              [128.3096, 2.08133],
              [128.2571, 2.12537],
              [128.2514, 2.25059],
              [128.2244, 2.30658],
              [128.2787, 2.35976],
              [128.2987, 2.44234],
              [128.3619, 2.50778],
              [128.4117, 2.53086],
              [128.459, 2.59769],
              [128.5255, 2.57971],
              [128.5646, 2.64851],
              [128.6355, 2.54578],
              [128.6942, 2.48003],
              [128.6958, 2.42752],
              [128.6547, 2.3753],
              [128.6571, 2.31508],
              [128.6307, 2.21973],
              [128.5306, 2.07179],
              [128.4704, 2.05684],
              [128.3987, 2.05641],
              [128.3047, 2.03752],
              [128.2792, 2.00001],
            ],
          ],
          [
            [
              [127.3592, -0.57986],
              [127.285, -0.46953],
              [127.3553, -0.32239],
              [127.4094, -0.35825],
              [127.4514, -0.41708],
              [127.481, -0.3414],
              [127.5376, -0.31027],
              [127.6123, -0.36417],
              [127.6887, -0.46297],
              [127.6677, -0.51201],
              [127.6037, -0.57387],
              [127.5993, -0.61639],
              [127.6448, -0.6237],
              [127.6496, -0.67974],
              [127.6861, -0.70913],
              [127.7163, -0.68805],
              [127.8006, -0.67786],
              [127.8704, -0.72379],
              [127.906, -0.77903],
              [127.8678, -0.82488],
              [127.7942, -0.85696],
              [127.693, -0.84385],
              [127.6567, -0.78787],
              [127.6537, -0.74391],
              [127.5675, -0.76966],
              [127.4728, -0.81791],
              [127.438, -0.74074],
              [127.4752, -0.65588],
              [127.4518, -0.62858],
              [127.3592, -0.57986],
            ],
          ],
          [
            [
              [125.9997, -1.91651],
              [125.9263, -1.94223],
              [125.8447, -1.89649],
              [125.7902, -1.9299],
              [125.5886, -1.93069],
              [125.5354, -1.94847],
              [125.4509, -1.94292],
              [125.4385, -1.89255],
              [125.3303, -1.83265],
              [125.372, -1.78057],
              [125.4305, -1.81122],
              [125.4809, -1.78226],
              [125.4913, -1.82035],
              [125.5512, -1.80585],
              [125.7029, -1.83132],
              [125.7522, -1.80754],
              [125.8765, -1.81093],
              [125.9168, -1.79541],
              [126.1406, -1.81564],
              [126.2095, -1.80953],
              [126.2828, -1.8179],
              [126.3354, -1.84281],
              [126.2614, -1.87942],
              [126.2178, -1.86881],
              [126.1545, -1.89238],
              [126.1065, -1.88032],
              [125.9997, -1.91651],
            ],
          ],
          [
            [
              [126, -2.44711],
              [125.9594, -2.37442],
              [125.9575, -2.32236],
              [125.8816, -2.21248],
              [125.8878, -2.17258],
              [125.8583, -2.08804],
              [125.8753, -2.02554],
              [125.9136, -1.9759],
              [125.9811, -2.01085],
              [125.9938, -2.05085],
              [125.9613, -2.12136],
              [125.9634, -2.18431],
              [126.0052, -2.26574],
              [126.0692, -2.41961],
              [126.0422, -2.47304],
              [126, -2.44711],
            ],
          ],
          [
            [
              [127.2619, -0.41957],
              [127.2517, -0.49356],
              [127.214, -0.51609],
              [127.1446, -0.52742],
              [127.1193, -0.51607],
              [127.1134, -0.37269],
              [127.1347, -0.32419],
              [127.1131, -0.29016],
              [127.1443, -0.2604],
              [127.2358, -0.24834],
              [127.2657, -0.28156],
              [127.2481, -0.31237],
              [127.2834, -0.37313],
              [127.2619, -0.41957],
            ],
          ],
          [
            [
              [127.1612, -0.72234],
              [127.2087, -0.64521],
              [127.2975, -0.68594],
              [127.2881, -0.72649],
              [127.3295, -0.78217],
              [127.2906, -0.79626],
              [127.2356, -0.7631],
              [127.191, -0.77644],
              [127.1612, -0.72234],
            ],
          ],
          [
            [
              [127.4999, -1.27043],
              [127.4654, -1.23999],
              [127.5378, -1.17793],
              [127.5999, -1.20978],
              [127.6935, -1.22769],
              [127.6721, -1.29242],
              [127.5595, -1.24815],
              [127.4999, -1.27043],
            ],
          ],
          [
            [
              [129.463684, -0.090001],
              [129.536438, -0.137458],
              [129.562119, -0.181339],
              [129.510452, -0.205838],
              [129.455719, -0.108978],
              [129.375412, -0.064561],
              [129.398895, -0.025581],
              [129.463684, -0.090001],
            ],
          ],
          [
            [
              [127.3835, 0.72289],
              [127.404, 0.75954],
              [127.4478, 0.74363],
              [127.4573, 0.67694],
              [127.4277, 0.63181],
              [127.3691, 0.64163],
              [127.3616, 0.67888],
              [127.3835, 0.72289],
            ],
          ],
          [
            [
              [127.2924, 0.82257],
              [127.3168, 0.86424],
              [127.3848, 0.83086],
              [127.3733, 0.7637],
              [127.3044, 0.76429],
              [127.2924, 0.82257],
            ],
          ],
          [
            [
              [127.3804, 0.28067],
              [127.3442, 0.33348],
              [127.4175, 0.37392],
              [127.4427, 0.33914],
              [127.4215, 0.28311],
              [127.3804, 0.28067],
            ],
          ],
          [
            [
              [127.4613, 0.00001],
              [127.4331, -0.00584],
              [127.4134, 0.05743],
              [127.4404, 0.10221],
              [127.4705, 0.03449],
              [127.4613, 0.00001],
            ],
          ],
          [
            [
              [127.3164, -1.43808],
              [127.2912, -1.40862],
              [127.347, -1.3666],
              [127.3989, -1.40281],
              [127.3713, -1.428],
              [127.3164, -1.43808],
            ],
          ],
          [
            [
              [128.1611, 2.41114],
              [128.1882, 2.36684],
              [128.184, 2.29051],
              [128.129, 2.32644],
              [128.1611, 2.41114],
            ],
          ],
          [
            [
              [128.350814, -1.033596],
              [128.3414, -0.97438],
              [128.4029, -0.99246],
              [128.4037, -1.03638],
              [128.350814, -1.033596],
            ],
          ],
          [
            [
              [128.4984, -0.56781],
              [128.5245, -0.58984],
              [128.5987, -0.61046],
              [128.5917, -0.64074],
              [128.5155, -0.62451],
              [128.4984, -0.56781],
            ],
          ],
          [
            [
              [128.3113, -0.54382],
              [128.3684, -0.51991],
              [128.4003, -0.57154],
              [128.3113, -0.54382],
            ],
          ],
          [
            [
              [127.3309, -0.62605],
              [127.3769, -0.6072],
              [127.4108, -0.633],
              [127.359, -0.6629],
              [127.3309, -0.62605],
            ],
          ],
          [
            [
              [124.303452, -2.000366],
              [124.313477, -1.971169],
              [124.366676, -1.967357],
              [124.365074, -2.013639],
              [124.328445, -2.02773],
              [124.303452, -2.000366],
            ],
          ],
          [
            [
              [126.375684, 1.346717],
              [126.43995, 1.344847],
              [126.412223, 1.282993],
              [126.375684, 1.346717],
            ],
          ],
        ],
      },
      id: 82,
      properties: {
        ID: 9,
        kode: 82,
        provinsi: "MALUKU UTARA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [130.8313, -3.47141],
              [130.8059, -3.49896],
              [130.8796, -3.58872],
              [130.838, -3.65112],
              [130.8219, -3.70138],
              [130.8327, -3.78794],
              [130.8279, -3.87666],
              [130.7655, -3.83031],
              [130.6133, -3.7912],
              [130.5704, -3.72628],
              [130.4664, -3.69326],
              [130.4058, -3.6243],
              [130.3481, -3.61665],
              [130.2904, -3.58056],
              [130.1187, -3.52129],
              [130.1092, -3.50424],
              [130.0123, -3.47822],
              [129.9645, -3.41722],
              [129.9632, -3.37067],
              [129.9239, -3.33397],
              [129.8779, -3.33584],
              [129.7948, -3.31658],
              [129.6776, -3.31819],
              [129.5451, -3.30253],
              [129.4952, -3.30992],
              [129.5639, -3.40784],
              [129.532, -3.466],
              [129.4135, -3.41433],
              [129.2791, -3.40822],
              [129.1756, -3.37997],
              [129.0764, -3.33637],
              [128.9589, -3.35402],
              [128.918, -3.3311],
              [128.9624, -3.2814],
              [128.9612, -3.22166],
              [128.8912, -3.19893],
              [128.8309, -3.24359],
              [128.7788, -3.25702],
              [128.6635, -3.37588],
              [128.6643, -3.43326],
              [128.5858, -3.42633],
              [128.5119, -3.45503],
              [128.4506, -3.45653],
              [128.3948, -3.42432],
              [128.3877, -3.39445],
              [128.3251, -3.32516],
              [128.2827, -3.22196],
              [128.1976, -3.20564],
              [128.1589, -3.16823],
              [128.1945, -3.12455],
              [128.1891, -3.06464],
              [128.1415, -3.06945],
              [128.0849, -3.12556],
              [128.0515, -3.25021],
              [128.0454, -3.33848],
              [128.0058, -3.37754],
              [127.9723, -3.37984],
              [127.9351, -3.481],
              [127.946, -3.52314],
              [127.9101, -3.53896],
              [127.8864, -3.48258],
              [127.9325, -3.36832],
              [127.9104, -3.28972],
              [127.8799, -3.2655],
              [127.866, -3.18653],
              [127.8952, -3.15067],
              [127.9702, -3.09849],
              [127.9926, -3.06595],
              [128.0965, -3.06632],
              [128.0854, -3.01254],
              [128.1169, -2.9968],
              [128.1079, -2.95342],
              [128.1604, -2.8631],
              [128.2347, -2.84965],
              [128.271, -2.86299],
              [128.3525, -2.85581],
              [128.3975, -2.86835],
              [128.4305, -2.84402],
              [128.5049, -2.8312],
              [128.5428, -2.84749],
              [128.6275, -2.85114],
              [128.6526, -2.8384],
              [128.71, -2.85998],
              [128.7457, -2.84936],
              [128.797, -2.86403],
              [128.9475, -2.83844],
              [129.0271, -2.79063],
              [129.0634, -2.8102],
              [129.0813, -2.93207],
              [129.1264, -2.96181],
              [129.1735, -2.92563],
              [129.213, -2.92231],
              [129.3442, -2.85179],
              [129.3758, -2.78267],
              [129.4677, -2.77901],
              [129.6358, -2.82154],
              [129.6626, -2.81661],
              [129.7802, -2.86243],
              [129.7981, -2.90508],
              [129.8424, -2.88833],
              [129.8639, -2.92376],
              [130.0093, -2.99152],
              [130.0619, -3.00004],
              [130.1593, -2.98459],
              [130.2095, -3.00005],
              [130.2655, -2.96975],
              [130.34, -2.97073],
              [130.4287, -3.02831],
              [130.4896, -3.10319],
              [130.521, -3.1028],
              [130.5932, -3.15459],
              [130.6337, -3.29172],
              [130.6252, -3.31561],
              [130.6609, -3.40861],
              [130.8015, -3.41255],
              [130.8313, -3.47141],
            ],
          ],
          [
            [
              [126.0006, -3.3093],
              [126.0156, -3.18204],
              [126.1009, -3.12067],
              [126.1275, -3.16512],
              [126.2217, -3.18936],
              [126.2245, -3.14467],
              [126.2956, -3.09941],
              [126.3414, -3.10657],
              [126.4018, -3.08571],
              [126.4644, -3.08945],
              [126.5983, -3.06836],
              [126.6736, -3.07402],
              [126.7065, -3.05979],
              [126.7883, -3.06155],
              [126.8791, -3.10877],
              [126.9244, -3.14334],
              [126.9815, -3.14039],
              [127.0466, -3.17702],
              [127.1038, -3.22728],
              [127.076, -3.26191],
              [127.0297, -3.26615],
              [127.0424, -3.33172],
              [127.0728, -3.37474],
              [127.1212, -3.38484],
              [127.159, -3.33658],
              [127.1807, -3.35828],
              [127.2546, -3.37528],
              [127.2462, -3.45383],
              [127.2481, -3.59206],
              [127.2178, -3.66125],
              [127.1869, -3.67576],
              [127.1262, -3.65913],
              [127.045, -3.68912],
              [126.9586, -3.75261],
              [126.8914, -3.78843],
              [126.8629, -3.78245],
              [126.7496, -3.84348],
              [126.6818, -3.85857],
              [126.6689, -3.84196],
              [126.5525, -3.79009],
              [126.5235, -3.79459],
              [126.2828, -3.66723],
              [126.2323, -3.62291],
              [126.198, -3.62769],
              [126.163, -3.58489],
              [126.1605, -3.54538],
              [126.0465, -3.44963],
              [126.0398, -3.40619],
              [126.0059, -3.36454],
              [126.0006, -3.3093],
            ],
          ],
          [
            [
              [131.148111, -7.733321],
              [131.107111, -7.701931],
              [131.164311, -7.667571],
              [131.184811, -7.589211],
              [131.222611, -7.528451],
              [131.233511, -7.473591],
              [131.309711, -7.418691],
              [131.340311, -7.442291],
              [131.365311, -7.366271],
              [131.436911, -7.321361],
              [131.475911, -7.229681],
              [131.529611, -7.228881],
              [131.517611, -7.158241],
              [131.582211, -7.120791],
              [131.646611, -7.112811],
              [131.650311, -7.174691],
              [131.716911, -7.159711],
              [131.738411, -7.219041],
              [131.652611, -7.225321],
              [131.632611, -7.247311],
              [131.637311, -7.304361],
              [131.675411, -7.359271],
              [131.657511, -7.548331],
              [131.621311, -7.645961],
              [131.583311, -7.658131],
              [131.553011, -7.719511],
              [131.483211, -7.727291],
              [131.480311, -7.774321],
              [131.374111, -7.855401],
              [131.333411, -7.936211],
              [131.341811, -7.985141],
              [131.301711, -8.016321],
              [131.271711, -7.956001],
              [131.230311, -8.002691],
              [131.188511, -7.987851],
              [131.105011, -7.990961],
              [131.122011, -7.905691],
              [131.086611, -7.879891],
              [131.086911, -7.837771],
              [131.146711, -7.799841],
              [131.112411, -7.777601],
              [131.148111, -7.733321],
            ],
          ],
          [
            [
              [125.8047, -8.00014],
              [125.8214, -7.90089],
              [125.8037, -7.85616],
              [125.8663, -7.81319],
              [125.8594, -7.76665],
              [125.8904, -7.75561],
              [125.9467, -7.66017],
              [125.9843, -7.65647],
              [126.0316, -7.69334],
              [126.1872, -7.72471],
              [126.2498, -7.68395],
              [126.3278, -7.69185],
              [126.3889, -7.63476],
              [126.4243, -7.63154],
              [126.4899, -7.58823],
              [126.545, -7.56934],
              [126.6433, -7.56392],
              [126.645, -7.60431],
              [126.692, -7.6219],
              [126.7264, -7.66638],
              [126.8208, -7.66033],
              [126.8458, -7.73482],
              [126.8188, -7.75456],
              [126.7227, -7.74454],
              [126.5973, -7.80845],
              [126.5588, -7.81877],
              [126.5236, -7.86325],
              [126.4953, -7.94762],
              [126.4649, -7.97483],
              [126.4293, -7.93509],
              [126.3682, -7.93536],
              [126.3332, -7.91575],
              [126.177, -7.92564],
              [126.1508, -7.90081],
              [126.061, -7.89072],
              [125.9438, -7.9134],
              [125.8653, -7.9728],
              [125.8047, -8.00014],
            ],
          ],
          [
            [
              [134.4336, -6.68109],
              [134.3658, -6.78505],
              [134.3282, -6.86583],
              [134.2755, -6.88061],
              [134.2023, -6.92197],
              [134.1704, -6.9112],
              [134.1372, -6.8557],
              [134.0711, -6.83181],
              [134.0503, -6.77574],
              [134.0766, -6.71568],
              [134.0907, -6.63462],
              [134.1005, -6.48848],
              [134.1407, -6.46422],
              [134.117, -6.41609],
              [134.134, -6.34636],
              [134.1277, -6.25815],
              [134.097, -6.17273],
              [134.1377, -6.17052],
              [134.17, -6.21557],
              [134.2173, -6.22012],
              [134.3115, -6.30646],
              [134.298, -6.36197],
              [134.3474, -6.39878],
              [134.382, -6.40713],
              [134.4026, -6.40139],
              [134.4249, -6.41895],
              [134.4362, -6.4517],
              [134.4599, -6.43869],
              [134.4891, -6.53131],
              [134.4858, -6.58192],
              [134.5276, -6.60318],
              [134.4821, -6.66863],
              [134.4336, -6.68109],
            ],
          ],
          [
            [
              [134.2807, -6.05256],
              [134.3267, -6.02579],
              [134.3607, -6.04227],
              [134.3823, -6.02187],
              [134.4244, -6.02619],
              [134.4382, -6.01891],
              [134.4436, -6.00643],
              [134.4644, -5.98356],
              [134.5357, -5.92285],
              [134.5723, -5.94052],
              [134.6581, -5.94721],
              [134.6703, -5.98357],
              [134.7544, -6.0529],
              [134.7817, -6.09747],
              [134.7604, -6.14324],
              [134.7663, -6.18145],
              [134.7274, -6.3072],
              [134.6866, -6.34413],
              [134.6395, -6.35555],
              [134.5489, -6.3525],
              [134.5054, -6.30132],
              [134.4592, -6.27077],
              [134.3971, -6.25802],
              [134.3863, -6.22362],
              [134.3368, -6.21551],
              [134.3125, -6.17191],
              [134.2849, -6.14636],
              [134.2807, -6.05256],
            ],
          ],
          [
            [
              [134.7577, -5.85453],
              [134.7697, -5.89399],
              [134.7117, -5.97952],
              [134.6304, -5.92205],
              [134.5854, -5.93691],
              [134.5374, -5.92008],
              [134.4715, -5.9604],
              [134.4315, -6.02112],
              [134.419, -6.02472],
              [134.3792, -6.01837],
              [134.3546, -6.0354],
              [134.3167, -5.99975],
              [134.334, -5.95209],
              [134.3007, -5.90053],
              [134.3324, -5.86254],
              [134.3723, -5.85071],
              [134.3688, -5.77119],
              [134.2634, -5.76163],
              [134.2142, -5.72281],
              [134.2405, -5.67587],
              [134.3467, -5.73121],
              [134.355, -5.69253],
              [134.4186, -5.64292],
              [134.4543, -5.5571],
              [134.5289, -5.56647],
              [134.538, -5.63655],
              [134.5491, -5.65535],
              [134.5668, -5.65654],
              [134.5782, -5.68039],
              [134.5952, -5.70553],
              [134.619, -5.7287],
              [134.6405, -5.71887],
              [134.6549, -5.74994],
              [134.6972, -5.81007],
              [134.7577, -5.85453],
            ],
          ],
          [
            [
              [128.2655, -3.61441],
              [128.2877, -3.69248],
              [128.2518, -3.72545],
              [128.1829, -3.74662],
              [128.1211, -3.74962],
              [128.1484, -3.66138],
              [128.0116, -3.74275],
              [127.9853, -3.77568],
              [127.9318, -3.76827],
              [127.9068, -3.71281],
              [127.9109, -3.67892],
              [128.0169, -3.58674],
              [128.1683, -3.58184],
              [128.2057, -3.52147],
              [128.2809, -3.48812],
              [128.3348, -3.50381],
              [128.3097, -3.56217],
              [128.3452, -3.59693],
              [128.3374, -3.63375],
              [128.2655, -3.61441],
            ],
          ],
          [
            [
              [129.789611, -8.048421],
              [129.750711, -8.060451],
              [129.702611, -8.045571],
              [129.576011, -7.901111],
              [129.583011, -7.840591],
              [129.608311, -7.812481],
              [129.675811, -7.791501],
              [129.843311, -7.844541],
              [129.860811, -7.922381],
              [129.798611, -8.013341],
              [129.789611, -8.048421],
            ],
          ],
          [
            [
              [132.918211, -5.790491],
              [132.941011, -5.772471],
              [132.946411, -5.681341],
              [133.006711, -5.643821],
              [133.016311, -5.584311],
              [133.045011, -5.515811],
              [133.054611, -5.449861],
              [133.117011, -5.274701],
              [133.179011, -5.291151],
              [133.122111, -5.555371],
              [133.089711, -5.614901],
              [133.020311, -5.665601],
              [132.968511, -5.737791],
              [132.953611, -5.811861],
              [132.963011, -5.856341],
              [132.900311, -5.950561],
              [132.876411, -5.898311],
              [132.918211, -5.790491],
            ],
          ],
          [
            [
              [131.002945, -4.443814],
              [131.074814, -4.453882],
              [131.155197, -4.44084],
              [131.228928, -4.456224],
              [131.343292, -4.421241],
              [131.390854, -4.377274],
              [131.453949, -4.374352],
              [131.493683, -4.41465],
              [131.455231, -4.502821],
              [131.368332, -4.529637],
              [131.272049, -4.541338],
              [131.22493, -4.506531],
              [131.086044, -4.477498],
              [130.989182, -4.514464],
              [130.957397, -4.476324],
              [131.002945, -4.443814],
            ],
          ],
          [
            [
              [132.696911, -5.752801],
              [132.654111, -5.708561],
              [132.644411, -5.635551],
              [132.692111, -5.601881],
              [132.744211, -5.672451],
              [132.780011, -5.766551],
              [132.811311, -5.784241],
              [132.820311, -5.849941],
              [132.789511, -5.938101],
              [132.729911, -5.942501],
              [132.671911, -5.903691],
              [132.696211, -5.808051],
              [132.696911, -5.752801],
            ],
          ],
          [
            [
              [134.2773, -6.17358],
              [134.3066, -6.17218],
              [134.3385, -6.2284],
              [134.3702, -6.22986],
              [134.3955, -6.26218],
              [134.4229, -6.28203],
              [134.3477, -6.34415],
              [134.3152, -6.27647],
              [134.2868, -6.28248],
              [134.2305, -6.20123],
              [134.1807, -6.20193],
              [134.1708, -6.16644],
              [134.1176, -6.10945],
              [134.1245, -6.0387],
              [134.1945, -6.0387],
              [134.2289, -6.0174],
              [134.2461, -6.07542],
              [134.2339, -6.12277],
              [134.2773, -6.17358],
            ],
          ],
          [
            [
              [134.4041, -6.30569],
              [134.4624, -6.27898],
              [134.5012, -6.30226],
              [134.5468, -6.36615],
              [134.5967, -6.38789],
              [134.6113, -6.43346],
              [134.5735, -6.47648],
              [134.548, -6.53803],
              [134.5202, -6.53328],
              [134.493, -6.45866],
              [134.4547, -6.43217],
              [134.4437, -6.4401],
              [134.4075, -6.39784],
              [134.3848, -6.40067],
              [134.3625, -6.36106],
              [134.4041, -6.30569],
            ],
          ],
          [
            [
              [127.778111, -8.140231],
              [127.804411, -8.104221],
              [127.930311, -8.143591],
              [128.022411, -8.148441],
              [128.097211, -8.140591],
              [128.116711, -8.171331],
              [128.071911, -8.195261],
              [128.044211, -8.257411],
              [127.954811, -8.249611],
              [127.936211, -8.222341],
              [127.859311, -8.217701],
              [127.793211, -8.190191],
              [127.778111, -8.140231],
            ],
          ],
          [
            [
              [131.087511, -8.172361],
              [130.990911, -8.230581],
              [130.891211, -8.238591],
              [130.896411, -8.286951],
              [130.789911, -8.342211],
              [130.767511, -8.313871],
              [130.829211, -8.248821],
              [130.929811, -8.191911],
              [130.912811, -8.147011],
              [130.977011, -8.131751],
              [130.999811, -8.089501],
              [131.035511, -8.071791],
              [131.079511, -8.108431],
              [131.169111, -8.112971],
              [131.145511, -8.157911],
              [131.087511, -8.172361],
            ],
          ],
          [
            [
              [134.6442, -5.58602],
              [134.7514, -5.63225],
              [134.731, -5.72249],
              [134.7029, -5.73076],
              [134.6496, -5.7286],
              [134.6427, -5.71633],
              [134.6165, -5.72584],
              [134.596, -5.7018],
              [134.575, -5.67087],
              [134.576, -5.65725],
              [134.5488, -5.65219],
              [134.5368, -5.61611],
              [134.5345, -5.5749],
              [134.6442, -5.58602],
            ],
          ],
          [
            [
              [134.5938, -5.42747],
              [134.6513, -5.44671],
              [134.6511, -5.47534],
              [134.7046, -5.51648],
              [134.7011, -5.5677],
              [134.6341, -5.58476],
              [134.5092, -5.54835],
              [134.506, -5.42404],
              [134.5577, -5.44406],
              [134.5938, -5.42747],
            ],
          ],
          [
            [
              [131.897411, -7.176801],
              [131.845711, -7.156551],
              [131.723211, -7.169341],
              [131.716611, -7.131491],
              [131.752311, -7.110931],
              [131.884511, -7.102661],
              [131.929811, -7.111851],
              [131.971311, -7.199891],
              [131.949211, -7.248091],
              [131.906911, -7.223991],
              [131.897411, -7.176801],
            ],
          ],
          [
            [
              [128.690311, -7.103501],
              [128.655111, -7.150041],
              [128.674811, -7.177831],
              [128.636911, -7.222311],
              [128.534511, -7.168821],
              [128.519911, -7.132791],
              [128.587111, -7.069881],
              [128.690311, -7.103501],
            ],
          ],
          [
            [
              [127.369111, -7.502501],
              [127.485211, -7.525411],
              [127.481111, -7.583221],
              [127.409411, -7.607281],
              [127.370311, -7.661551],
              [127.325411, -7.631321],
              [127.366611, -7.577711],
              [127.369111, -7.502501],
            ],
          ],
          [
            [
              [128.4108, -3.55199],
              [128.4361, -3.50583],
              [128.4891, -3.50863],
              [128.5416, -3.53703],
              [128.5658, -3.58219],
              [128.5329, -3.61114],
              [128.453, -3.61128],
              [128.4048, -3.63179],
              [128.4108, -3.55199],
            ],
          ],
          [
            [
              [134.7075, -6.72872],
              [134.6705, -6.78497],
              [134.6232, -6.76017],
              [134.6723, -6.66742],
              [134.6857, -6.59563],
              [134.7244, -6.58593],
              [134.7601, -6.63249],
              [134.7382, -6.7057],
              [134.7075, -6.72872],
            ],
          ],
          [
            [
              [128.6085, -3.57854],
              [128.5457, -3.5238],
              [128.5962, -3.49247],
              [128.6756, -3.54095],
              [128.7227, -3.50944],
              [128.7303, -3.60021],
              [128.6678, -3.5731],
              [128.6368, -3.62703],
              [128.6085, -3.57854],
            ],
          ],
          [
            [
              [131.006851, -4.338299],
              [131.056335, -4.294552],
              [131.147736, -4.32551],
              [131.130356, -4.40931],
              [131.043167, -4.401302],
              [130.995056, -4.371799],
              [131.006851, -4.338299],
            ],
          ],
          [
            [
              [131.041011, -7.499981],
              [130.969711, -7.484171],
              [130.990111, -7.424961],
              [131.162611, -7.400661],
              [131.114011, -7.472901],
              [131.041011, -7.499981],
            ],
          ],
          [
            [
              [127.6479, -3.20179],
              [127.7043, -3.15873],
              [127.7537, -3.14518],
              [127.789, -3.18783],
              [127.786, -3.24502],
              [127.6987, -3.25287],
              [127.6609, -3.23991],
              [127.6479, -3.20179],
            ],
          ],
          [
            [
              [134.8759, -6.29141],
              [134.9079, -6.32475],
              [134.8507, -6.4427],
              [134.8068, -6.46157],
              [134.7981, -6.39306],
              [134.8759, -6.29141],
            ],
          ],
          [
            [
              [127.9522, -3.00023],
              [127.9018, -3.03362],
              [127.8416, -3.03203],
              [127.8735, -2.95421],
              [127.9352, -2.92238],
              [128.0001, -2.93658],
              [127.9522, -3.00023],
            ],
          ],
          [
            [
              [128.087511, -8.231111],
              [128.190711, -8.200321],
              [128.218911, -8.218541],
              [128.227411, -8.275191],
              [128.150311, -8.281711],
              [128.086211, -8.269521],
              [128.087511, -8.231111],
            ],
          ],
          [
            [
              [129.000611, -8.266451],
              [128.950511, -8.237551],
              [128.915111, -8.253071],
              [128.825211, -8.210451],
              [128.859611, -8.185831],
              [128.953211, -8.189821],
              [129.020211, -8.221081],
              [129.000611, -8.266451],
            ],
          ],
          [
            [
              [127.5001, -3.32302],
              [127.4816, -3.29371],
              [127.5485, -3.24207],
              [127.6241, -3.31356],
              [127.5758, -3.33546],
              [127.5001, -3.32302],
            ],
          ],
          [
            [
              [134.7314, -6.47601],
              [134.7625, -6.53462],
              [134.7352, -6.55801],
              [134.6709, -6.55956],
              [134.6397, -6.49611],
              [134.6917, -6.44599],
              [134.7314, -6.47601],
            ],
          ],
          [
            [
              [132.763011, -5.660381],
              [132.745511, -5.617491],
              [132.756311, -5.574361],
              [132.797511, -5.559731],
              [132.821311, -5.673781],
              [132.763011, -5.660381],
            ],
          ],
          [
            [
              [131.043911, -7.653431],
              [131.122811, -7.635551],
              [131.105911, -7.688891],
              [130.969211, -7.737981],
              [130.968111, -7.678161],
              [131.043911, -7.653431],
            ],
          ],
          [
            [
              [127.636911, -8.177851],
              [127.684011, -8.153111],
              [127.747611, -8.200721],
              [127.656011, -8.237481],
              [127.600011, -8.206561],
              [127.636911, -8.177851],
            ],
          ],
          [
            [
              [130.872111, -7.499971],
              [130.998211, -7.527311],
              [130.972711, -7.562581],
              [130.846511, -7.562131],
              [130.839211, -7.497951],
              [130.872111, -7.499971],
            ],
          ],
          [
            [
              [127.172, -8.11934],
              [127.1417, -8.11181],
              [127.1359, -8.04633],
              [127.2011, -8.02771],
              [127.2309, -8.11386],
              [127.172, -8.11934],
            ],
          ],
          [
            [
              [131.621311, -6.695521],
              [131.562011, -6.719951],
              [131.581311, -6.772751],
              [131.526611, -6.802571],
              [131.511911, -6.762721],
              [131.559711, -6.681411],
              [131.621311, -6.695521],
            ],
          ],
          [
            [
              [127.1987, -3.89045],
              [127.1543, -3.88116],
              [127.1369, -3.84772],
              [127.1915, -3.81556],
              [127.2362, -3.86309],
              [127.1987, -3.89045],
            ],
          ],
          [
            [
              [131.4279, -4.00002],
              [131.4501, -4.07044],
              [131.4216, -4.07687],
              [131.3673, -3.96939],
              [131.4184, -3.94902],
              [131.4279, -4.00002],
            ],
          ],
          [
            [
              [134.7166, -5.7494],
              [134.7493, -5.7861],
              [134.6982, -5.80898],
              [134.6595, -5.73844],
              [134.7166, -5.7494],
            ],
          ],
          [
            [
              [134.2541, -5.78689],
              [134.2099, -5.83785],
              [134.1901, -5.81428],
              [134.1989, -5.75416],
              [134.2541, -5.78689],
            ],
          ],
          [
            [
              [134.5586, -5.33935],
              [134.5999, -5.34036],
              [134.5386, -5.41645],
              [134.511, -5.37494],
              [134.5586, -5.33935],
            ],
          ],
        ],
      },
      id: 81,
      properties: {
        ID: 10,
        kode: 81,
        provinsi: "MALUKU",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [115.75, -1.314338],
              [115.750001, -1.314339],
              [115.751405, -1.316831],
              [115.73581, -1.366078],
              [115.653402, -1.497092],
              [115.653089, -1.497869],
              [115.63121, -1.533835],
              [115.636133, -1.603781],
              [115.668327, -1.631298],
              [115.665229, -1.706676],
              [115.691899, -1.750616],
              [115.726902, -1.805778],
              [115.730987, -1.867477],
              [115.706121, -1.962304],
              [115.710694, -2.048348],
              [115.710956, -2.048324],
              [115.813393, -2.070402],
              [115.793901, -2.13127],
              [115.785043, -2.215817],
              [115.813901, -2.25],
              [115.813632, -2.250004],
              [115.809844, -2.277218],
              [115.837873, -2.389611],
              [115.885309, -2.374997],
              [115.890968, -2.335292],
              [115.984661, -2.312577],
              [116.186227, -2.32084],
              [116.250001, -2.316857],
              [116.320487, -2.341474],
              [116.493124, -2.381091],
              [116.554062, -2.409357],
              [116.5088, -2.56185],
              [116.477155, -2.511811],
              [116.42694, -2.494954],
              [116.383386, -2.522825],
              [116.304234, -2.537069],
              [116.337746, -2.569175],
              [116.392311, -2.586137],
              [116.367549, -2.664821],
              [116.358986, -2.763994],
              [116.371806, -2.804421],
              [116.364408, -2.877151],
              [116.268831, -3.003408],
              [116.212625, -3.001885],
              [116.2059, -2.93782],
              [116.155156, -2.90048],
              [116.103854, -2.918623],
              [116.1262, -3.01424],
              [116.172072, -3.061749],
              [116.211546, -3.077393],
              [116.209133, -3.127579],
              [116.168473, -3.180757],
              [116.174596, -3.25247],
              [116.085972, -3.282887],
              [116.034042, -3.360676],
              [116.007613, -3.432879],
              [116.014801, -3.48442],
              [115.991253, -3.52718],
              [115.994862, -3.568975],
              [115.966095, -3.612225],
              [115.83994, -3.630036],
              [115.719, -3.7309],
              [115.657998, -3.743123],
              [115.400724, -3.852247],
              [115.055918, -3.991818],
              [114.674708, -4.180716],
              [114.628891, -4.15206],
              [114.638174, -4.037824],
              [114.610048, -3.887838],
              [114.608771, -3.756415],
              [114.622502, -3.711745],
              [114.610217, -3.639174],
              [114.555767, -3.55747],
              [114.513437, -3.543926],
              [114.483868, -3.503508],
              [114.4433, -3.50281],
              [114.349449, -3.456847],
              [114.358683, -3.386272],
              [114.347025, -3.350136],
              [114.383407, -3.26764],
              [114.450182, -3.209987],
              [114.429722, -3.174344],
              [114.545967, -3.067971],
              [114.496324, -3.015414],
              [114.546252, -2.947693],
              [114.567871, -2.866444],
              [114.617653, -2.883607],
              [114.598846, -2.815611],
              [114.664366, -2.800567],
              [114.672453, -2.747],
              [114.761401, -2.722209],
              [114.787004, -2.682251],
              [114.806774, -2.578846],
              [114.886746, -2.50283],
              [114.919861, -2.455716],
              [114.987968, -2.413859],
              [115.040507, -2.352388],
              [115.248471, -2.211515],
              [115.29124, -2.224027],
              [115.297228, -2.143794],
              [115.322177, -2.072651],
              [115.406859, -2.060095],
              [115.371055, -2.010274],
              [115.402261, -1.954247],
              [115.33758, -1.851955],
              [115.324479, -1.809402],
              [115.351248, -1.633594],
              [115.414142, -1.424074],
              [115.556666, -1.395118],
              [115.669192, -1.333779],
              [115.75, -1.314338],
            ],
          ],
          [
            [
              [116.31113, -3.902152],
              [116.266114, -3.913611],
              [116.210584, -3.981587],
              [116.142724, -4.036726],
              [116.096245, -4.059081],
              [116.039887, -4.024688],
              [116.079433, -3.924688],
              [116.064453, -3.903803],
              [116.082245, -3.834424],
              [116.006969, -3.681632],
              [116.01009, -3.613496],
              [116.036951, -3.582823],
              [116.045361, -3.470512],
              [116.070784, -3.437013],
              [116.1174, -3.302174],
              [116.185062, -3.267459],
              [116.253822, -3.210675],
              [116.28029, -3.221115],
              [116.250389, -3.378996],
              [116.308094, -3.45045],
              [116.313815, -3.503195],
              [116.27193, -3.523571],
              [116.305973, -3.591237],
              [116.300157, -3.712615],
              [116.339172, -3.729019],
              [116.272724, -3.821292],
              [116.31113, -3.902152],
            ],
          ],
          [
            [
              [116.417468, -3.500025],
              [116.399178, -3.626403],
              [116.362428, -3.651056],
              [116.343564, -3.568739],
              [116.312436, -3.556486],
              [116.344771, -3.452928],
              [116.389052, -3.414555],
              [116.434746, -3.422707],
              [116.417468, -3.500025],
            ],
          ],
        ],
      },
      id: 63,
      properties: {
        ID: 11,
        kode: 63,
        provinsi: "KALIMANTAN SELATAN",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [114.204971, 1.407545],
              [114.153831, 1.384724],
              [114.152161, 1.382885],
              [114.137711, 1.21268],
              [114.140587, 1.206963],
              [114.119576, 1.156378],
              [114.081848, 1.161817],
              [114.047989, 1.132663],
              [113.987701, 1.144419],
              [113.938293, 1.06126],
              [113.890594, 1.038177],
              [113.919106, 0.982897],
              [113.918137, 0.979328],
              [113.880379, 0.925269],
              [113.881111, 0.883935],
              [113.926888, 0.843717],
              [113.889313, 0.783661],
              [113.898712, 0.745404],
              [113.843277, 0.702985],
              [113.842865, 0.665291],
              [113.738724, 0.544104],
              [113.672333, 0.505215],
              [113.656631, 0.438104],
              [113.587898, 0.405597],
              [113.513199, 0.320208],
              [113.437424, 0.265147],
              [113.322639, 0.27277],
              [113.269646, 0.237864],
              [113.326904, 0.178387],
              [113.405693, 0.138666],
              [113.424301, 0.01172],
              [113.333961, -0.188953],
              [113.221898, -0.340063],
              [113.260048, -0.386946],
              [113.265274, -0.432963],
              [113.229156, -0.474128],
              [113.131927, -0.450832],
              [113.059326, -0.500177],
              [113.032639, -0.487246],
              [112.888245, -0.5348],
              [112.852104, -0.568786],
              [112.754036, -0.568419],
              [112.731289, -0.624087],
              [112.688972, -0.652312],
              [112.634483, -0.654555],
              [112.595421, -0.687516],
              [112.538094, -0.699546],
              [112.449364, -0.679314],
              [112.302696, -0.732715],
              [112.244011, -0.634966],
              [112.199463, -0.614976],
              [112.107172, -0.688612],
              [112.039477, -0.702334],
              [111.999829, -0.72664],
              [112.000516, -0.782459],
              [111.954544, -0.818529],
              [111.906593, -0.775333],
              [111.906021, -0.869211],
              [111.832191, -0.914291],
              [111.733315, -0.923568],
              [111.717972, -0.945031],
              [111.624825, -0.984459],
              [111.623978, -1.031922],
              [111.570969, -1.075839],
              [111.55349, -1.117017],
              [111.571541, -1.14573],
              [111.560516, -1.210964],
              [111.494591, -1.221164],
              [111.489815, -1.279386],
              [111.417722, -1.249998],
              [111.348486, -1.285983],
              [111.261569, -1.387914],
              [111.21228, -1.411965],
              [111.188332, -1.490991],
              [111.157883, -1.470608],
              [111.111994, -1.487714],
              [111.123306, -1.544106],
              [111.077415, -1.562303],
              [111.039024, -1.539377],
              [110.980354, -1.538065],
              [110.94973, -1.578825],
              [110.912148, -1.583816],
              [110.855583, -1.633108],
              [110.857147, -1.667797],
              [110.913635, -1.717645],
              [110.974731, -1.667775],
              [111.001907, -1.691915],
              [111.018458, -1.760494],
              [110.971994, -1.812174],
              [110.969867, -1.866475],
              [110.995881, -1.900829],
              [110.978226, -1.95324],
              [111.046007, -1.95951],
              [111.085697, -2.007968],
              [111.049252, -2.069462],
              [111.077835, -2.153214],
              [111.0326, -2.247475],
              [111.068977, -2.298775],
              [111.104942, -2.433837],
              [111.105408, -2.484712],
              [111.136215, -2.611802],
              [111.118469, -2.653161],
              [111.16468, -2.672753],
              [111.166374, -2.710246],
              [111.138382, -2.7492],
              [111.063812, -2.785731],
              [111.010681, -2.794681],
              [110.967964, -2.856296],
              [110.886566, -2.874295],
              [110.797234, -2.912337],
              [110.747238, -2.952027],
              [110.7221, -3.00548],
              [110.6576, -3.03914],
              [110.6336, -2.98782],
              [110.6128, -2.88084],
              [110.5698, -2.84296],
              [110.525, -2.8458],
              [110.4068, -2.90381],
              [110.2995, -2.99725],
              [110.2586, -2.96867],
              [110.22, -2.88738],
              [110.2455, -2.85244],
              [110.2533, -2.76538],
              [110.2148, -2.74003],
              [110.2275, -2.70112],
              [110.2077, -2.64912],
              [110.1552, -2.63672],
              [110.1941, -2.52439],
              [110.1754, -2.45821],
              [110.147, -2.41627],
              [110.137, -2.32053],
              [110.0881, -2.24693],
              [110.0796, -2.18218],
              [110.1071, -2.13802],
              [110.1123, -2.08129],
              [110.0942, -1.98356],
              [110.0508, -1.92568],
              [109.9995, -1.90751],
              [109.9017, -1.83527],
              [109.9364, -1.78015],
              [109.9808, -1.74154],
              [110.0278, -1.67139],
              [110.033, -1.53186],
              [110.0617, -1.46419],
              [110.0684, -1.37387],
              [110.0528, -1.33292],
              [109.9916, -1.27373],
              [109.9618, -1.27656],
              [109.9111, -1.19229],
              [109.9482, -1.12206],
              [109.8486, -1.09025],
              [109.774, -1.04261],
              [109.761, -0.99262],
              [109.7275, -0.98058],
              [109.6514, -0.99955],
              [109.6433, -0.98207],
              [109.6117, -0.9719],
              [109.5843, -0.90008],
              [109.4326, -0.85378],
              [109.4049, -0.93135],
              [109.2996, -0.90027],
              [109.239, -0.80772],
              [109.245, -0.6637],
              [109.3207, -0.70762],
              [109.3963, -0.70803],
              [109.4654, -0.75414],
              [109.5308, -0.7396],
              [109.6311, -0.80334],
              [109.6335, -0.75171],
              [109.5958, -0.70947],
              [109.6738, -0.69369],
              [109.6652, -0.68153],
              [109.5847, -0.68744],
              [109.588, -0.66158],
              [109.5804, -0.65017],
              [109.5137, -0.64136],
              [109.4929, -0.62301],
              [109.4754, -0.61456],
              [109.4189, -0.6312],
              [109.3774, -0.57662],
              [109.2616, -0.60186],
              [109.2036, -0.55585],
              [109.163, -0.57835],
              [109.1282, -0.54665],
              [109.1098, -0.49835],
              [109.0966, -0.36251],
              [109.1129, -0.33999],
              [109.088, -0.27689],
              [109.1198, -0.2587],
              [109.1392, -0.23692],
              [109.1936, -0.22256],
              [109.1786, -0.19141],
              [109.188, -0.1414],
              [109.1735, -0.0609],
              [109.1573, -0.04261],
              [109.1731, 0.07643],
              [109.1372, 0.13194],
              [109.1174, 0.21137],
              [109.0713, 0.26328],
              [108.9632, 0.31588],
              [108.9116, 0.3217],
              [108.9387, 0.38147],
              [108.9285, 0.46134],
              [108.906, 0.47842],
              [108.9224, 0.56979],
              [108.9105, 0.6628],
              [108.8679, 0.71447],
              [108.872, 0.78082],
              [108.8361, 0.8233],
              [108.9103, 0.8683],
              [108.9553, 0.91943],
              [108.9756, 1.00491],
              [108.9609, 1.05662],
              [108.909, 1.15188],
              [108.9456, 1.16483],
              [108.9905, 1.27642],
              [109.0304, 1.32147],
              [109.0512, 1.3894],
              [109.0411, 1.44732],
              [109.0592, 1.51973],
              [109.1307, 1.5864],
              [109.2182, 1.62901],
              [109.2566, 1.66235],
              [109.289, 1.74958],
              [109.3391, 1.82919],
              [109.351, 1.87508],
              [109.3308, 1.92828],
              [109.3548, 1.94679],
              [109.4278, 1.94949],
              [109.4634, 1.97743],
              [109.5912, 1.9991],
              [109.575401, 1.935634],
              [109.538345, 1.914961],
              [109.557236, 1.853854],
              [109.599236, 1.810235],
              [109.655716, 1.798155],
              [109.680099, 1.767307],
              [109.663406, 1.729619],
              [109.656738, 1.632067],
              [109.792725, 1.499817],
              [109.830124, 1.424426],
              [109.934013, 1.41802],
              [109.963875, 1.386595],
              [109.974075, 1.308176],
              [110.04628, 1.26457],
              [110.107086, 1.195396],
              [110.18927, 1.178725],
              [110.206352, 1.121725],
              [110.241669, 1.110338],
              [110.275497, 1.050082],
              [110.277237, 0.996843],
              [110.402931, 0.983606],
              [110.406189, 0.95233],
              [110.482376, 0.881211],
              [110.570297, 0.85522],
              [110.714661, 0.905033],
              [110.764175, 0.929846],
              [110.808174, 0.911536],
              [110.909386, 0.955599],
              [111.041229, 0.997548],
              [111.107147, 1.027512],
              [111.308907, 1.029509],
              [111.356682, 1.035687],
              [111.408791, 1.019521],
              [111.482697, 1.019521],
              [111.552612, 1.039497],
              [111.648499, 1.013529],
              [111.678459, 1.029509],
              [111.733223, 1.011347],
              [111.762688, 1.021632],
              [111.857185, 1.002252],
              [111.890572, 1.067516],
              [111.957893, 1.126365],
              [112.128143, 1.142361],
              [112.157951, 1.205362],
              [112.174301, 1.306329],
              [112.205956, 1.339872],
              [112.222633, 1.390472],
              [112.194519, 1.410984],
              [112.222755, 1.457148],
              [112.274704, 1.469801],
              [112.320335, 1.504941],
              [112.42939, 1.524687],
              [112.480782, 1.576551],
              [112.650337, 1.568992],
              [112.672386, 1.554553],
              [112.770721, 1.562787],
              [112.8377, 1.537369],
              [112.882736, 1.585829],
              [112.92025, 1.569736],
              [113.004318, 1.569513],
              [113.063759, 1.536398],
              [113.030952, 1.472237],
              [112.982132, 1.451602],
              [112.975845, 1.40725],
              [113.114716, 1.425778],
              [113.172112, 1.378784],
              [113.260704, 1.391758],
              [113.318687, 1.378034],
              [113.419991, 1.284333],
              [113.532501, 1.322036],
              [113.581009, 1.298786],
              [113.621231, 1.223979],
              [113.659279, 1.219476],
              [113.699623, 1.258209],
              [113.791924, 1.292841],
              [113.826965, 1.331964],
              [113.822708, 1.372153],
              [113.875908, 1.3915],
              [113.979195, 1.451969],
              [114.019402, 1.444113],
              [114.088257, 1.462753],
              [114.141617, 1.46217],
              [114.204971, 1.407545],
            ],
          ],
          [
            [
              [109.6986, -0.99995],
              [109.7573, -1.00449],
              [109.7685, -1.12241],
              [109.7808, -1.1439],
              [109.656, -1.22133],
              [109.543, -1.27298],
              [109.4999, -1.3094],
              [109.4137, -1.28393],
              [109.4512, -1.09149],
              [109.4502, -1.03477],
              [109.4866, -0.97418],
              [109.554, -1.00326],
              [109.5886, -0.98292],
              [109.637, -0.98789],
              [109.6436, -1.01161],
              [109.6721, -1.02069],
              [109.6986, -0.99995],
            ],
          ],
          [
            [
              [108.8904, -1.53854],
              [108.9347, -1.54254],
              [108.982, -1.59809],
              [108.953, -1.64399],
              [108.8571, -1.67404],
              [108.8187, -1.56793],
              [108.8773, -1.56155],
              [108.8904, -1.53854],
            ],
          ],
          [
            [
              [109.0795, -0.27425],
              [109.0473, -0.25387],
              [109.0858, -0.20704],
              [109.1542, -0.20969],
              [109.1176, -0.25515],
              [109.0795, -0.27425],
            ],
          ],
          [
            [
              [109.5, -0.68043],
              [109.4729, -0.64078],
              [109.4714, -0.62425],
              [109.4933, -0.6268],
              [109.5118, -0.64379],
              [109.5446, -0.65463],
              [109.5821, -0.65385],
              [109.583, -0.68458],
              [109.5408, -0.70285],
              [109.5, -0.68043],
            ],
          ],
          [
            [
              [109.1333, -0.0912],
              [109.1641, -0.09208],
              [109.1842, -0.1367],
              [109.1752, -0.19458],
              [109.1264, -0.12726],
              [109.1333, -0.0912],
            ],
          ],
          [
            [
              [110.0675, -2.71332],
              [110.108, -2.6754],
              [110.1238, -2.74506],
              [110.0769, -2.76368],
              [110.0675, -2.71332],
            ],
          ],
        ],
      },
      id: 61,
      properties: {
        ID: 12,
        kode: 61,
        provinsi: "KALIMANTAN BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [119.591652, -4.55424],
              [119.59671, -4.416243],
              [119.639999, -4.302221],
              [119.594444, -4.240834],
              [119.624649, -4.236449],
              [119.612373, -4.203055],
              [119.638023, -4.173174],
              [119.605278, -4.083888],
              [119.641388, -3.961668],
              [119.583611, -3.976388],
              [119.583885, -4.022222],
              [119.613777, -4.00442],
              [119.586563, -4.039411],
              [119.570557, -3.948335],
              [119.451942, -3.713609],
              [119.46389, -3.639999],
              [119.516594, -3.571808],
              [119.435226, -3.345711],
              [119.43866, -3.266739],
              [119.389656, -3.21247],
              [119.420471, -3.176799],
              [119.484596, -3.18489],
              [119.545479, -3.13092],
              [119.629059, -3.121519],
              [119.534187, -2.94152],
              [119.5252, -2.793351],
              [119.493317, -2.74063],
              [119.643578, -2.75641],
              [119.727882, -2.72763],
              [119.76104, -2.68366],
              [119.751106, -2.604909],
              [119.700089, -2.553469],
              [119.720917, -2.500069],
              [119.689026, -2.437739],
              [119.715866, -2.39282],
              [119.690308, -2.33612],
              [119.596573, -2.294341],
              [119.629776, -2.163379],
              [119.733871, -2.07421],
              [119.880997, -2.047519],
              [119.99604, -1.963381],
              [120.093803, -1.96225],
              [120.122032, -2.007521],
              [120.336891, -2.053441],
              [120.399567, -1.884479],
              [120.581871, -2.121749],
              [120.706909, -2.212381],
              [120.975296, -2.2411],
              [121.164711, -2.33201],
              [121.328552, -2.372219],
              [121.504707, -2.490139],
              [121.71553, -2.558119],
              [121.800636, -2.709759],
              [121.742439, -2.735281],
              [121.656937, -2.878121],
              [121.57132, -2.912889],
              [121.497948, -2.98648],
              [121.367706, -3.01218],
              [121.305733, -3.069639],
              [121.269417, -3.06436],
              [121.215973, -2.974619],
              [121.172737, -2.96713],
              [121.101349, -2.77383],
              [120.985046, -2.83115],
              [120.972656, -2.81988],
              [121.09816, -2.71633],
              [121.046944, -2.701666],
              [121.058823, -2.672917],
              [121.036942, -2.69417],
              [121.073677, -2.642818],
              [121.054787, -2.639081],
              [121.073402, -2.616626],
              [121.056114, -2.580555],
              [121.072212, -2.61561],
              [121.054573, -2.651976],
              [121.031387, -2.659723],
              [121.041389, -2.624166],
              [121.026947, -2.65389],
              [121.010429, -2.614999],
              [121.006386, -2.679166],
              [120.976669, -2.666945],
              [120.98764, -2.639878],
              [120.970894, -2.670767],
              [120.945709, -2.64595],
              [120.857224, -2.658057],
              [120.793892, -2.62389],
              [120.799156, -2.60833],
              [120.666107, -2.639441],
              [120.632774, -2.683056],
              [120.568611, -2.691945],
              [120.582497, -2.669719],
              [120.564163, -2.670555],
              [120.569725, -2.711666],
              [120.453331, -2.824721],
              [120.353615, -2.860277],
              [120.256111, -2.945834],
              [120.196831, -2.951605],
              [120.189453, -2.967989],
              [120.254723, -3.05167],
              [120.255547, -3.16028],
              [120.382217, -3.202221],
              [120.389168, -3.250832],
              [120.421249, -3.264168],
              [120.379723, -3.503611],
              [120.418892, -3.573057],
              [120.413612, -3.667221],
              [120.442497, -3.739167],
              [120.358917, -3.849969],
              [120.33667, -3.9375],
              [120.361115, -4.02389],
              [120.330696, -4.104164],
              [120.380867, -4.163501],
              [120.365067, -4.298959],
              [120.393501, -4.332041],
              [120.348145, -4.425264],
              [120.402496, -4.480834],
              [120.377472, -4.512521],
              [120.397186, -4.600131],
              [120.458572, -4.658292],
              [120.400108, -4.710047],
              [120.383614, -4.838332],
              [120.303391, -4.87538],
              [120.300552, -5.055555],
              [120.271667, -5.14394],
              [120.35833, -5.331111],
              [120.404861, -5.341689],
              [120.472504, -5.623055],
              [120.314857, -5.507519],
              [120.13028, -5.589722],
              [119.935448, -5.544427],
              [119.840088, -5.635554],
              [119.849953, -5.664043],
              [119.785614, -5.701977],
              [119.646667, -5.682223],
              [119.656113, -5.640278],
              [119.611389, -5.6125],
              [119.558998, -5.650539],
              [119.552902, -5.595309],
              [119.561386, -5.618332],
              [119.579445, -5.603612],
              [119.512871, -5.56993],
              [119.514442, -5.53444],
              [119.460327, -5.576923],
              [119.487984, -5.604735],
              [119.438889, -5.596667],
              [119.430275, -5.487501],
              [119.396111, -5.432501],
              [119.362976, -5.41842],
              [119.353889, -5.325833],
              [119.409447, -5.112136],
              [119.498611, -5.116945],
              [119.450279, -5.108611],
              [119.471939, -5.077922],
              [119.450279, -5.0975],
              [119.447716, -5.086544],
              [119.525558, -4.923611],
              [119.513885, -4.886388],
              [119.56147, -4.891851],
              [119.506111, -4.868611],
              [119.481392, -4.750834],
              [119.591652, -4.55424],
            ],
          ],
          [
            [
              [120.431389, -5.63944],
              [120.445831, -5.646111],
              [120.429443, -5.661112],
              [120.419998, -5.649723],
              [120.431389, -5.63944],
            ],
          ],
          [
            [
              [118.154724, -5.128056],
              [118.138641, -5.126358],
              [118.147217, -5.114721],
              [118.154724, -5.128056],
            ],
          ],
          [
            [
              [117.661667, -5.175556],
              [117.681938, -5.196813],
              [117.656113, -5.222223],
              [117.661667, -5.175556],
            ],
          ],
          [
            [
              [117.929443, -5.351667],
              [117.951668, -5.383333],
              [117.947777, -5.408611],
              [117.926392, -5.389443],
              [117.929443, -5.351667],
            ],
          ],
          [
            [
              [119.312775, -5.511667],
              [119.31591, -5.487446],
              [119.298058, -5.498612],
              [119.297501, -5.46778],
              [119.26667, -5.45472],
              [119.301949, -5.456808],
              [119.299721, -5.493611],
              [119.320763, -5.496492],
              [119.310837, -5.519719],
              [119.291809, -5.512451],
              [119.29583, -5.53139],
              [119.257767, -5.52556],
              [119.248337, -5.494999],
              [119.276108, -5.501112],
              [119.279167, -5.471939],
              [119.27906, -5.4938],
              [119.312775, -5.511667],
            ],
          ],
          [
            [
              [120.489166, -5.738329],
              [120.492775, -5.751945],
              [120.474442, -5.750835],
              [120.489166, -5.738329],
            ],
          ],
          [
            [
              [120.458115, -6.38956],
              [120.480293, -6.281098],
              [120.443039, -6.2589],
              [120.445557, -6.16514],
              [120.426506, -6.179759],
              [120.466187, -6.093651],
              [120.445137, -5.956089],
              [120.461388, -5.792778],
              [120.493111, -5.7675],
              [120.568466, -6.055651],
              [120.524467, -6.222331],
              [120.53833, -6.327239],
              [120.495674, -6.391684],
              [120.509979, -6.443737],
              [120.483971, -6.49799],
              [120.458115, -6.38956],
            ],
          ],
          [
            [
              [120.429733, -6.10583],
              [120.414795, -6.20879],
              [120.392365, -6.178013],
              [120.429733, -6.10583],
            ],
          ],
          [
            [
              [120.992241, -6.504577],
              [120.979668, -6.504577],
              [121.00132, -6.493719],
              [120.992241, -6.504577],
            ],
          ],
          [
            [
              [120.438942, -6.59793],
              [120.440979, -6.641493],
              [120.426071, -6.641673],
              [120.420059, -6.596825],
              [120.438942, -6.59793],
            ],
          ],
          [
            [
              [120.800095, -6.788329],
              [120.81385, -6.832688],
              [120.795654, -6.866649],
              [120.778847, -6.799716],
              [120.800095, -6.788329],
            ],
          ],
          [
            [
              [120.629715, -7.000628],
              [120.736809, -7.075277],
              [120.785904, -7.059813],
              [120.767731, -7.134739],
              [120.631943, -7.133331],
              [120.63475, -7.099226],
              [120.603889, -7.072223],
              [120.629715, -7.000628],
            ],
          ],
          [
            [
              [120.560486, -7.07302],
              [120.611656, -7.08917],
              [120.563332, -7.093056],
              [120.560486, -7.07302],
            ],
          ],
          [
            [
              [121.751389, -7.222219],
              [121.747498, -7.238333],
              [121.738335, -7.229166],
              [121.751389, -7.222219],
            ],
          ],
          [
            [
              [120.906303, -7.277767],
              [121.003609, -7.281388],
              [121.063889, -7.300556],
              [121, -7.33333],
              [120.79528, -7.270555],
              [120.906303, -7.277767],
            ],
          ],
          [
            [
              [121.766113, -7.261667],
              [121.772781, -7.286945],
              [121.727501, -7.294445],
              [121.730278, -7.277778],
              [121.766113, -7.261667],
            ],
          ],
          [
            [
              [121.096947, -7.302219],
              [121.168335, -7.354165],
              [121.099167, -7.398055],
              [121.059723, -7.372499],
              [121.096947, -7.302219],
            ],
          ],
          [
            [
              [121.819725, -7.330278],
              [121.840279, -7.350555],
              [121.823608, -7.39694],
              [121.753891, -7.423055],
              [121.756386, -7.347777],
              [121.819725, -7.330278],
            ],
          ],
          [
            [
              [121.797005, -7.472008],
              [121.797501, -7.488609],
              [121.722778, -7.491661],
              [121.797005, -7.472008],
            ],
          ],
          [
            [
              [120.423058, -5.04861],
              [120.427635, -5.058155],
              [120.412498, -5.051388],
              [120.423058, -5.04861],
            ],
          ],
        ],
      },
      id: 73,
      properties: {
        ID: 13,
        kode: 73,
        provinsi: "SULAWESI SELATAN",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [106.721344, -6.089998],
            [106.741844, -6.105995],
            [106.857552, -6.117222],
            [106.877823, -6.09872],
            [106.972267, -6.089283],
            [106.972893, -6.185318],
            [106.945602, -6.25469],
            [106.909164, -6.263964],
            [106.922569, -6.318879],
            [106.9132, -6.366885],
            [106.775894, -6.316725],
            [106.718864, -6.185875],
            [106.688759, -6.174209],
            [106.692719, -6.095602],
            [106.721344, -6.089998],
          ],
        ],
      },
      id: 31,
      properties: {
        ID: 14,
        kode: 31,
        provinsi: "DKI JAKARTA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [106.396103, -6.979798],
            [106.390602, -6.90497],
            [106.427551, -6.865082],
            [106.43618, -6.818825],
            [106.511475, -6.765959],
            [106.429398, -6.695778],
            [106.431358, -6.583818],
            [106.401779, -6.529884],
            [106.404884, -6.453141],
            [106.45713, -6.419496],
            [106.432259, -6.359931],
            [106.466515, -6.313413],
            [106.500175, -6.356728],
            [106.532104, -6.333633],
            [106.599113, -6.361764],
            [106.767433, -6.361234],
            [106.775894, -6.316725],
            [106.9132, -6.366885],
            [106.922569, -6.318879],
            [106.909164, -6.263964],
            [106.945602, -6.25469],
            [106.972893, -6.185318],
            [106.972267, -6.089283],
            [107.018662, -6.078872],
            [107.008194, -5.994798],
            [107.038139, -5.911394],
            [107.103302, -5.932775],
            [107.139267, -5.978195],
            [107.191887, -5.985764],
            [107.302711, -5.956646],
            [107.387733, -6.01634],
            [107.465004, -6.141714],
            [107.531631, -6.174138],
            [107.621086, -6.189385],
            [107.654709, -6.242166],
            [107.722885, -6.232824],
            [107.822433, -6.178484],
            [107.893303, -6.238593],
            [107.940582, -6.249246],
            [108.103218, -6.334497],
            [108.156311, -6.331516],
            [108.194878, -6.30224],
            [108.19416, -6.261509],
            [108.301331, -6.245291],
            [108.361443, -6.274672],
            [108.368279, -6.329412],
            [108.429184, -6.416264],
            [108.484001, -6.460444],
            [108.538673, -6.485534],
            [108.539986, -6.577236],
            [108.554527, -6.676128],
            [108.575089, -6.735016],
            [108.605278, -6.770391],
            [108.677612, -6.768246],
            [108.683212, -6.80682],
            [108.763901, -6.815747],
            [108.829338, -6.74608],
            [108.824615, -6.829293],
            [108.76516, -6.896383],
            [108.761101, -6.98307],
            [108.798622, -7.004968],
            [108.777687, -7.104835],
            [108.726479, -7.116722],
            [108.696854, -7.151166],
            [108.628929, -7.137631],
            [108.556373, -7.171165],
            [108.582017, -7.240565],
            [108.555715, -7.290434],
            [108.560766, -7.334588],
            [108.603483, -7.350607],
            [108.662295, -7.340506],
            [108.714968, -7.421927],
            [108.724345, -7.486524],
            [108.753132, -7.543514],
            [108.738433, -7.609161],
            [108.804252, -7.673145],
            [108.76519, -7.696947],
            [108.715416, -7.6797],
            [108.657326, -7.69776],
            [108.586388, -7.684473],
            [108.513016, -7.699345],
            [108.505714, -7.760839],
            [108.48156, -7.801749],
            [108.430328, -7.822663],
            [108.261208, -7.806957],
            [108.123146, -7.780538],
            [107.928497, -7.730316],
            [107.839561, -7.7341],
            [107.782387, -7.677471],
            [107.679466, -7.660038],
            [107.673851, -7.627574],
            [107.602493, -7.571478],
            [107.39267, -7.492356],
            [107.35405, -7.498446],
            [107.242142, -7.487233],
            [107.077705, -7.451569],
            [106.857651, -7.432205],
            [106.788452, -7.434358],
            [106.519707, -7.405331],
            [106.473618, -7.371199],
            [106.421753, -7.357368],
            [106.370895, -7.310125],
            [106.376572, -7.237391],
            [106.398254, -7.188931],
            [106.455795, -7.184799],
            [106.456253, -7.127603],
            [106.539734, -7.056473],
            [106.543465, -6.982475],
            [106.441109, -6.952632],
            [106.396103, -6.979798],
          ],
        ],
      },
      id: 32,
      properties: {
        ID: 15,
        kode: 32,
        provinsi: "JAWA BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [140.686661, -2.477779],
              [140.747223, -2.534719],
              [140.707947, -2.538949],
              [140.717224, -2.59278],
              [140.698059, -2.588055],
              [140.686951, -2.613889],
              [140.705826, -2.628334],
              [140.736664, -2.627222],
              [140.71167, -2.596666],
              [140.761108, -2.62861],
              [140.789536, -2.595499],
              [140.915283, -2.627222],
              [141.002945, -2.604969],
              [141.000214, -6.313239],
              [140.957016, -6.341135],
              [140.931885, -6.553238],
              [140.893906, -6.623135],
              [140.8564, -6.630125],
              [140.864258, -6.671305],
              [140.834351, -6.67659],
              [140.836395, -6.713049],
              [140.885437, -6.740618],
              [140.858093, -6.780619],
              [140.902603, -6.805129],
              [140.897812, -6.856439],
              [140.936249, -6.846869],
              [140.936356, -6.89572],
              [140.951218, -6.876529],
              [140.982391, -6.891975],
              [141.011765, -7.999899],
              [141.001114, -9.118333],
              [140.892776, -9.084998],
              [140.61322, -8.809982],
              [140.500488, -8.61316],
              [140.355118, -8.463129],
              [140.314621, -8.455412],
              [140.228607, -8.355278],
              [140.169556, -8.336712],
              [139.983337, -8.187221],
              [139.956665, -8.124438],
              [140.074966, -8.065577],
              [140.078033, -8.032313],
              [140.056671, -7.993609],
              [140.066101, -7.9232],
              [140.046387, -8.016963],
              [140.060791, -8.062901],
              [139.924423, -8.107983],
              [139.71257, -8.097499],
              [139.506393, -8.180833],
              [139.343323, -8.206104],
              [139.277191, -8.176252],
              [139.223236, -8.095256],
              [139.08194, -8.1375],
              [139.068802, -8.11299],
              [139.070053, -8.151273],
              [138.988052, -8.203059],
              [138.953613, -8.193334],
              [138.956116, -8.159168],
              [138.948059, -8.18639],
              [138.995285, -8.230279],
              [139.003311, -8.296171],
              [138.976944, -8.329998],
              [138.935272, -8.313889],
              [138.953049, -8.295834],
              [138.92334, -8.279722],
              [138.949448, -8.262499],
              [138.910004, -8.267219],
              [138.835281, -8.115],
              [138.924164, -8.076111],
              [138.902771, -8.031388],
              [138.913086, -7.919674],
              [139.018051, -7.853889],
              [139.018082, -7.751259],
              [139.068344, -7.631122],
              [139.106308, -7.60077],
              [139.114456, -7.636712],
              [139.115234, -7.566709],
              [139.054016, -7.517074],
              [138.964325, -7.519186],
              [138.868591, -7.321462],
              [138.67334, -7.223056],
              [138.671951, -7.19833],
              [138.915115, -7.198061],
              [139.023254, -7.240216],
              [139.170609, -7.236943],
              [139.243729, -7.15057],
              [139.265533, -7.225818],
              [139.42308, -7.233811],
              [139.437164, -7.220868],
              [139.43161, -7.200046],
              [139.383499, -7.200255],
              [139.353729, -7.164835],
              [139.404419, -7.131457],
              [139.472626, -7.171249],
              [139.459442, -7.221426],
              [139.473785, -7.26068],
              [139.541382, -7.284661],
              [139.577698, -7.267271],
              [139.597656, -7.18476],
              [139.648392, -7.177779],
              [139.635056, -7.233941],
              [139.666168, -7.295719],
              [139.690643, -7.288561],
              [139.747726, -7.219747],
              [139.769852, -7.18024],
              [139.763702, -7.129942],
              [139.784821, -7.100969],
              [139.830399, -7.085875],
              [139.802246, -7.078103],
              [139.766602, -7.112126],
              [139.745209, -7.214639],
              [139.698654, -7.24724],
              [139.688766, -7.285228],
              [139.664612, -7.262061],
              [139.656052, -7.18003],
              [139.631943, -7.15506],
              [139.57373, -7.187123],
              [139.56192, -7.26636],
              [139.50708, -7.263996],
              [139.470047, -7.238251],
              [139.474976, -7.148047],
              [139.389664, -7.116319],
              [139.344269, -7.043914],
              [139.258286, -7.016988],
              [139.219482, -7.021232],
              [139.217438, -6.970949],
              [139.134613, -6.956379],
              [138.953888, -6.828889],
              [138.938889, -6.787777],
              [138.91037, -6.780899],
              [138.872955, -6.798277],
              [138.834793, -6.784596],
              [138.824997, -6.691108],
              [138.681107, -6.6075],
              [138.428848, -6.36095],
              [138.441391, -6.327219],
              [138.389999, -6.23194],
              [138.383057, -6.183332],
              [138.403061, -6.18111],
              [138.348969, -6.090442],
              [138.363617, -6.069171],
              [138.288895, -5.939166],
              [138.254166, -5.923331],
              [138.251114, -5.87778],
              [138.401398, -5.83333],
              [138.426193, -5.858562],
              [138.444199, -5.847572],
              [138.466583, -5.884939],
              [138.487595, -5.8637],
              [138.517075, -5.889771],
              [138.53923, -5.887751],
              [138.487228, -5.86228],
              [138.466385, -5.88361],
              [138.444489, -5.846298],
              [138.424393, -5.855866],
              [138.403336, -5.73527],
              [138.405792, -5.818329],
              [138.34938, -5.83769],
              [138.16333, -5.805554],
              [138.15889, -5.753889],
              [138.232498, -5.707777],
              [138.423218, -5.659669],
              [138.339447, -5.653055],
              [138.374756, -5.644679],
              [138.368439, -5.617626],
              [138.307358, -5.589237],
              [138.353058, -5.551871],
              [138.310883, -5.578286],
              [138.286194, -5.61748],
              [138.27417, -5.594721],
              [138.243607, -5.595555],
              [138.262222, -5.565001],
              [138.235001, -5.536666],
              [138.28833, -5.542779],
              [138.254181, -5.540461],
              [138.255646, -5.52691],
              [138.297165, -5.524929],
              [138.259506, -5.532753],
              [138.255829, -5.506388],
              [138.297501, -5.507778],
              [138.255905, -5.505616],
              [138.242188, -5.466599],
              [138.281662, -5.40862],
              [138.198685, -5.481849],
              [138.186066, -5.440681],
              [138.165573, -5.436957],
              [138.133392, -5.481514],
              [138.125793, -5.532678],
              [138.081116, -5.530834],
              [138.094376, -5.501411],
              [138.078049, -5.463055],
              [138.091797, -5.445975],
              [138.076859, -5.463939],
              [138.088699, -5.521059],
              [138.05278, -5.50472],
              [138.058685, -5.386909],
              [138.16185, -5.383855],
              [138.183258, -5.339423],
              [138.239044, -5.326373],
              [138.28566, -5.266903],
              [138.236465, -5.322412],
              [138.177994, -5.333399],
              [138.140244, -5.369929],
              [138.114273, -5.321293],
              [138.131561, -5.312794],
              [138.129532, -5.296389],
              [138.177704, -5.276022],
              [138.181061, -5.234888],
              [138.176834, -5.275101],
              [138.129013, -5.295087],
              [138.112885, -5.320039],
              [138.126999, -5.37387],
              [138.054428, -5.374451],
              [138.051392, -5.433055],
              [138.026642, -5.437757],
              [137.991089, -5.368555],
              [138.049789, -5.371112],
              [138.088348, -5.27899],
              [138.150391, -5.268478],
              [138.141708, -5.197303],
              [138.176849, -5.186413],
              [138.141861, -5.191596],
              [138.147339, -5.267649],
              [138.083145, -5.27842],
              [138.048355, -5.367272],
              [138.001587, -5.358379],
              [137.984024, -5.371354],
              [138.041107, -5.479722],
              [138.028885, -5.505281],
              [137.875275, -5.361939],
              [137.947418, -5.293072],
              [137.994446, -5.2925],
              [138.087784, -5.23],
              [138.047623, -5.189037],
              [138.096298, -5.180214],
              [138.096939, -5.152222],
              [138.067535, -5.139541],
              [138.102127, -5.13235],
              [138.095932, -5.10047],
              [138.111755, -5.11218],
              [138.120285, -5.100556],
              [138.096909, -5.098136],
              [138.102356, -5.130493],
              [138.066498, -5.137029],
              [138.0961, -5.170526],
              [138.044952, -5.18542],
              [138.060837, -5.23278],
              [137.994781, -5.28301],
              [137.960205, -5.27179],
              [137.963333, -5.231944],
              [137.941116, -5.21111],
              [137.951904, -5.197399],
              [137.939163, -5.210278],
              [137.958832, -5.278958],
              [137.909698, -5.321306],
              [137.877228, -5.308056],
              [137.91037, -5.270108],
              [137.876114, -5.303333],
              [137.838608, -5.279999],
              [137.867218, -5.221941],
              [137.912781, -5.210834],
              [137.91806, -5.168331],
              [137.960281, -5.141389],
              [138.021393, -5.139723],
              [137.952774, -5.138611],
              [137.916107, -5.167223],
              [137.902222, -5.214167],
              [137.861389, -5.223611],
              [137.832504, -5.298055],
              [137.746384, -5.35576],
              [137.740829, -5.374444],
              [137.728073, -5.325589],
              [137.825562, -5.23056],
              [137.806107, -5.178473],
              [137.843887, -5.166389],
              [137.887222, -5.100278],
              [137.90889, -5.11889],
              [137.89917, -5.109169],
              [137.914444, -5.095829],
              [137.948059, -5.105557],
              [137.968887, -5.083055],
              [137.930832, -5.040829],
              [137.967224, -5.080279],
              [137.961105, -5.093334],
              [137.915283, -5.09389],
              [137.897781, -5.108889],
              [137.910278, -5.117219],
              [137.88945, -5.0975],
              [137.835831, -5.129166],
              [137.856384, -5.145833],
              [137.802017, -5.179166],
              [137.820282, -5.228612],
              [137.772507, -5.26972],
              [137.777496, -5.202219],
              [137.767776, -5.276389],
              [137.738892, -5.2875],
              [137.735001, -5.255556],
              [137.719528, -5.276592],
              [137.680832, -5.2375],
              [137.685822, -5.20237],
              [137.714172, -5.186945],
              [137.717346, -5.157984],
              [137.74556, -5.184166],
              [137.771118, -5.122233],
              [137.796753, -5.130053],
              [137.778671, -5.09182],
              [137.837708, -5.076876],
              [137.856323, -5.053611],
              [137.83812, -5.075417],
              [137.810272, -5.070417],
              [137.758606, -5.103056],
              [137.748337, -5.138055],
              [137.719452, -5.12028],
              [137.738052, -5.108611],
              [137.73555, -5.090277],
              [137.759583, -5.088611],
              [137.788605, -5.053889],
              [137.804718, -5.068056],
              [137.803604, -5.046939],
              [137.827774, -5.04639],
              [137.804169, -5.04472],
              [137.805832, -5.06639],
              [137.788895, -5.05222],
              [137.734924, -5.086945],
              [137.728394, -5.075208],
              [137.745834, -5.077781],
              [137.756943, -5.04833],
              [137.743896, -5.077222],
              [137.700272, -5.056945],
              [137.749451, -5.010277],
              [137.725006, -5.018056],
              [137.710007, -5.05472],
              [137.681885, -5.05243],
              [137.670502, -5.067969],
              [137.652222, -5.046112],
              [137.668335, -5.028788],
              [137.710556, -5.026332],
              [137.712875, -5.01128],
              [137.665924, -5.02725],
              [137.699081, -4.997439],
              [137.569565, -5.10746],
              [137.595276, -5.059999],
              [137.552505, -5.07263],
              [137.582199, -5.027038],
              [137.595078, -5.022031],
              [137.589127, -5.039639],
              [137.614685, -5.052061],
              [137.640549, -5.02611],
              [137.613556, -5.050661],
              [137.598053, -5.020278],
              [137.625275, -5.025557],
              [137.629379, -5.009692],
              [137.657227, -5.01028],
              [137.679459, -4.99131],
              [137.633636, -5.007355],
              [137.655731, -4.989439],
              [137.628967, -5.005211],
              [137.613617, -4.982547],
              [137.637772, -4.951111],
              [137.619919, -4.95427],
              [137.636337, -4.921067],
              [137.6203, -4.908901],
              [137.677643, -4.86235],
              [137.624222, -4.898518],
              [137.596146, -4.878935],
              [137.614426, -4.885729],
              [137.615723, -4.919128],
              [137.632904, -4.922148],
              [137.615616, -4.929145],
              [137.608093, -4.904179],
              [137.58374, -4.90084],
              [137.618164, -4.93389],
              [137.57988, -4.947223],
              [137.602661, -4.954443],
              [137.570618, -4.987661],
              [137.595551, -5.008055],
              [137.543884, -5.061111],
              [137.551361, -5.116002],
              [137.513962, -5.10728],
              [137.521423, -5.074759],
              [137.496094, -5.079269],
              [137.520874, -5.075976],
              [137.50499, -5.105753],
              [137.530273, -5.123245],
              [137.497177, -5.146317],
              [137.449387, -5.099888],
              [137.453369, -5.069268],
              [137.551117, -5.007791],
              [137.532837, -4.97914],
              [137.567963, -4.952649],
              [137.519592, -5.00266],
              [137.506882, -4.963662],
              [137.534622, -4.90425],
              [137.519028, -4.916176],
              [137.512833, -4.958318],
              [137.498032, -4.863029],
              [137.490372, -4.93494],
              [137.514755, -5.005213],
              [137.455872, -5.045023],
              [137.431671, -5.118589],
              [137.414444, -5.115833],
              [137.434174, -5.051972],
              [137.417221, -5.007223],
              [137.464661, -4.995559],
              [137.45369, -4.940616],
              [137.486435, -4.933999],
              [137.460342, -4.88565],
              [137.469101, -4.924051],
              [137.437317, -4.919075],
              [137.394958, -4.95218],
              [137.336853, -5.042817],
              [137.290665, -5.007679],
              [137.305283, -4.97194],
              [137.336243, -5.005831],
              [137.308609, -4.97],
              [137.364166, -4.97],
              [137.37944, -4.90389],
              [137.424728, -4.911666],
              [137.386383, -4.900277],
              [137.4375, -4.83833],
              [137.37056, -4.91],
              [137.331268, -4.846252],
              [137.368652, -4.891006],
              [137.369171, -4.925279],
              [137.349716, -4.97],
              [137.294647, -4.952153],
              [137.285294, -5.026015],
              [137.235596, -4.98977],
              [137.275009, -4.910381],
              [137.306946, -4.916944],
              [137.32103, -4.888448],
              [137.296661, -4.91278],
              [137.262375, -4.862608],
              [137.283447, -4.895315],
              [137.228455, -4.956563],
              [137.205627, -4.934858],
              [137.216599, -4.898372],
              [137.201218, -4.887019],
              [137.223679, -4.86581],
              [137.215042, -4.851497],
              [137.243774, -4.835383],
              [137.234619, -4.815379],
              [137.241043, -4.837099],
              [137.217072, -4.841949],
              [137.198929, -4.886048],
              [137.196808, -4.931351],
              [137.223663, -4.95997],
              [137.179993, -5.008611],
              [137.125, -4.964166],
              [137.13237, -4.90512],
              [137.16507, -4.90713],
              [137.142685, -4.885969],
              [137.178375, -4.887749],
              [137.211868, -4.843461],
              [137.17778, -4.885],
              [137.158646, -4.875339],
              [137.178055, -4.840555],
              [137.171707, -4.86604],
              [137.154037, -4.860249],
              [137.166626, -4.811603],
              [137.151871, -4.775251],
              [137.164413, -4.813178],
              [137.14856, -4.83271],
              [137.156601, -4.871111],
              [137.121964, -4.898376],
              [137.107773, -4.974721],
              [137.057785, -4.938612],
              [137.10643, -4.8794],
              [137.088455, -4.859736],
              [137.126877, -4.839812],
              [137.130676, -4.821499],
              [137.117126, -4.84292],
              [137.085022, -4.829271],
              [137.092728, -4.786487],
              [137.067596, -4.802947],
              [137.091797, -4.806379],
              [137.082443, -4.826791],
              [137.100662, -4.843472],
              [137.064194, -4.858589],
              [137.051727, -4.81478],
              [137.057465, -4.867086],
              [137.031662, -4.883056],
              [137.06189, -4.918713],
              [137.016602, -4.91996],
              [137.005524, -4.893362],
              [137.026108, -4.923059],
              [136.976257, -4.939583],
              [136.924591, -4.890449],
              [136.964447, -4.884722],
              [136.959946, -4.870778],
              [136.996536, -4.859626],
              [137.009384, -4.83132],
              [136.994171, -4.858056],
              [136.984833, -4.834018],
              [136.988907, -4.860497],
              [136.925003, -4.870833],
              [136.922073, -4.831021],
              [136.912643, -4.873709],
              [136.88269, -4.860162],
              [136.872772, -4.836671],
              [136.884445, -4.820277],
              [136.855881, -4.820006],
              [136.886108, -4.783888],
              [136.834473, -4.81917],
              [136.863327, -4.749166],
              [136.853607, -4.723888],
              [136.830551, -4.815555],
              [136.845551, -4.82758],
              [136.814102, -4.81142],
              [136.787338, -4.831839],
              [136.783127, -4.814169],
              [136.823959, -4.784859],
              [136.790024, -4.801367],
              [136.777283, -4.77061],
              [136.793686, -4.759283],
              [136.775238, -4.770323],
              [136.76973, -4.755557],
              [136.750717, -4.758848],
              [136.743195, -4.735069],
              [136.783615, -4.791945],
              [136.757782, -4.78583],
              [136.766937, -4.809166],
              [136.72226, -4.803013],
              [136.768326, -4.813333],
              [136.743332, -4.872779],
              [136.689438, -4.844445],
              [136.691116, -4.795555],
              [136.679932, -4.817713],
              [136.674576, -4.79347],
              [136.645828, -4.831459],
              [136.654541, -4.808576],
              [136.632034, -4.827103],
              [136.568893, -4.797082],
              [136.610962, -4.776591],
              [136.573486, -4.77887],
              [136.579926, -4.73576],
              [136.583038, -4.762241],
              [136.544449, -4.790555],
              [136.558548, -4.765355],
              [136.543259, -4.748958],
              [136.547531, -4.7741],
              [136.500412, -4.753264],
              [136.518753, -4.72222],
              [136.511093, -4.744961],
              [136.465088, -4.73842],
              [136.458893, -4.682219],
              [136.434174, -4.728512],
              [136.421249, -4.69368],
              [136.323303, -4.665585],
              [136.350357, -4.633609],
              [136.295029, -4.67434],
              [136.285126, -4.646466],
              [136.281799, -4.669376],
              [136.231384, -4.66257],
              [136.213058, -4.614722],
              [136.232224, -4.583329],
              [136.200317, -4.633944],
              [136.209305, -4.659304],
              [136.140549, -4.631945],
              [136.1875, -4.616944],
              [136.133362, -4.62563],
              [136.162018, -4.586597],
              [136.163605, -4.552219],
              [136.113892, -4.622781],
              [136.075485, -4.592074],
              [136.089447, -4.55972],
              [136.053055, -4.5875],
              [136.046036, -4.566249],
              [136.06778, -4.557778],
              [136.056229, -4.546981],
              [136.070343, -4.529861],
              [136.047775, -4.496945],
              [136.072495, -4.4825],
              [136.073059, -4.451805],
              [136.046387, -4.496389],
              [136.059723, -4.518889],
              [136.045013, -4.520808],
              [136.051392, -4.536944],
              [136.021164, -4.538193],
              [136.01915, -4.550833],
              [135.908188, -4.483339],
              [135.718887, -4.497223],
              [135.416977, -4.429519],
              [135.349716, -4.438889],
              [135.40889, -4.428888],
              [135.35611, -4.414719],
              [135.338669, -4.44479],
              [135.199768, -4.463722],
              [135.11908, -4.397203],
              [135.09639, -4.408057],
              [135.060562, -4.385001],
              [135.078873, -4.373259],
              [135.039795, -4.375563],
              [135.015274, -4.337818],
              [135.011948, -4.350281],
              [134.928589, -4.29995],
              [135.000839, -4.335765],
              [134.989441, -4.329445],
              [134.998428, -4.305543],
              [134.998886, -4.322361],
              [134.979721, -4.324169],
              [134.87616, -4.251943],
              [135.25766, -3.75588],
              [134.205246, -3.391239],
              [134.27594, -3.23835],
              [134.425034, -3.110369],
              [134.426788, -3.006559],
              [134.661392, -2.823219],
              [134.688339, -2.965833],
              [134.740005, -2.990555],
              [134.776672, -2.985279],
              [134.777771, -2.940829],
              [134.819168, -2.938611],
              [134.804169, -2.911667],
              [134.831161, -2.91347],
              [134.828888, -2.877499],
              [134.853058, -2.886668],
              [134.83194, -2.963055],
              [134.852753, -3.00157],
              [134.81105, -3.037865],
              [134.837784, -3.095831],
              [134.813553, -3.08191],
              [134.800629, -3.131394],
              [134.831635, -3.124849],
              [134.862289, -3.158792],
              [134.861557, -3.250149],
              [134.935944, -3.271329],
              [134.916977, -3.244816],
              [134.960007, -3.225279],
              [134.945831, -3.284169],
              [134.971939, -3.314721],
              [135.070618, -3.333921],
              [135.113922, -3.381292],
              [135.337784, -3.399168],
              [135.501968, -3.357546],
              [135.611282, -3.180421],
              [135.760956, -3.099078],
              [135.785873, -3.109717],
              [135.733948, -3.06395],
              [135.910553, -2.979166],
              [135.935486, -2.916109],
              [135.965057, -2.92696],
              [135.904999, -2.86861],
              [135.950562, -2.820001],
              [135.947495, -2.77917],
              [135.990082, -2.77009],
              [136.017731, -2.691776],
              [136.185013, -2.639112],
              [136.266083, -2.562176],
              [136.295883, -2.41113],
              [136.346664, -2.370277],
              [136.33223, -2.279722],
              [136.392654, -2.218956],
              [136.518143, -2.19077],
              [136.535141, -2.222489],
              [136.581741, -2.201986],
              [136.598709, -2.27059],
              [136.640823, -2.246155],
              [136.655609, -2.277758],
              [136.706421, -2.22702],
              [136.749146, -2.26798],
              [136.793533, -2.210915],
              [136.81073, -2.234741],
              [136.805161, -2.176717],
              [136.913895, -2.182777],
              [136.942215, -2.120279],
              [137.027176, -2.147546],
              [137.035324, -2.20457],
              [137.038681, -2.183144],
              [137.062576, -2.167899],
              [137.031235, -2.168865],
              [137.030853, -2.146974],
              [137.004715, -2.128333],
              [137.027252, -2.114966],
              [137.031235, -2.144123],
              [137.057602, -2.098139],
              [137.149048, -2.139998],
              [137.121948, -2.102294],
              [137.186279, -2.12408],
              [137.158966, -2.095534],
              [137.175613, -2.078479],
              [137.195541, -2.09764],
              [137.195679, -2.066915],
              [137.21167, -2.086944],
              [137.227066, -2.069857],
              [137.257874, -2.115513],
              [137.225052, -2.066614],
              [137.250519, -2.05105],
              [137.252502, -2.08639],
              [137.275803, -2.104687],
              [137.251404, -2.073809],
              [137.265396, -2.04078],
              [137.211685, -2.029968],
              [137.223068, -2.01325],
              [137.255707, -2.01153],
              [137.206161, -2.021535],
              [137.189163, -1.990279],
              [137.217224, -1.98333],
              [137.221603, -2.009503],
              [137.266937, -1.987779],
              [137.230438, -2.000925],
              [137.196945, -1.963055],
              [137.220551, -1.960279],
              [137.182495, -1.937779],
              [137.219452, -1.938611],
              [137.258057, -1.903059],
              [137.236893, -1.87196],
              [137.21666, -1.886669],
              [137.193329, -1.859169],
              [137.205826, -1.843612],
              [137.153122, -1.771874],
              [137.226944, -1.74833],
              [137.299438, -1.82722],
              [137.365829, -1.840829],
              [137.42778, -1.809439],
              [137.475998, -1.83778],
              [137.428329, -1.807777],
              [137.402222, -1.809446],
              [137.39473, -1.76361],
              [137.360275, -1.76],
              [137.354446, -1.708612],
              [137.331116, -1.689789],
              [137.394791, -1.6584],
              [137.429214, -1.671332],
              [137.401947, -1.653056],
              [137.441666, -1.62889],
              [137.45639, -1.662222],
              [137.44194, -1.639445],
              [137.47319, -1.606318],
              [137.48111, -1.634722],
              [137.503326, -1.643333],
              [137.491318, -1.670689],
              [137.519165, -1.672223],
              [137.492569, -1.670555],
              [137.504166, -1.642223],
              [137.475555, -1.618611],
              [137.524994, -1.62639],
              [137.477966, -1.597864],
              [137.531113, -1.578056],
              [137.52507, -1.604449],
              [137.580826, -1.55583],
              [137.585556, -1.585833],
              [137.603119, -1.57951],
              [137.607773, -1.608057],
              [137.642227, -1.62528],
              [137.603058, -1.57833],
              [137.585831, -1.580556],
              [137.63591, -1.561457],
              [137.633606, -1.593889],
              [137.637497, -1.561667],
              [137.592438, -1.552847],
              [137.636948, -1.528888],
              [137.634995, -1.54778],
              [137.65834, -1.550349],
              [137.636108, -1.54667],
              [137.648056, -1.51972],
              [137.727219, -1.493056],
              [137.75708, -1.546461],
              [137.793549, -1.54771],
              [137.796951, -1.52694],
              [137.753052, -1.538333],
              [137.741394, -1.481111],
              [137.809723, -1.49611],
              [137.778336, -1.480001],
              [137.83667, -1.461668],
              [137.934998, -1.458611],
              [137.970001, -1.531667],
              [137.950623, -1.520478],
              [137.913956, -1.55632],
              [137.953613, -1.537987],
              [137.93486, -1.587294],
              [137.964996, -1.542778],
              [137.962784, -1.584723],
              [138.000443, -1.63421],
              [137.963028, -1.62002],
              [137.921738, -1.634652],
              [137.954361, -1.654879],
              [137.953766, -1.62561],
              [138.00296, -1.640575],
              [138, -1.605278],
              [138.01889, -1.626944],
              [138.128326, -1.646109],
              [138.034485, -1.609399],
              [137.979996, -1.57028],
              [137.981049, -1.52854],
              [138.071808, -1.60333],
              [138.341309, -1.71601],
              [138.652985, -1.787329],
              [138.751114, -1.84611],
              [138.748062, -1.86667],
              [138.789734, -1.920396],
              [138.863342, -1.965819],
              [139, -1.975],
              [139.751251, -2.359654],
              [139.809998, -2.37778],
              [140.055222, -2.360203],
              [140.111282, -2.319439],
              [140.143158, -2.348534],
              [140.143417, -2.322349],
              [140.153885, -2.371111],
              [140.211105, -2.409444],
              [140.253586, -2.400959],
              [140.337006, -2.464859],
              [140.371384, -2.457221],
              [140.348801, -2.395277],
              [140.497955, -2.444],
              [140.612717, -2.43861],
              [140.686661, -2.477779],
            ],
          ],
          [
            [
              [137.988617, -1.571112],
              [138.024155, -1.600109],
              [138.023483, -1.616599],
              [137.980133, -1.583469],
              [137.988617, -1.571112],
            ],
          ],
          [
            [
              [137.978058, -1.581944],
              [138.012772, -1.607222],
              [137.98111, -1.59639],
              [137.975525, -1.569188],
              [137.978058, -1.581944],
            ],
          ],
          [
            [
              [138.716949, -1.57972],
              [138.747498, -1.625],
              [138.710556, -1.609445],
              [138.716949, -1.57972],
            ],
          ],
          [
            [
              [138.799728, -1.66194],
              [138.797577, -1.707807],
              [138.789169, -1.672499],
              [138.799728, -1.66194],
            ],
          ],
          [
            [
              [139.008606, -1.93222],
              [139.025116, -1.934025],
              [139.018188, -1.948651],
              [138.99884, -1.93779],
              [139.008606, -1.93222],
            ],
          ],
          [
            [
              [137.632217, -5.07833],
              [137.648895, -5.05111],
              [137.671387, -5.07],
              [137.694168, -5.05472],
              [137.725281, -5.087779],
              [137.716736, -5.121875],
              [137.742249, -5.136425],
              [137.704727, -5.14889],
              [137.670837, -5.216389],
              [137.550064, -5.169653],
              [137.664169, -5.117221],
              [137.677567, -5.094309],
              [137.665344, -5.075069],
              [137.661667, -5.116667],
              [137.604721, -5.103888],
              [137.632217, -5.07833],
            ],
          ],
          [
            [
              [137.726868, -5.07583],
              [137.732224, -5.111806],
              [137.715134, -5.10132],
              [137.726868, -5.07583],
            ],
          ],
          [
            [
              [137.574783, -5.109547],
              [137.599365, -5.096743],
              [137.62973, -5.127717],
              [137.547607, -5.142501],
              [137.574783, -5.109547],
            ],
          ],
          [
            [
              [137.775558, -5.108889],
              [137.794235, -5.12882],
              [137.771118, -5.119439],
              [137.743332, -5.182222],
              [137.717224, -5.155],
              [137.705826, -5.185],
              [137.705826, -5.153334],
              [137.752441, -5.137569],
              [137.759171, -5.104166],
              [137.775558, -5.108889],
            ],
          ],
          [
            [
              [137.76973, -5.359721],
              [137.780548, -5.334439],
              [137.843338, -5.285556],
              [137.892227, -5.329723],
              [137.838882, -5.375554],
              [137.76973, -5.359721],
            ],
          ],
          [
            [
              [138.156113, -5.462446],
              [138.177704, -5.439199],
              [138.201935, -5.485814],
              [138.240051, -5.447612],
              [138.254654, -5.534579],
              [138.234222, -5.536142],
              [138.231247, -5.553288],
              [138.260788, -5.565427],
              [138.243408, -5.597385],
              [138.277359, -5.60064],
              [138.239975, -5.611981],
              [138.24675, -5.666887],
              [138.213333, -5.67333],
              [138.183304, -5.72805],
              [138.134445, -5.718888],
              [138.089371, -5.745764],
              [138.045273, -5.598889],
              [138.064636, -5.556417],
              [138.133392, -5.536582],
              [138.156113, -5.462446],
            ],
          ],
          [
            [
              [138.372345, -5.631629],
              [138.372818, -5.645044],
              [138.341003, -5.647079],
              [138.3405, -5.659877],
              [138.225037, -5.68639],
              [138.250809, -5.663958],
              [138.243561, -5.611985],
              [138.286118, -5.619167],
              [138.339172, -5.595831],
              [138.372345, -5.631629],
            ],
          ],
          [
            [
              [138.219986, -5.699447],
              [138.204453, -5.712554],
              [138.219543, -5.67475],
              [138.219986, -5.699447],
            ],
          ],
          [
            [
              [135.823059, -1.064444],
              [135.773636, -0.875779],
              [135.740829, -0.810277],
              [135.708328, -0.802501],
              [135.729584, -0.77534],
              [135.642212, -0.886614],
              [135.467422, -0.74415],
              [135.542496, -0.839051],
              [135.541382, -0.875561],
              [135.50972, -0.827266],
              [135.483185, -0.81471],
              [135.489319, -0.805698],
              [135.393799, -0.723137],
              [135.363052, -0.63056],
              [135.533615, -0.673333],
              [135.589767, -0.663129],
              [135.595291, -0.70156],
              [135.64328, -0.662539],
              [135.68512, -0.71941],
              [135.717468, -0.70734],
              [135.748367, -0.739628],
              [135.80545, -0.685597],
              [135.854996, -0.700555],
              [135.924622, -0.790082],
              [136.051392, -0.856669],
              [136.039993, -0.89528],
              [136.091095, -0.916307],
              [136.170898, -1.042747],
              [136.256104, -1.016666],
              [136.323883, -1.073889],
              [136.387589, -1.076979],
              [136.315704, -1.13999],
              [136.139725, -1.20047],
              [136, -1.1425],
              [135.873337, -1.17333],
              [135.802216, -1.09861],
              [135.823059, -1.064444],
            ],
          ],
          [
            [
              [134.865616, -1.132207],
              [134.794449, -1.0325],
              [134.810608, -0.980829],
              [134.791916, -0.98111],
              [134.843536, -0.93096],
              [134.941528, -0.965931],
              [134.946854, -0.99929],
              [134.925003, -1.074723],
              [134.972229, -1.01083],
              [134.98584, -1.036112],
              [134.952164, -1.128141],
              [134.865616, -1.132207],
            ],
          ],
          [
            [
              [136.618332, -1.144722],
              [136.600555, -1.173061],
              [136.597931, -1.140549],
              [136.618332, -1.144722],
            ],
          ],
          [
            [
              [136.597504, -1.189167],
              [136.615051, -1.218769],
              [136.589996, -1.2275],
              [136.575912, -1.198749],
              [136.597504, -1.189167],
            ],
          ],
          [
            [
              [136.448471, -1.240008],
              [136.429825, -1.213009],
              [136.442581, -1.1992],
              [136.448471, -1.240008],
            ],
          ],
          [
            [
              [136.323914, -1.217178],
              [136.344635, -1.236434],
              [136.294739, -1.240503],
              [136.323914, -1.217178],
            ],
          ],
          [
            [
              [136.521667, -1.226666],
              [136.539108, -1.239675],
              [136.500702, -1.239311],
              [136.521667, -1.226666],
            ],
          ],
          [
            [
              [136.220123, -1.22892],
              [136.206329, -1.256306],
              [136.188354, -1.2483],
              [136.220123, -1.22892],
            ],
          ],
          [
            [
              [136.604172, -1.22861],
              [136.616837, -1.236922],
              [136.60878, -1.25436],
              [136.59375, -1.244999],
              [136.604172, -1.22861],
            ],
          ],
          [
            [
              [136.650345, -1.258679],
              [136.662201, -1.34517],
              [136.600372, -1.320721],
              [136.588333, -1.275829],
              [136.619873, -1.24419],
              [136.650345, -1.258679],
            ],
          ],
          [
            [
              [138.736664, -6.651109],
              [138.821671, -6.706112],
              [138.831116, -6.789719],
              [138.875, -6.803611],
              [138.927505, -6.787777],
              [138.944717, -6.82611],
              [138.835281, -6.826391],
              [138.752777, -6.75083],
              [138.672775, -6.724167],
              [138.671951, -6.640279],
              [138.736664, -6.651109],
            ],
          ],
          [
            [
              [138.674728, -6.753055],
              [138.736115, -6.759439],
              [138.798889, -6.834999],
              [138.728333, -6.883611],
              [138.679169, -6.86917],
              [138.66861, -6.838609],
              [138.696671, -6.831667],
              [138.700562, -6.809445],
              [138.675003, -6.834723],
              [138.610275, -6.755277],
              [138.635498, -6.729222],
              [138.674728, -6.753055],
            ],
          ],
          [
            [
              [139.348892, -7.191886],
              [139.429672, -7.217217],
              [139.273407, -7.21773],
              [139.261368, -7.15547],
              [139.238541, -7.139749],
              [139.201248, -7.156321],
              [139.179718, -7.2135],
              [139.159592, -7.202781],
              [139.06456, -7.211061],
              [138.935654, -7.159518],
              [138.855499, -7.157715],
              [138.613663, -7.010989],
              [138.565552, -6.918889],
              [138.626663, -6.87611],
              [138.717224, -6.90222],
              [138.798828, -6.850365],
              [138.934448, -6.842219],
              [139.128784, -6.966357],
              [139.187759, -6.97306],
              [139.224091, -6.99824],
              [139.219162, -7.025279],
              [139.344315, -7.047271],
              [139.380539, -7.112805],
              [139.338058, -7.165287],
              [139.348892, -7.191886],
            ],
          ],
          [
            [
              [139.778641, -7.11203],
              [139.765869, -7.121571],
              [139.782822, -7.101749],
              [139.778641, -7.11203],
            ],
          ],
          [
            [
              [138.765839, -7.16701],
              [138.716339, -7.156767],
              [138.713959, -7.116509],
              [138.759338, -7.144841],
              [138.765839, -7.16701],
            ],
          ],
          [
            [
              [138.791992, -7.16389],
              [138.781143, -7.14949],
              [138.806412, -7.159609],
              [138.791992, -7.16389],
            ],
          ],
          [
            [
              [138.992355, -7.200771],
              [139.029861, -7.223701],
              [138.960587, -7.196493],
              [138.992355, -7.200771],
            ],
          ],
          [
            [
              [139.651947, -7.205833],
              [139.676086, -7.288565],
              [139.655609, -7.286751],
              [139.639862, -7.223539],
              [139.651947, -7.205833],
            ],
          ],
          [
            [
              [139.160416, -7.208007],
              [139.17189, -7.215815],
              [139.144318, -7.211838],
              [139.160416, -7.208007],
            ],
          ],
          [
            [
              [135.239502, -1.483889],
              [135.253326, -1.52139],
              [135.262192, -1.478369],
              [135.337967, -1.482462],
              [135.325317, -1.509429],
              [135.247437, -1.529691],
              [135.092072, -1.501065],
              [135.117783, -1.4625],
              [135.154831, -1.489979],
              [135.215729, -1.474511],
              [135.221893, -1.50746],
              [135.239502, -1.483889],
            ],
          ],
          [
            [
              [136.18689, -1.870264],
              [135.978058, -1.816944],
              [135.911942, -1.754719],
              [135.899445, -1.788056],
              [135.867218, -1.740278],
              [135.864716, -1.767778],
              [135.845001, -1.746667],
              [135.829163, -1.76528],
              [135.821945, -1.73528],
              [135.762497, -1.748889],
              [135.788895, -1.71944],
              [135.751389, -1.721111],
              [135.732224, -1.68861],
              [135.672501, -1.706944],
              [135.553925, -1.66302],
              [135.474167, -1.680834],
              [135.465561, -1.63611],
              [135.410278, -1.601944],
              [135.785553, -1.62611],
              [135.846115, -1.63722],
              [135.85083, -1.66194],
              [135.89917, -1.63472],
              [136.20311, -1.64816],
              [136.370667, -1.717186],
              [136.445633, -1.697759],
              [136.789688, -1.73943],
              [136.903732, -1.793248],
              [136.848068, -1.82756],
              [136.718781, -1.816415],
              [136.630951, -1.872919],
              [136.503586, -1.849189],
              [136.536072, -1.899107],
              [136.341843, -1.860849],
              [136.275558, -1.883385],
              [136.259796, -1.913474],
              [136.251984, -1.887713],
              [136.229462, -1.909598],
              [136.18689, -1.870264],
            ],
          ],
          [
            [
              [135.789169, -1.759168],
              [135.792496, -1.771389],
              [135.765274, -1.772223],
              [135.789169, -1.759168],
            ],
          ],
          [
            [
              [135.813263, -1.784792],
              [135.824982, -1.803397],
              [135.804428, -1.817163],
              [135.794281, -1.80024],
              [135.813263, -1.784792],
            ],
          ],
          [
            [
              [137.02417, -1.830833],
              [137.054443, -1.869444],
              [136.950394, -1.83829],
              [137.02417, -1.830833],
            ],
          ],
          [
            [
              [136.363892, -1.886389],
              [136.372772, -1.898056],
              [136.358612, -1.903059],
              [136.363892, -1.886389],
            ],
          ],
          [
            [
              [136.28215, -1.88671],
              [136.316437, -1.904517],
              [136.299057, -1.934199],
              [136.252518, -1.936765],
              [136.28215, -1.88671],
            ],
          ],
          [
            [
              [136.33139, -1.905832],
              [136.357498, -1.905279],
              [136.36084, -1.962777],
              [136.330551, -1.935001],
              [136.33139, -1.905832],
            ],
          ],
          [
            [
              [139.641342, -7.166201],
              [139.639542, -7.180967],
              [139.629395, -7.166479],
              [139.584839, -7.185022],
              [139.641342, -7.166201],
            ],
          ],
          [
            [
              [139.582672, -7.199419],
              [139.574646, -7.245232],
              [139.566711, -7.226402],
              [139.589844, -7.19128],
              [139.582672, -7.199419],
            ],
          ],
          [
            [
              [138.238281, -7.461789],
              [138.418365, -7.40394],
              [138.749786, -7.370584],
              [138.865005, -7.436666],
              [138.912949, -7.53501],
              [139.087479, -7.572639],
              [138.994293, -7.74785],
              [138.993958, -7.849852],
              [138.896149, -7.899531],
              [138.888885, -8.03513],
              [138.913895, -8.075277],
              [138.827499, -8.079165],
              [138.794449, -8.13972],
              [138.678604, -8.150555],
              [138.615005, -8.249722],
              [138.488052, -8.321387],
              [138.468887, -8.350834],
              [138.340271, -8.379444],
              [138.323883, -8.370279],
              [138.33194, -8.300556],
              [138.300827, -8.391945],
              [137.870834, -8.373609],
              [137.656387, -8.44694],
              [137.63945, -8.416108],
              [137.705826, -8.172501],
              [137.80986, -8.041252],
              [137.79834, -8],
              [137.906097, -7.787568],
              [137.968765, -7.734963],
              [138.049286, -7.599432],
              [138.238281, -7.461789],
            ],
          ],
          [
            [
              [140.057495, -8],
              [140.072754, -8.043889],
              [140.05365, -8.022773],
              [140.057495, -8],
            ],
          ],
          [
            [
              [138.892502, -8.388057],
              [138.59639, -8.363333],
              [138.554031, -8.317221],
              [138.662506, -8.235833],
              [138.679443, -8.16972],
              [138.745285, -8.16528],
              [138.815002, -8.137778],
              [138.846115, -8.263055],
              [138.916107, -8.300055],
              [138.892502, -8.388057],
            ],
          ],
          [
            [
              [138.853058, -8.206389],
              [138.88681, -8.238333],
              [138.890274, -8.267221],
              [138.848343, -8.254039],
              [138.853058, -8.206389],
            ],
          ],
          [
            [
              [138.846939, -8.25472],
              [138.900833, -8.282498],
              [138.880829, -8.286945],
              [138.846939, -8.25472],
            ],
          ],
          [
            [
              [138.9375, -8.320277],
              [138.98111, -8.335279],
              [138.95166, -8.341667],
              [138.9375, -8.320277],
            ],
          ],
          [
            [
              [138.476105, -8.359444],
              [138.34639, -8.41944],
              [138.261673, -8.415559],
              [138.26445, -8.390828],
              [138.303329, -8.394999],
              [138.47139, -8.352778],
              [138.499451, -8.320829],
              [138.476105, -8.359444],
            ],
          ],
          [
            [
              [138.925827, -8.32361],
              [138.970276, -8.365555],
              [138.926117, -8.361945],
              [138.925827, -8.32361],
            ],
          ],
          [
            [
              [136.0336, -4.543684],
              [136.052338, -4.53639],
              [136.047501, -4.520831],
              [136.069244, -4.528965],
              [136.055054, -4.547481],
              [136.06691, -4.554398],
              [136.046677, -4.557589],
              [136.038391, -4.578921],
              [135.986526, -4.542084],
              [136.0336, -4.543684],
            ],
          ],
          [
            [
              [136.212494, -4.625279],
              [136.21167, -4.653333],
              [136.211395, -4.61472],
              [136.212494, -4.625279],
            ],
          ],
          [
            [
              [136.783844, -4.800275],
              [136.792496, -4.807291],
              [136.777893, -4.822709],
              [136.783844, -4.800275],
            ],
          ],
          [
            [
              [136.682083, -4.825362],
              [136.680832, -4.849443],
              [136.651459, -4.8268],
              [136.673447, -4.810445],
              [136.682083, -4.825362],
            ],
          ],
          [
            [
              [136.787216, -4.836388],
              [136.794312, -4.849026],
              [136.777771, -4.869718],
              [136.767227, -4.855556],
              [136.787216, -4.836388],
            ],
          ],
          [
            [
              [136.850891, -4.83077],
              [136.905563, -4.874452],
              [136.831451, -4.914025],
              [136.794998, -4.888334],
              [136.836945, -4.870831],
              [136.789032, -4.88345],
              [136.808517, -4.833339],
              [136.850891, -4.83077],
            ],
          ],
          [
            [
              [137.069458, -4.862466],
              [137.079391, -4.883259],
              [137.05806, -4.893611],
              [137.055145, -4.849776],
              [137.069458, -4.862466],
            ],
          ],
          [
            [
              [137.410934, -4.958318],
              [137.436829, -4.921295],
              [137.476303, -4.92868],
              [137.45314, -4.938498],
              [137.448639, -4.99531],
              [137.414169, -5.004723],
              [137.405579, -5.109431],
              [137.337982, -5.052601],
              [137.410934, -4.958318],
            ],
          ],
          [
            [
              [137.616577, -4.958748],
              [137.618896, -5.02194],
              [137.575302, -4.987336],
              [137.616577, -4.958748],
            ],
          ],
          [
            [
              [137.50972, -5.171941],
              [137.507141, -5.198541],
              [137.496109, -5.185281],
              [137.50972, -5.171941],
            ],
          ],
          [
            [
              [134.817627, -2.681377],
              [134.863327, -2.7075],
              [134.804443, -2.711944],
              [134.817627, -2.681377],
            ],
          ],
          [
            [
              [135.730316, -2.91161],
              [135.718063, -2.929645],
              [135.672134, -2.94229],
              [135.730316, -2.91161],
            ],
          ],
          [
            [
              [135.769165, -2.933611],
              [135.806946, -2.94306],
              [135.708496, -2.972639],
              [135.729828, -2.941041],
              [135.769165, -2.933611],
            ],
          ],
          [
            [
              [135.611801, -3.06994],
              [135.625916, -3.077431],
              [135.619553, -3.097629],
              [135.611801, -3.06994],
            ],
          ],
          [
            [
              [135.268097, -0.391721],
              [135.278336, -0.406945],
              [135.267563, -0.410619],
              [135.268097, -0.391721],
            ],
          ],
          [
            [
              [135.491287, -0.93065],
              [135.509216, -0.967496],
              [135.4935, -0.964363],
              [135.491287, -0.93065],
            ],
          ],
          [
            [
              [137.361664, -1.763056],
              [137.401947, -1.78667],
              [137.360138, -1.839236],
              [137.320007, -1.798611],
              [137.271118, -1.785278],
              [137.241943, -1.74111],
              [137.343338, -1.696667],
              [137.361664, -1.763056],
            ],
          ],
          [
            [
              [137.123337, -1.888055],
              [137.091949, -1.826389],
              [137.140274, -1.772501],
              [137.162781, -1.796666],
              [137.138336, -1.8475],
              [137.160828, -1.932362],
              [137.123337, -1.888055],
            ],
          ],
          [
            [
              [137.274719, -1.79111],
              [137.311951, -1.800001],
              [137.323792, -1.822457],
              [137.299591, -1.825001],
              [137.274719, -1.79111],
            ],
          ],
          [
            [
              [137.165833, -1.86778],
              [137.142105, -1.846445],
              [137.17775, -1.806419],
              [137.213058, -1.890555],
              [137.165833, -1.86778],
            ],
          ],
          [
            [
              [137.087494, -1.85566],
              [137.111938, -1.87611],
              [137.093933, -1.895802],
              [137.087494, -1.85566],
            ],
          ],
          [
            [
              [137.180557, -1.878057],
              [137.212296, -1.892709],
              [137.231674, -1.871939],
              [137.256104, -1.90694],
              [137.174728, -1.940279],
              [137.180557, -1.878057],
            ],
          ],
          [
            [
              [137.199997, -1.972219],
              [137.213333, -1.982222],
              [137.197083, -1.985486],
              [137.199997, -1.972219],
            ],
          ],
          [
            [
              [136.269501, -2.222935],
              [136.248444, -2.228918],
              [136.257401, -2.215674],
              [136.269501, -2.222935],
            ],
          ],
        ],
      },
      id: 91,
      properties: {
        ID: 16,
        kode: 91,
        provinsi: "PAPUA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [122.6195, -8.40327],
              [122.6706, -8.39535],
              [122.729, -8.36376],
              [122.7693, -8.36789],
              [122.8147, -8.30079],
              [122.877, -8.29701],
              [122.8978, -8.27617],
              [122.9248, -8.19796],
              [122.8688, -8.17643],
              [122.8155, -8.19872],
              [122.7905, -8.23832],
              [122.7432, -8.21051],
              [122.7834, -8.16046],
              [122.7859, -8.11148],
              [122.8321, -8.10133],
              [122.8691, -8.06508],
              [122.9764, -8.14032],
              [122.9647, -8.19849],
              [123.0159, -8.27969],
              [123.0215, -8.32064],
              [122.9648, -8.3543],
              [122.9302, -8.33062],
              [122.8828, -8.38951],
              [122.8928, -8.45255],
              [122.7916, -8.43101],
              [122.783, -8.46163],
              [122.8367, -8.52308],
              [122.8381, -8.59432],
              [122.73, -8.6417],
              [122.6701, -8.63274],
              [122.5684, -8.67269],
              [122.5333, -8.71705],
              [122.3794, -8.76204],
              [122.3508, -8.75008],
              [122.2867, -8.764],
              [122.1999, -8.75926],
              [122.1256, -8.73763],
              [122.0858, -8.75021],
              [122.0352, -8.80331],
              [121.9284, -8.8417],
              [121.8651, -8.84578],
              [121.8184, -8.88101],
              [121.7381, -8.88868],
              [121.718, -8.86764],
              [121.6379, -8.85644],
              [121.5642, -8.81199],
              [121.5405, -8.82249],
              [121.3854, -8.79636],
              [121.3637, -8.82703],
              [121.3611, -8.89566],
              [121.3111, -8.92514],
              [121.2515, -8.90006],
              [121.1267, -8.90792],
              [121.0708, -8.9397],
              [120.9975, -8.9596],
              [120.9069, -8.92252],
              [120.8565, -8.87337],
              [120.827, -8.82198],
              [120.7782, -8.83222],
              [120.7668, -8.87329],
              [120.7266, -8.87758],
              [120.6248, -8.83975],
              [120.6032, -8.80507],
              [120.5406, -8.79251],
              [120.5014, -8.80494],
              [120.3745, -8.79988],
              [120.3207, -8.83812],
              [120.2396, -8.83066],
              [120.1793, -8.77632],
              [120.1168, -8.78019],
              [120.0637, -8.80548],
              [119.9371, -8.8341],
              [119.8216, -8.78411],
              [119.7994, -8.73838],
              [119.8127, -8.65842],
              [119.8019, -8.57549],
              [119.9154, -8.46571],
              [119.9588, -8.44277],
              [120.0002, -8.45481],
              [120.0043, -8.40762],
              [120.034, -8.37535],
              [120.0896, -8.38059],
              [120.1253, -8.35436],
              [120.1542, -8.37109],
              [120.2008, -8.29826],
              [120.26, -8.27393],
              [120.4055, -8.27102],
              [120.4419, -8.23714],
              [120.4648, -8.28285],
              [120.5241, -8.2609],
              [120.5603, -8.29137],
              [120.6582, -8.28036],
              [120.6896, -8.32071],
              [120.7431, -8.34189],
              [120.8114, -8.3341],
              [120.8595, -8.35319],
              [120.9799, -8.34873],
              [120.9947, -8.39561],
              [121.1606, -8.44687],
              [121.1876, -8.44131],
              [121.2386, -8.47818],
              [121.306, -8.49264],
              [121.3439, -8.5619],
              [121.4223, -8.58897],
              [121.4573, -8.56206],
              [121.5044, -8.61735],
              [121.6049, -8.54726],
              [121.6083, -8.49767],
              [121.6751, -8.51677],
              [121.7317, -8.50041],
              [121.808, -8.51648],
              [121.8425, -8.48957],
              [121.9275, -8.49713],
              [121.9504, -8.45808],
              [122.0267, -8.44553],
              [122.0162, -8.52998],
              [122.1068, -8.53397],
              [122.1615, -8.55955],
              [122.227, -8.62796],
              [122.2939, -8.65004],
              [122.3636, -8.61847],
              [122.4794, -8.61589],
              [122.5221, -8.55195],
              [122.4879, -8.51239],
              [122.4979, -8.46913],
              [122.5472, -8.46883],
              [122.6013, -8.39854],
              [122.6195, -8.40327],
            ],
          ],
          [
            [
              [124.046476, -9.342838],
              [124.0983, -9.41876],
              [124.157, -9.42968],
              [124.2065, -9.37529],
              [124.2687, -9.41875],
              [124.292, -9.50619],
              [124.3536, -9.47901],
              [124.3785, -9.35658],
              [124.4542, -9.31137],
              [124.472284, -9.18241],
              [124.5359, -9.19723],
              [124.6204, -9.16331],
              [124.6696, -9.12933],
              [124.7107, -9.05728],
              [124.7393, -9.06466],
              [124.8162, -9.01365],
              [124.8541, -9.01698],
              [124.8877, -8.98574],
              [124.949953, -8.967377],
              [124.9422, -9.04616],
              [124.9889, -9.06706],
              [125.0678, -9.02986],
              [125.1141, -8.97605],
              [125.182, -9.02754],
              [125.1877, -9.05588],
              [125.1722, -9.17896],
              [125.1018, -9.2008],
              [125.0577, -9.17553],
              [125.0155, -9.17832],
              [124.9847, -9.21434],
              [125.0001, -9.298],
              [125.0505, -9.33069],
              [125.0769, -9.38772],
              [125.092, -9.46447],
              [125.0071, -9.53962],
              [124.9834, -9.64711],
              [124.888, -9.70606],
              [124.8459, -9.74556],
              [124.7576, -9.86098],
              [124.7463, -9.89112],
              [124.6665, -9.93153],
              [124.6529, -9.95679],
              [124.5237, -10.03156],
              [124.4956, -10.09939],
              [124.4146, -10.1587],
              [124.379, -10.17015],
              [124.2336, -10.16353],
              [124.1707, -10.15307],
              [124.0928, -10.18045],
              [124.0698, -10.22167],
              [124.015, -10.26787],
              [123.9107, -10.29561],
              [123.8572, -10.3338],
              [123.7969, -10.3545],
              [123.7041, -10.36645],
              [123.6575, -10.3507],
              [123.6052, -10.36942],
              [123.5448, -10.3308],
              [123.4568, -10.3559],
              [123.5192, -10.22132],
              [123.5297, -10.17631],
              [123.6574, -10.13518],
              [123.7442, -10.09523],
              [123.7477, -10.0302],
              [123.6479, -10.00887],
              [123.5803, -10.03243],
              [123.5828, -9.92561],
              [123.6492, -9.89468],
              [123.6688, -9.81791],
              [123.6432, -9.77904],
              [123.6799, -9.75675],
              [123.6675, -9.64933],
              [123.7317, -9.57434],
              [123.7766, -9.55646],
              [123.7921, -9.4971],
              [123.8279, -9.50221],
              [123.9361, -9.42633],
              [123.9833, -9.35745],
              [124.046476, -9.342838],
            ],
          ],
          [
            [
              [119.6801, -9.82812],
              [119.6782, -9.794],
              [119.6154, -9.79994],
              [119.5839, -9.77393],
              [119.5296, -9.76832],
              [119.4709, -9.74123],
              [119.4114, -9.76779],
              [119.389, -9.79727],
              [119.3501, -9.76086],
              [119.3025, -9.74462],
              [119.1805, -9.74634],
              [119.0334, -9.68038],
              [118.9853, -9.60762],
              [118.9281, -9.55858],
              [118.9442, -9.51227],
              [118.9939, -9.45514],
              [119.0562, -9.42444],
              [119.0918, -9.42535],
              [119.1876, -9.37625],
              [119.2117, -9.39543],
              [119.3002, -9.36271],
              [119.3813, -9.38571],
              [119.4637, -9.35966],
              [119.5257, -9.38095],
              [119.5944, -9.34502],
              [119.6311, -9.3427],
              [119.6837, -9.37922],
              [119.7638, -9.38235],
              [119.7973, -9.39664],
              [119.9419, -9.28043],
              [119.9617, -9.32425],
              [120.1028, -9.47526],
              [120.1738, -9.46924],
              [120.2226, -9.4938],
              [120.2371, -9.59441],
              [120.2569, -9.644],
              [120.3607, -9.64701],
              [120.4517, -9.6284],
              [120.4984, -9.70313],
              [120.5523, -9.71446],
              [120.6071, -9.79198],
              [120.6418, -9.87525],
              [120.696, -9.91756],
              [120.7276, -9.91889],
              [120.7962, -9.97115],
              [120.8238, -10.02323],
              [120.8192, -10.08719],
              [120.7595, -10.13127],
              [120.7342, -10.17339],
              [120.6687, -10.22046],
              [120.6116, -10.24588],
              [120.5584, -10.23103],
              [120.4863, -10.26146],
              [120.4706, -10.30381],
              [120.4281, -10.30201],
              [120.3543, -10.24881],
              [120.2091, -10.25562],
              [120.1432, -10.22396],
              [120.0313, -10.1239],
              [119.9956, -10.0374],
              [119.9365, -9.98009],
              [119.8393, -9.92739],
              [119.7904, -9.92132],
              [119.7625, -9.89042],
              [119.7087, -9.86856],
              [119.6801, -9.82812],
            ],
          ],
          [
            [
              [124.3539, -8.38033],
              [124.4209, -8.29541],
              [124.4662, -8.25809],
              [124.5091, -8.26198],
              [124.5163, -8.22269],
              [124.4021, -8.27409],
              [124.3938, -8.22276],
              [124.4739, -8.13038],
              [124.5972, -8.12891],
              [124.5932, -8.19252],
              [124.6703, -8.16927],
              [124.7815, -8.15302],
              [124.8305, -8.17319],
              [125.0117, -8.16488],
              [125.0878, -8.15317],
              [125.1393, -8.22922],
              [125.1257, -8.34491],
              [125.0513, -8.36068],
              [124.8983, -8.37272],
              [124.7889, -8.40916],
              [124.6638, -8.39523],
              [124.5907, -8.4354],
              [124.5477, -8.44335],
              [124.5042, -8.41943],
              [124.4346, -8.45537],
              [124.3665, -8.44637],
              [124.3329, -8.4252],
              [124.3539, -8.38033],
            ],
          ],
          [
            [
              [123.5276, -8.36233],
              [123.5595, -8.36871],
              [123.5963, -8.33362],
              [123.5953, -8.28771],
              [123.6222, -8.2463],
              [123.7002, -8.25179],
              [123.6976, -8.21665],
              [123.7785, -8.16919],
              [123.8399, -8.21125],
              [123.9044, -8.21861],
              [123.911, -8.25849],
              [123.8382, -8.28234],
              [123.7639, -8.28847],
              [123.6734, -8.42844],
              [123.6204, -8.4061],
              [123.5531, -8.4716],
              [123.5829, -8.54344],
              [123.5455, -8.57183],
              [123.5049, -8.52237],
              [123.4487, -8.53498],
              [123.4261, -8.57759],
              [123.3883, -8.58505],
              [123.3148, -8.52816],
              [123.2864, -8.5495],
              [123.234, -8.51171],
              [123.2912, -8.4659],
              [123.3403, -8.39887],
              [123.4284, -8.37077],
              [123.4715, -8.3368],
              [123.4363, -8.27322],
              [123.5372, -8.23502],
              [123.5591, -8.25389],
              [123.5023, -8.33801],
              [123.5276, -8.36233],
            ],
          ],
          [
            [
              [123.1958, -10.58802],
              [123.2635, -10.51636],
              [123.4078, -10.45521],
              [123.3768, -10.55145],
              [123.4286, -10.65562],
              [123.3069, -10.70394],
              [123.2572, -10.73333],
              [123.2161, -10.81699],
              [123.1347, -10.81048],
              [123.0742, -10.84782],
              [122.968, -10.86041],
              [122.9112, -10.91875],
              [122.8847, -10.9029],
              [122.8195, -10.91942],
              [122.8198, -10.82761],
              [122.8044, -10.80657],
              [122.8534, -10.75584],
              [122.983, -10.7299],
              [123.0472, -10.72532],
              [123.1265, -10.64254],
              [123.178, -10.63356],
              [123.1958, -10.58802],
            ],
          ],
          [
            [
              [123.9428, -8.40262],
              [123.9618, -8.34731],
              [124.057, -8.294],
              [124.1009, -8.36503],
              [124.1639, -8.29119],
              [124.2086, -8.25939],
              [124.2258, -8.21369],
              [124.2778, -8.17424],
              [124.3162, -8.18454],
              [124.3197, -8.23096],
              [124.2932, -8.27001],
              [124.2955, -8.33138],
              [124.2429, -8.36111],
              [124.2035, -8.41588],
              [124.2077, -8.4605],
              [124.1385, -8.53854],
              [124.0619, -8.55243],
              [124.0617, -8.50392],
              [124.0329, -8.42446],
              [123.9428, -8.40262],
            ],
          ],
          [
            [
              [123.165, -8.39172],
              [123.1103, -8.40389],
              [123.0019, -8.40353],
              [123.0336, -8.31035],
              [123.1511, -8.23307],
              [123.2464, -8.2287],
              [123.3056, -8.29655],
              [123.308, -8.36417],
              [123.2869, -8.39409],
              [123.165, -8.39172],
            ],
          ],
          [
            [
              [121.8719, -10.6122],
              [121.7565, -10.6104],
              [121.6963, -10.57643],
              [121.8228, -10.5064],
              [121.8566, -10.44256],
              [121.8946, -10.42433],
              [121.9928, -10.43927],
              [121.9944, -10.5213],
              [121.8719, -10.6122],
            ],
          ],
          [
            [
              [119.4425, -8.75035],
              [119.3824, -8.72088],
              [119.4106, -8.6473],
              [119.3781, -8.58177],
              [119.4252, -8.54893],
              [119.4231, -8.44954],
              [119.4765, -8.45059],
              [119.5122, -8.49349],
              [119.5754, -8.4895],
              [119.5624, -8.58388],
              [119.5005, -8.58569],
              [119.4598, -8.61698],
              [119.4358, -8.67357],
              [119.4581, -8.69916],
              [119.4425, -8.75035],
            ],
          ],
          [
            [
              [123.3282, -10.3451],
              [123.3042, -10.26902],
              [123.3686, -10.20903],
              [123.3919, -10.14384],
              [123.4535, -10.11986],
              [123.4662, -10.16577],
              [123.4525, -10.22088],
              [123.4184, -10.2343],
              [123.4236, -10.29639],
              [123.3737, -10.30972],
              [123.3282, -10.3451],
            ],
          ],
          [
            [
              [123, -8.49739],
              [122.9458, -8.59493],
              [122.8954, -8.61934],
              [122.8738, -8.5781],
              [122.8848, -8.53292],
              [122.9503, -8.48984],
              [122.9816, -8.43728],
              [123.12, -8.4369],
              [123.1484, -8.46317],
              [123.0802, -8.49089],
              [123.0229, -8.47906],
              [123, -8.49739],
            ],
          ],
          [
            [
              [119.6352, -8.60281],
              [119.666, -8.61178],
              [119.6742, -8.68424],
              [119.7117, -8.65867],
              [119.7274, -8.61727],
              [119.8027, -8.61757],
              [119.8027, -8.65049],
              [119.7245, -8.68237],
              [119.7173, -8.79128],
              [119.6133, -8.74851],
              [119.6432, -8.65507],
              [119.6352, -8.60281],
            ],
          ],
          [
            [
              [125.5443, -8.30659],
              [125.5038, -8.26816],
              [125.5505, -8.22926],
              [125.6169, -8.14468],
              [125.6448, -8.17069],
              [125.6089, -8.23812],
              [125.5862, -8.31465],
              [125.5443, -8.30659],
            ],
          ],
          [
            [
              [122.3898, -8.50424],
              [122.3571, -8.49548],
              [122.3385, -8.44026],
              [122.3804, -8.43406],
              [122.4208, -8.48212],
              [122.3898, -8.50424],
            ],
          ],
          [
            [
              [121.7251, -8.36166],
              [121.681, -8.3275],
              [121.7321, -8.30295],
              [121.7251, -8.36166],
            ],
          ],
        ],
      },
      id: 53,
      properties: {
        ID: 17,
        kode: 53,
        provinsi: "NUSA TENGGARA TIMUR",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [115.194942, -8.732323],
              [115.180252, -8.757741],
              [115.23497, -8.799568],
              [115.170486, -8.847422],
              [115.087341, -8.835617],
              [115.089859, -8.811961],
              [115.161148, -8.779349],
              [115.166382, -8.717985],
              [115.140114, -8.66686],
              [115.097687, -8.638191],
              [115.068596, -8.591315],
              [114.929085, -8.474201],
              [114.801537, -8.414222],
              [114.714836, -8.394822],
              [114.627663, -8.407767],
              [114.575851, -8.388434],
              [114.522606, -8.33624],
              [114.445526, -8.21899],
              [114.428268, -8.168071],
              [114.438026, -8.0937],
              [114.48764, -8.09358],
              [114.536934, -8.138295],
              [114.582436, -8.116596],
              [114.692444, -8.144426],
              [114.744499, -8.167377],
              [114.853981, -8.195267],
              [114.997383, -8.17379],
              [115.114624, -8.079416],
              [115.179657, -8.058906],
              [115.338425, -8.111131],
              [115.452835, -8.162612],
              [115.564995, -8.233503],
              [115.634735, -8.322159],
              [115.701965, -8.354779],
              [115.716316, -8.397886],
              [115.680428, -8.443698],
              [115.644066, -8.459964],
              [115.609451, -8.505023],
              [115.543221, -8.499585],
              [115.499054, -8.547023],
              [115.44661, -8.566829],
              [115.359718, -8.577768],
              [115.264145, -8.655357],
              [115.260429, -8.703996],
              [115.194942, -8.732323],
            ],
          ],
          [
            [
              [115.623787, -8.773455],
              [115.588226, -8.818159],
              [115.484924, -8.767053],
              [115.445183, -8.722188],
              [115.488922, -8.672191],
              [115.565613, -8.670997],
              [115.623749, -8.750002],
              [115.623787, -8.773455],
            ],
          ],
        ],
      },
      id: 51,
      properties: {
        ID: 18,
        kode: 51,
        provinsi: "BALI",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [101.914047, -0.920961],
              [101.845276, -0.982571],
              [101.650337, -0.93408],
              [101.595917, -0.851199],
              [101.395836, -0.738651],
              [101.407646, -0.720709],
              [101.355362, -0.68732],
              [101.359833, -0.65925],
              [101.253769, -0.62543],
              [101.162247, -0.53627],
              [101.068939, -0.50064],
              [101.024826, -0.398439],
              [101.036423, -0.34944],
              [100.996368, -0.31436],
              [100.915039, -0.32568],
              [100.907509, -0.371669],
              [100.844856, -0.337659],
              [100.838783, -0.2906],
              [100.781006, -0.230419],
              [100.733833, -0.04317],
              [100.776741, -0.01239],
              [100.809166, -0.041148],
              [100.845413, 0.01544],
              [100.824219, 0.118061],
              [100.842186, 0.189851],
              [100.812531, 0.268481],
              [100.74514, 0.250221],
              [100.668938, 0.18083],
              [100.605743, 0.183469],
              [100.451752, 0.229109],
              [100.376022, 0.35071],
              [100.281677, 0.33296],
              [100.280533, 0.41644],
              [100.206459, 0.584121],
              [100.25573, 0.709401],
              [100.130508, 0.80901],
              [100.13134, 0.902851],
              [100.081863, 0.938071],
              [100.14064, 0.951121],
              [100.161377, 0.999161],
              [100.102188, 1.09181],
              [100.183029, 1.12499],
              [100.130478, 1.174599],
              [100.094643, 1.327261],
              [100.053658, 1.361081],
              [100.077881, 1.387211],
              [100.315857, 1.416461],
              [100.337547, 1.431191],
              [100.283859, 1.46392],
              [100.291878, 1.47756],
              [100.331718, 1.479493],
              [100.323486, 1.44348],
              [100.381348, 1.450509],
              [100.434021, 1.511289],
              [100.415894, 1.537212],
              [100.455322, 1.629089],
              [100.411362, 1.69775],
              [100.421158, 1.767701],
              [100.285522, 1.813293],
              [100.361328, 2.201904],
              [100.307129, 2.357482],
              [100.3293, 2.529452],
              [100.361389, 2.393055],
              [100.43, 2.272778],
              [100.645546, 2.110561],
              [100.670403, 2.124381],
              [100.773567, 2.081344],
              [100.795021, 2.112496],
              [100.760902, 2.252232],
              [100.789444, 2.286945],
              [101.053665, 2.28401],
              [101.078056, 2.214441],
              [101.305, 2.041667],
              [101.356941, 1.779443],
              [101.409721, 1.698055],
              [101.561386, 1.637221],
              [101.751945, 1.664723],
              [102.006752, 1.45814],
              [102.149017, 1.378252],
              [102.166061, 1.182529],
              [102.150597, 1.166825],
              [102.152969, 1.132561],
              [102.122726, 1.124511],
              [102.166817, 1.133411],
              [102.180069, 1.230281],
              [102.209427, 1.187251],
              [102.191437, 1.093891],
              [102.229172, 0.995434],
              [102.407532, 0.811556],
              [102.570236, 0.738701],
              [102.674683, 0.755719],
              [102.894142, 0.728491],
              [103.104446, 0.478611],
              [103.10733, 0.455001],
              [102.899178, 0.33559],
              [102.612465, 0.230497],
              [102.573799, 0.169348],
              [102.521767, 0.203079],
              [102.494911, 0.24997],
              [102.430275, 0.26111],
              [102.405815, 0.208622],
              [102.431664, 0.243611],
              [102.484947, 0.239691],
              [102.513992, 0.19311],
              [102.548119, 0.171994],
              [102.527206, 0.168425],
              [102.583611, 0.154167],
              [102.598793, 0.201912],
              [102.69117, 0.248486],
              [102.859177, 0.25005],
              [103.142067, 0.39348],
              [103.195908, 0.475206],
              [103.32621, 0.545462],
              [103.414749, 0.521301],
              [103.585732, 0.393189],
              [103.6007, 0.294215],
              [103.614403, 0.345418],
              [103.651665, 0.337222],
              [103.712776, 0.299446],
              [103.753052, 0.229166],
              [103.811668, -0.010834],
              [103.614273, -0.006715],
              [103.567307, -0.025967],
              [103.59581, -0.037978],
              [103.583702, -0.06066],
              [103.533882, -0.079921],
              [103.504738, -0.07983],
              [103.457008, -0.044549],
              [103.488052, -0.089149],
              [103.454102, -0.11187],
              [103.501549, -0.147554],
              [103.424141, -0.207049],
              [103.521393, -0.21111],
              [103.442245, -0.352848],
              [103.547226, -0.215831],
              [103.709442, -0.255829],
              [103.786392, -0.340556],
              [103.604721, -0.395834],
              [103.55278, -0.385277],
              [103.604164, -0.426389],
              [103.553055, -0.496112],
              [103.400467, -0.517549],
              [103.436386, -0.541945],
              [103.404716, -0.60417],
              [103.430557, -0.61583],
              [103.373337, -0.651111],
              [103.421112, -0.669167],
              [103.362617, -0.696942],
              [103.435143, -0.710556],
              [103.412331, -0.731389],
              [103.459999, -0.735277],
              [103.485001, -0.771112],
              [103.360077, -0.80318],
              [103.126038, -0.746429],
              [103.007942, -0.75602],
              [102.913399, -0.886409],
              [102.789528, -0.976889],
              [102.779449, -1.026619],
              [102.63903, -1.121101],
              [102.616806, -1.094629],
              [102.48381, -1.080979],
              [102.44252, -1.02545],
              [102.382446, -1.02669],
              [102.38623, -0.99338],
              [102.326332, -0.963339],
              [102.306816, -0.91736],
              [102.20359, -0.94852],
              [102.165001, -0.89873],
              [102.116623, -0.921171],
              [102.007767, -0.878599],
              [101.914047, -0.920961],
            ],
          ],
          [
            [
              [103.208931, 0.7028],
              [103.281151, 0.653311],
              [103.30043, 0.550661],
              [103.169434, 0.497803],
              [103.138641, 0.552931],
              [103.148483, 0.66511],
              [103.208931, 0.7028],
            ],
          ],
          [
            [
              [103.109169, 0.666945],
              [103.103752, 0.630071],
              [103.093102, 0.652121],
              [103.109169, 0.666945],
            ],
          ],
          [
            [
              [103.067978, 0.563381],
              [103.028374, 0.636104],
              [103.035622, 0.660158],
              [103.083977, 0.591011],
              [103.067978, 0.563381],
            ],
          ],
          [
            [
              [102.966736, 0.35389],
              [102.986626, 0.335219],
              [102.945236, 0.312279],
              [102.934753, 0.340978],
              [102.966736, 0.35389],
            ],
          ],
          [
            [
              [102.908363, 0.30936],
              [102.937454, 0.316539],
              [102.853996, 0.26006],
              [102.819542, 0.26782],
              [102.908363, 0.30936],
            ],
          ],
          [
            [
              [101.415833, 1.83972],
              [101.383057, 1.91056],
              [101.398056, 2.0075],
              [101.446945, 2.057222],
              [101.484169, 2.062781],
              [101.516388, 2.0275],
              [101.580345, 2.073965],
              [101.592461, 2.056639],
              [101.586113, 2.08611],
              [101.620003, 2.106112],
              [101.621925, 2.064369],
              [101.626564, 2.096252],
              [101.612999, 2.101656],
              [101.655724, 2.124963],
              [101.708885, 2.091945],
              [101.777779, 1.986669],
              [101.784164, 1.936389],
              [101.728333, 1.940555],
              [101.777779, 1.928332],
              [101.732224, 1.763888],
              [101.61528, 1.688055],
              [101.454445, 1.725555],
              [101.415833, 1.83972],
            ],
          ],
          [
            [
              [101.402496, 1.827501],
              [101.406113, 1.757219],
              [101.394165, 1.789166],
              [101.402496, 1.827501],
            ],
          ],
          [
            [
              [102.03833, 1.609171],
              [102.462502, 1.5175],
              [102.497498, 1.469171],
              [102.47139, 1.4425],
              [102.495552, 1.432219],
              [102.508278, 1.254549],
              [102.294716, 1.428889],
              [102.181946, 1.43778],
              [102.084999, 1.481667],
              [101.99855, 1.584105],
              [102.03833, 1.609171],
            ],
          ],
          [
            [
              [102.44252, 1.08239],
              [102.478317, 0.941141],
              [102.44014, 0.94943],
              [102.386307, 0.91344],
              [102.277443, 1.003204],
              [102.236137, 1.101478],
              [102.245789, 1.194704],
              [102.205338, 1.277218],
              [102.229706, 1.352399],
              [102.213898, 1.41431],
              [102.290672, 1.41322],
              [102.484993, 1.238279],
              [102.484642, 1.198129],
              [102.442146, 1.242096],
              [102.483612, 1.195],
              [102.44252, 1.08239],
            ],
          ],
          [
            [
              [102.657677, 1.03797],
              [102.680397, 1.108101],
              [102.73597, 1.1547],
              [102.874504, 1.134391],
              [103.003326, 1.072781],
              [103.154999, 0.894719],
              [103.153206, 0.847245],
              [103.071854, 0.831692],
              [102.88929, 0.964007],
              [102.806084, 0.992549],
              [102.790306, 1.023331],
              [102.821716, 1.04924],
              [102.880127, 1.042189],
              [102.854736, 1.085342],
              [102.811562, 1.080421],
              [102.81189, 1.036981],
              [102.778641, 1.020097],
              [102.73085, 1.039711],
              [102.624474, 1.011149],
              [102.657677, 1.03797],
            ],
          ],
          [
            [
              [102.536591, 1.127383],
              [102.614899, 1.047572],
              [102.6082, 1.005649],
              [102.500656, 0.945325],
              [102.45977, 1.076551],
              [102.48484, 1.12999],
              [102.536591, 1.127383],
            ],
          ],
          [
            [
              [102.865929, 1.059505],
              [102.823753, 1.053876],
              [102.842125, 1.071836],
              [102.865929, 1.059505],
            ],
          ],
          [
            [
              [102.905869, 0.778383],
              [102.691811, 0.792222],
              [102.56028, 0.76921],
              [102.43708, 0.82588],
              [102.408745, 0.887096],
              [102.440979, 0.93514],
              [102.48465, 0.929567],
              [102.589317, 1.001665],
              [102.638046, 0.97948],
              [102.737106, 1.02234],
              [102.743286, 0.995879],
              [102.646317, 0.95067],
              [102.626183, 0.903375],
              [102.646179, 0.948769],
              [102.684723, 0.957781],
              [102.697144, 0.927527],
              [102.782051, 0.904975],
              [102.78083, 0.926944],
              [102.746651, 0.908059],
              [102.69558, 0.937002],
              [102.77578, 1.005175],
              [103.046654, 0.82447],
              [103.048889, 0.718611],
              [102.994003, 0.689499],
              [102.905869, 0.778383],
            ],
          ],
          [
            [
              [103.092308, 0.820251],
              [103.109169, 0.806708],
              [103.082703, 0.795887],
              [103.075043, 0.820691],
              [103.092308, 0.820251],
            ],
          ],
          [
            [
              [103.103416, 0.798351],
              [103.114723, 0.736939],
              [103.087738, 0.717289],
              [103.080353, 0.77615],
              [103.103416, 0.798351],
            ],
          ],
          [
            [
              [103.546112, 0.448891],
              [103.590279, 0.408331],
              [103.558212, 0.423656],
              [103.546112, 0.448891],
            ],
          ],
          [
            [
              [103.628563, -0.016778],
              [103.64669, -0.050217],
              [103.599472, -0.020901],
              [103.628563, -0.016778],
            ],
          ],
          [
            [
              [103.666656, -0.05315],
              [103.635635, -0.016538],
              [103.680496, -0.038186],
              [103.666656, -0.05315],
            ],
          ],
          [
            [
              [103.479721, -0.053889],
              [103.501663, -0.081667],
              [103.528336, -0.082777],
              [103.490547, -0.085829],
              [103.463608, -0.045556],
              [103.479721, -0.053889],
            ],
          ],
          [
            [
              [103.581146, -0.077897],
              [103.590836, -0.097778],
              [103.542999, -0.121347],
              [103.473335, -0.108055],
              [103.581146, -0.077897],
            ],
          ],
          [
            [
              [103.557281, -0.176062],
              [103.566826, -0.195259],
              [103.477783, -0.20167],
              [103.557281, -0.176062],
            ],
          ],
          [
            [
              [100.735832, 2.149445],
              [100.710281, 2.21722],
              [100.739441, 2.261945],
              [100.785553, 2.121667],
              [100.735832, 2.149445],
            ],
          ],
          [
            [
              [100.638336, 2.219241],
              [100.67028, 2.196739],
              [100.684448, 2.161741],
              [100.632797, 2.195269],
              [100.638336, 2.219241],
            ],
          ],
        ],
      },
      id: 14,
      properties: {
        ID: 19,
        kode: 14,
        provinsi: "RIAU",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [103.991943, 1.134721],
              [104.013611, 1.189443],
              [104.071663, 1.118888],
              [104.101944, 1.140834],
              [104.071953, 1.18778],
              [104.098892, 1.199444],
              [104.138885, 1.169166],
              [104.136948, 1.039722],
              [104.101379, 1.042414],
              [104.079712, 1.024154],
              [104.100166, 0.982464],
              [104.030563, 1.00639],
              [104.040527, 0.9825],
              [104.008575, 0.985876],
              [103.990829, 1.017414],
              [103.94265, 1.008161],
              [103.910004, 1.038056],
              [103.888046, 1.0925],
              [103.937225, 1.08389],
              [103.920227, 1.14296],
              [103.991943, 1.134721],
            ],
          ],
          [
            [
              [103.888046, 1.158889],
              [103.889458, 1.14181],
              [103.868889, 1.147222],
              [103.888046, 1.158889],
            ],
          ],
          [
            [
              [103.802505, 1.101735],
              [103.812241, 1.084147],
              [103.790558, 1.096945],
              [103.802505, 1.101735],
            ],
          ],
          [
            [
              [103.849442, 1.069171],
              [103.882149, 1.05321],
              [103.838646, 1.027541],
              [103.83255, 1.06309],
              [103.849442, 1.069171],
            ],
          ],
          [
            [
              [104.181389, 1.068332],
              [104.167503, 1.022221],
              [104.154999, 1.041389],
              [104.181389, 1.068332],
            ],
          ],
          [
            [
              [103.749954, 1.026713],
              [103.791252, 1.04645],
              [103.806206, 0.972775],
              [103.782646, 0.97739],
              [103.749954, 1.026713],
            ],
          ],
          [
            [
              [103.903107, 1.03268],
              [103.919678, 1.012794],
              [103.903259, 1.002832],
              [103.885101, 1.02966],
              [103.903107, 1.03268],
            ],
          ],
          [
            [
              [103.832474, 0.989007],
              [103.868256, 1.037678],
              [103.877739, 1.012594],
              [103.900421, 0.998828],
              [103.925278, 1.008061],
              [103.974998, 0.954444],
              [103.941902, 0.909791],
              [103.832474, 0.989007],
            ],
          ],
          [
            [
              [104.178833, 1.02863],
              [104.174721, 0.998611],
              [104.155556, 0.998333],
              [104.155243, 1.016117],
              [104.178833, 1.02863],
            ],
          ],
          [
            [
              [103.991943, 1.000556],
              [103.981392, 1.005834],
              [103.992226, 1.011944],
              [103.991943, 1.000556],
            ],
          ],
          [
            [
              [104.245827, 0.997499],
              [104.258888, 0.97389],
              [104.232224, 0.979722],
              [104.245827, 0.997499],
            ],
          ],
          [
            [
              [104.152237, 0.97107],
              [104.172226, 0.973541],
              [104.198067, 0.945872],
              [104.153069, 0.93375],
              [104.152237, 0.97107],
            ],
          ],
          [
            [
              [104.0625, 0.967223],
              [104.079666, 0.949464],
              [104.068428, 0.914281],
              [104.044579, 0.938139],
              [104.0625, 0.967223],
            ],
          ],
          [
            [
              [104.178719, 0.78228],
              [104.14537, 0.856911],
              [104.09214, 0.870374],
              [104.094444, 0.926755],
              [104.078018, 0.959827],
              [104.119728, 0.961952],
              [104.140556, 0.942221],
              [104.167175, 0.867541],
              [104.184509, 0.88475],
              [104.265961, 0.85921],
              [104.245346, 0.820324],
              [104.178719, 0.78228],
            ],
          ],
          [
            [
              [104.168579, 0.941861],
              [104.191391, 0.928334],
              [104.161392, 0.910555],
              [104.168579, 0.941861],
            ],
          ],
          [
            [
              [104.21447, 0.916711],
              [104.193329, 0.902286],
              [104.204201, 0.922235],
              [104.21447, 0.916711],
            ],
          ],
          [
            [
              [104.048843, 0.921121],
              [104.051514, 0.900766],
              [104.035652, 0.892237],
              [104.048843, 0.921121],
            ],
          ],
          [
            [
              [104.193886, 0.78806],
              [104.276863, 0.796511],
              [104.264015, 0.743706],
              [104.309097, 0.707096],
              [104.248886, 0.723611],
              [104.253304, 0.692524],
              [104.218613, 0.724445],
              [104.196388, 0.720833],
              [104.170685, 0.77976],
              [104.193886, 0.78806],
            ],
          ],
          [
            [
              [104.30864, 0.76319],
              [104.357208, 0.741919],
              [104.299721, 0.755833],
              [104.30864, 0.76319],
            ],
          ],
          [
            [
              [104.264999, 0.621389],
              [104.212471, 0.718914],
              [104.285561, 0.66168],
              [104.289169, 0.610554],
              [104.264999, 0.621389],
            ],
          ],
          [
            [
              [104.29319, 0.689987],
              [104.301392, 0.671667],
              [104.270416, 0.682853],
              [104.29319, 0.689987],
            ],
          ],
          [
            [
              [104.326897, 0.678119],
              [104.329605, 0.660429],
              [104.312317, 0.66227],
              [104.314339, 0.684932],
              [104.326897, 0.678119],
            ],
          ],
          [
            [
              [104.085518, 0.643431],
              [104.104195, 0.624462],
              [104.085831, 0.6025],
              [104.085518, 0.643431],
            ],
          ],
          [
            [
              [104.198395, 0.608487],
              [104.230003, 0.570278],
              [104.203529, 0.572165],
              [104.197502, 0.541668],
              [104.198395, 0.608487],
            ],
          ],
          [
            [
              [104.22525, 0.557619],
              [104.238327, 0.53083],
              [104.2192, 0.541424],
              [104.22525, 0.557619],
            ],
          ],
          [
            [
              [103.388893, 1.16639],
              [103.40889, 1.129167],
              [103.379448, 1.150279],
              [103.388893, 1.16639],
            ],
          ],
          [
            [
              [103.375, 1.13806],
              [103.389725, 1.066666],
              [103.425003, 1.045559],
              [103.438919, 0.988355],
              [103.350723, 1.004977],
              [103.312225, 1.043889],
              [103.310898, 1.0875],
              [103.375, 1.13806],
            ],
          ],
          [
            [
              [103.444168, 0.962781],
              [103.473892, 0.949719],
              [103.475281, 0.919721],
              [103.425835, 0.95611],
              [103.444168, 0.962781],
            ],
          ],
          [
            [
              [103.418053, 0.95],
              [103.439163, 0.930834],
              [103.419327, 0.913091],
              [103.406944, 0.940555],
              [103.418053, 0.95],
            ],
          ],
          [
            [
              [103.526588, 0.867764],
              [103.501663, 0.86169],
              [103.489807, 0.926629],
              [103.526588, 0.867764],
            ],
          ],
          [
            [
              [103.448593, 0.92195],
              [103.47905, 0.908221],
              [103.486595, 0.854903],
              [103.409561, 0.892529],
              [103.448593, 0.92195],
            ],
          ],
          [
            [
              [103.752777, 0.90139],
              [103.765831, 0.882501],
              [103.744156, 0.894441],
              [103.752777, 0.90139],
            ],
          ],
          [
            [
              [103.932793, 0.76699],
              [103.918098, 0.755371],
              [103.835861, 0.838657],
              [103.810516, 0.899544],
              [103.898209, 0.854561],
              [103.896111, 0.804721],
              [103.906944, 0.833333],
              [103.932793, 0.76699],
            ],
          ],
          [
            [
              [103.505753, 0.723843],
              [103.458176, 0.638205],
              [103.400017, 0.649092],
              [103.34333, 0.800561],
              [103.370277, 0.894444],
              [103.405396, 0.882045],
              [103.412231, 0.84503],
              [103.486664, 0.794171],
              [103.505753, 0.723843],
            ],
          ],
          [
            [
              [103.748337, 0.886391],
              [103.83432, 0.812035],
              [103.829681, 0.752109],
              [103.719788, 0.85222],
              [103.748337, 0.886391],
            ],
          ],
          [
            [
              [103.422485, 0.875584],
              [103.494286, 0.845531],
              [103.527649, 0.76686],
              [103.472771, 0.822776],
              [103.421257, 0.841823],
              [103.422485, 0.875584],
            ],
          ],
          [
            [
              [103.671112, 0.864168],
              [103.693024, 0.823861],
              [103.654678, 0.873375],
              [103.671112, 0.864168],
            ],
          ],
          [
            [
              [103.701981, 0.857501],
              [103.696854, 0.836451],
              [103.691391, 0.856667],
              [103.701981, 0.857501],
            ],
          ],
          [
            [
              [103.699379, 0.80447],
              [103.728027, 0.766115],
              [103.713066, 0.752],
              [103.661285, 0.828747],
              [103.699379, 0.80447],
            ],
          ],
          [
            [
              [103.54023, 0.793539],
              [103.554886, 0.778246],
              [103.543266, 0.754735],
              [103.529892, 0.776238],
              [103.54023, 0.793539],
            ],
          ],
          [
            [
              [103.966095, 0.76825],
              [103.95089, 0.763291],
              [103.962479, 0.777925],
              [103.966095, 0.76825],
            ],
          ],
          [
            [
              [103.654968, 0.74142],
              [103.687973, 0.723951],
              [103.674232, 0.712245],
              [103.654968, 0.74142],
            ],
          ],
          [
            [
              [103.746147, 0.736406],
              [103.741257, 0.684986],
              [103.693207, 0.710456],
              [103.692604, 0.728509],
              [103.746147, 0.736406],
            ],
          ],
          [
            [
              [103.509483, 0.702729],
              [103.516907, 0.69439],
              [103.495583, 0.692653],
              [103.509483, 0.702729],
            ],
          ],
          [
            [
              [103.520882, 0.6907],
              [103.490433, 0.625259],
              [103.46209, 0.622588],
              [103.488167, 0.681338],
              [103.520882, 0.6907],
            ],
          ],
          [
            [
              [103.683189, 0.632263],
              [103.706596, 0.615174],
              [103.673744, 0.613337],
              [103.683189, 0.632263],
            ],
          ],
          [
            [
              [103.64637, 0.621533],
              [103.664047, 0.614349],
              [103.63105, 0.621476],
              [103.64637, 0.621533],
            ],
          ],
          [
            [
              [103.595352, 0.531329],
              [103.623047, 0.507661],
              [103.618752, 0.494904],
              [103.597855, 0.490893],
              [103.576202, 0.558519],
              [103.595352, 0.531329],
            ],
          ],
          [
            [
              [103.636169, 0.532426],
              [103.634186, 0.514899],
              [103.61972, 0.526666],
              [103.636169, 0.532426],
            ],
          ],
          [
            [
              [104.221107, 1.058612],
              [104.238609, 1.124171],
              [104.334999, 1.145],
              [104.311668, 1.182501],
              [104.371727, 1.179231],
              [104.39389, 1.204445],
              [104.499443, 1.169166],
              [104.562225, 1.190556],
              [104.545555, 1.2175],
              [104.584167, 1.228332],
              [104.577156, 1.156674],
              [104.657051, 1.045382],
              [104.634163, 0.986188],
              [104.660164, 0.9152],
              [104.621002, 0.900818],
              [104.594337, 0.810601],
              [104.557312, 0.813413],
              [104.476234, 0.849759],
              [104.491501, 0.875025],
              [104.438919, 0.906104],
              [104.438118, 0.932751],
              [104.476883, 0.919293],
              [104.498665, 0.935507],
              [104.40889, 0.963611],
              [104.415306, 0.978571],
              [104.495552, 0.97972],
              [104.440353, 0.99803],
              [104.445686, 1.017259],
              [104.481018, 1.014196],
              [104.498337, 1.03639],
              [104.416954, 1.039773],
              [104.416809, 1.068339],
              [104.37925, 1.010575],
              [104.316818, 1.039859],
              [104.331375, 0.994548],
              [104.250557, 1.00417],
              [104.221107, 1.058612],
            ],
          ],
          [
            [
              [107.41111, 1.103226],
              [107.388336, 1.088888],
              [107.403893, 1.113334],
              [107.41111, 1.103226],
            ],
          ],
          [
            [
              [107.504906, 1.048235],
              [107.519447, 1.046341],
              [107.503738, 1.035955],
              [107.504906, 1.048235],
            ],
          ],
          [
            [
              [104.821388, 0.968055],
              [104.78611, 1.02889],
              [104.849442, 1.01333],
              [104.854164, 0.9825],
              [104.821388, 0.968055],
            ],
          ],
          [
            [
              [107.531166, 1.02283],
              [107.587502, 1.01111],
              [107.603615, 0.991111],
              [107.547775, 0.949444],
              [107.574539, 1.007085],
              [107.544998, 0.972221],
              [107.531166, 1.02283],
            ],
          ],
          [
            [
              [107.42778, 0.97889],
              [107.471107, 0.969441],
              [107.468613, 0.923334],
              [107.438332, 0.932501],
              [107.42778, 0.97889],
            ],
          ],
          [
            [
              [104.627151, 0.89593],
              [104.661942, 0.880279],
              [104.628212, 0.854511],
              [104.627151, 0.89593],
            ],
          ],
          [
            [
              [104.683609, 0.895834],
              [104.695831, 0.848888],
              [104.676392, 0.84639],
              [104.660278, 0.862499],
              [104.683609, 0.895834],
            ],
          ],
          [
            [
              [104.45945, 0.884146],
              [104.485085, 0.870221],
              [104.416557, 0.87629],
              [104.45945, 0.884146],
            ],
          ],
          [
            [
              [104.648331, 0.86889],
              [104.666389, 0.82],
              [104.62603, 0.803713],
              [104.648331, 0.86889],
            ],
          ],
          [
            [
              [104.623245, 0.849223],
              [104.613647, 0.846101],
              [104.621719, 0.86092],
              [104.623245, 0.849223],
            ],
          ],
          [
            [
              [104.364296, 0.846365],
              [104.356056, 0.81376],
              [104.353302, 0.845016],
              [104.364296, 0.846365],
            ],
          ],
          [
            [
              [104.548058, 0.795278],
              [104.587502, 0.776111],
              [104.50972, 0.743335],
              [104.508789, 0.773499],
              [104.548058, 0.795278],
            ],
          ],
          [
            [
              [104.593887, 0.794171],
              [104.636665, 0.78389],
              [104.585556, 0.751667],
              [104.593887, 0.794171],
            ],
          ],
          [
            [
              [104.706322, 0.790191],
              [104.74704, 0.786283],
              [104.750153, 0.753349],
              [104.687912, 0.772549],
              [104.706322, 0.790191],
            ],
          ],
          [
            [
              [104.696114, 0.763334],
              [104.757629, 0.74733],
              [104.762222, 0.733334],
              [104.734398, 0.717881],
              [104.696114, 0.763334],
            ],
          ],
          [
            [
              [104.659164, 0.753333],
              [104.620163, 0.69751],
              [104.601768, 0.699288],
              [104.615585, 0.738065],
              [104.659164, 0.753333],
            ],
          ],
          [
            [
              [107.241669, 0.14639],
              [107.251389, 0.141109],
              [107.22139, 0.098888],
              [107.204437, 0.12694],
              [107.241669, 0.14639],
            ],
          ],
          [
            [
              [104.408302, 0.472981],
              [104.426178, 0.459885],
              [104.40168, 0.46247],
              [104.408302, 0.472981],
            ],
          ],
          [
            [
              [104.521347, 0.424976],
              [104.5625, 0.4125],
              [104.52916, 0.404983],
              [104.533157, 0.361604],
              [104.521347, 0.424976],
            ],
          ],
          [
            [
              [104.324257, 0.38417],
              [104.325531, 0.369253],
              [104.305267, 0.385],
              [104.324257, 0.38417],
            ],
          ],
          [
            [
              [104.430405, 0.384874],
              [104.433197, 0.372036],
              [104.408951, 0.377782],
              [104.430405, 0.384874],
            ],
          ],
          [
            [
              [104.414612, 0.301367],
              [104.398888, 0.284444],
              [104.389725, 0.308612],
              [104.354446, 0.313888],
              [104.328743, 0.375651],
              [104.424026, 0.326898],
              [104.43354, 0.307211],
              [104.398056, 0.313888],
              [104.414612, 0.301367],
            ],
          ],
          [
            [
              [104.468361, 0.364601],
              [104.490631, 0.346131],
              [104.459511, 0.34875],
              [104.468361, 0.364601],
            ],
          ],
          [
            [
              [104.302498, 0.346945],
              [104.32222, 0.336388],
              [104.319168, 0.308056],
              [104.301392, 0.30944],
              [104.302498, 0.346945],
            ],
          ],
          [
            [
              [104.327499, 0.32806],
              [104.369446, 0.30528],
              [104.386673, 0.273609],
              [104.355278, 0.27861],
              [104.327499, 0.32806],
            ],
          ],
          [
            [
              [104.362251, 0.268636],
              [104.363892, 0.255834],
              [104.351685, 0.274184],
              [104.362251, 0.268636],
            ],
          ],
          [
            [
              [104.498802, 0.261466],
              [104.512192, 0.250579],
              [104.489418, 0.266601],
              [104.498802, 0.261466],
            ],
          ],
          [
            [
              [104.443611, 0.250834],
              [104.473717, 0.227603],
              [104.447258, 0.234139],
              [104.443611, 0.250834],
            ],
          ],
          [
            [
              [104.515556, 0.225561],
              [104.531113, 0.20944],
              [104.514519, 0.247661],
              [104.704475, 0.046888],
              [104.702049, 0.018291],
              [104.621956, 0.074787],
              [104.634163, 0.077501],
              [104.627777, 0.095834],
              [104.605606, 0.095834],
              [104.619156, 0.075001],
              [104.564049, 0.115879],
              [104.545097, 0.145139],
              [104.569168, 0.142219],
              [104.54528, 0.16806],
              [104.536842, 0.15057],
              [104.504723, 0.191389],
              [104.527908, 0.184785],
              [104.52417, 0.19726],
              [104.47583, 0.242777],
              [104.515556, 0.225561],
            ],
          ],
          [
            [
              [104.232468, 0.199581],
              [104.241783, 0.17658],
              [104.227524, 0.154723],
              [104.200279, 0.170834],
              [104.232468, 0.199581],
            ],
          ],
          [
            [
              [104.473442, 0.177131],
              [104.483856, 0.161489],
              [104.461945, 0.170278],
              [104.473442, 0.177131],
            ],
          ],
          [
            [
              [104.298744, 0.166706],
              [104.336342, 0.130701],
              [104.336937, 0.10628],
              [104.300751, 0.128406],
              [104.298744, 0.166706],
            ],
          ],
          [
            [
              [104.435089, 0.064922],
              [104.378044, 0.123239],
              [104.432777, 0.089441],
              [104.401947, 0.162431],
              [104.492004, 0.072191],
              [104.486755, 0.043938],
              [104.462502, 0.060278],
              [104.494789, 0.014492],
              [104.435089, 0.064922],
            ],
          ],
          [
            [
              [104.488892, 0.151944],
              [104.516388, 0.130833],
              [104.516388, 0.108055],
              [104.488892, 0.151944],
            ],
          ],
          [
            [
              [104.54187, 0.102252],
              [104.56105, 0.072029],
              [104.534019, 0.095916],
              [104.54187, 0.102252],
            ],
          ],
          [
            [
              [104.743607, 0.08667],
              [104.754639, 0.078303],
              [104.740501, 0.075097],
              [104.743607, 0.08667],
            ],
          ],
          [
            [
              [104.491394, 0.088336],
              [104.498795, 0.071992],
              [104.480873, 0.087456],
              [104.491394, 0.088336],
            ],
          ],
          [
            [
              [104.769371, 0.059421],
              [104.784454, 0.030865],
              [104.739166, 0.0325],
              [104.738609, 0.048333],
              [104.769371, 0.059421],
            ],
          ],
          [
            [
              [104.539162, 0.044531],
              [104.543839, 0.032846],
              [104.521446, 0.051195],
              [104.539162, 0.044531],
            ],
          ],
          [
            [
              [104.659157, -0.110831],
              [104.682777, -0.083889],
              [104.788055, -0.204863],
              [104.823334, -0.195277],
              [104.827225, -0.132779],
              [104.896942, -0.231112],
              [104.997498, -0.278056],
              [105.001732, -0.30332],
              [104.921944, -0.277777],
              [104.899796, -0.294237],
              [104.929733, -0.324721],
              [104.915833, -0.339722],
              [104.849167, -0.322499],
              [104.703331, -0.20472],
              [104.521667, -0.276239],
              [104.498611, -0.24194],
              [104.429169, -0.236666],
              [104.426109, -0.184169],
              [104.504997, -0.129166],
              [104.493614, 0.003333],
              [104.531387, -0.02444],
              [104.548897, 0.0027],
              [104.565834, -0.011944],
              [104.552177, 0.02917],
              [104.653336, -0.051667],
              [104.668053, -0.077779],
              [104.624443, -0.079445],
              [104.659157, -0.110831],
            ],
          ],
          [
            [
              [104.532501, 0.026389],
              [104.545479, 0.006588],
              [104.522987, -0.001248],
              [104.513245, 0.013289],
              [104.532501, 0.026389],
            ],
          ],
          [
            [
              [104.842224, -0.035555],
              [104.879166, -0.081111],
              [104.837502, -0.053059],
              [104.842224, -0.035555],
            ],
          ],
          [
            [
              [104.731598, -0.098751],
              [104.766388, -0.148334],
              [104.745003, -0.139445],
              [104.731598, -0.098751],
            ],
          ],
          [
            [
              [104.470001, -0.277219],
              [104.491943, -0.307778],
              [104.46389, -0.31333],
              [104.459717, -0.328329],
              [104.385834, -0.298611],
              [104.470001, -0.277219],
            ],
          ],
          [
            [
              [104.233887, -0.331943],
              [104.233055, -0.355555],
              [104.221107, -0.343335],
              [104.233887, -0.331943],
            ],
          ],
          [
            [
              [104.320831, -0.360834],
              [104.324722, -0.339439],
              [104.337776, -0.38889],
              [104.311119, -0.416878],
              [104.346107, -0.44639],
              [104.346947, -0.3875],
              [104.385834, -0.413334],
              [104.430275, -0.383611],
              [104.440277, -0.340278],
              [104.480415, -0.335485],
              [104.597427, -0.45986],
              [104.517776, -0.57167],
              [104.503326, -0.64694],
              [104.428886, -0.57639],
              [104.395279, -0.604722],
              [104.389168, -0.666944],
              [104.355835, -0.679443],
              [104.330559, -0.514445],
              [104.30722, -0.539719],
              [104.2425, -0.485833],
              [104.276947, -0.395556],
              [104.320831, -0.360834],
            ],
          ],
          [
            [
              [104.156113, -0.3375],
              [104.177498, -0.350833],
              [104.157501, -0.36528],
              [104.142776, -0.350277],
              [104.156113, -0.3375],
            ],
          ],
          [
            [
              [104.186111, -0.360556],
              [104.230278, -0.364439],
              [104.234169, -0.386112],
              [104.185555, -0.38889],
              [104.186111, -0.360556],
            ],
          ],
          [
            [
              [104.196114, -0.392222],
              [104.229156, -0.39389],
              [104.223053, -0.429445],
              [104.195274, -0.42361],
              [104.196114, -0.392222],
            ],
          ],
          [
            [
              [107.964722, 4.66889],
              [107.927498, 4.693334],
              [108.007179, 4.775322],
              [107.964722, 4.66889],
            ],
          ],
          [
            [
              [108.120285, 3.726185],
              [108.18882, 3.783804],
              [108.275383, 3.710817],
              [108.208305, 3.802454],
              [108.061745, 3.83516],
              [107.961945, 4.003333],
              [108.07386, 4.06799],
              [108.218857, 4.23043],
              [108.242348, 4.216281],
              [108.233963, 4.128587],
              [108.402809, 3.96678],
              [108.389877, 3.893811],
              [108.362556, 3.90342],
              [108.352882, 3.876487],
              [108.367233, 3.895001],
              [108.378372, 3.856221],
              [108.407944, 3.886981],
              [108.410088, 3.858323],
              [108.387474, 3.793217],
              [108.309113, 3.730069],
              [108.296234, 3.657469],
              [108.223572, 3.663732],
              [108.156494, 3.630646],
              [108.089989, 3.67947],
              [108.120285, 3.726185],
            ],
          ],
          [
            [
              [107.860283, 4.160001],
              [107.863892, 4.1275],
              [107.84417, 4.111667],
              [107.860283, 4.160001],
            ],
          ],
          [
            [
              [107.897781, 3.913612],
              [107.921669, 3.900555],
              [107.911942, 3.88139],
              [107.894302, 3.892223],
              [107.897781, 3.913612],
            ],
          ],
          [
            [
              [108.002502, 3.817779],
              [108.02861, 3.80722],
              [108.040001, 3.765833],
              [108.012573, 3.778473],
              [108.002502, 3.817779],
            ],
          ],
          [
            [
              [108.116943, 3.763059],
              [108.126389, 3.755278],
              [108.113892, 3.751388],
              [108.116943, 3.763059],
            ],
          ],
          [
            [
              [108.05246, 3.715161],
              [108.089447, 3.694444],
              [108.085945, 3.682095],
              [108.044151, 3.676598],
              [108.05246, 3.715161],
            ],
          ],
          [
            [
              [108.053886, 3.669722],
              [108.083054, 3.654445],
              [108.081947, 3.633611],
              [108.050545, 3.631025],
              [108.053886, 3.669722],
            ],
          ],
          [
            [
              [108.105278, 3.637221],
              [108.121407, 3.606961],
              [108.07, 3.583609],
              [108.076401, 3.612536],
              [108.105278, 3.637221],
            ],
          ],
          [
            [
              [108.044167, 3.593891],
              [108.044701, 3.556943],
              [108.033058, 3.574905],
              [108.044167, 3.593891],
            ],
          ],
          [
            [
              [108.087624, 3.583575],
              [108.095558, 3.572221],
              [108.080826, 3.574171],
              [108.087624, 3.583575],
            ],
          ],
          [
            [
              [106.343887, 3.417499],
              [106.338264, 3.351805],
              [106.320557, 3.32194],
              [106.329086, 3.40451],
              [106.343887, 3.417499],
            ],
          ],
          [
            [
              [106.279671, 3.402523],
              [106.290833, 3.387221],
              [106.268394, 3.394186],
              [106.279671, 3.402523],
            ],
          ],
          [
            [
              [106.440002, 3.395834],
              [106.443336, 3.379166],
              [106.427223, 3.3725],
              [106.440002, 3.395834],
            ],
          ],
          [
            [
              [106.185555, 3.300832],
              [106.171387, 3.332779],
              [106.226967, 3.394551],
              [106.226669, 3.31167],
              [106.212502, 3.297222],
              [106.20137, 3.325823],
              [106.199997, 3.288056],
              [106.185555, 3.300832],
            ],
          ],
          [
            [
              [106.260559, 3.34778],
              [106.264488, 3.336977],
              [106.269447, 3.381671],
              [106.302643, 3.38014],
              [106.288055, 3.250001],
              [106.273056, 3.29694],
              [106.260559, 3.289166],
              [106.284164, 3.224999],
              [106.226936, 3.259441],
              [106.260559, 3.34778],
            ],
          ],
          [
            [
              [106.407776, 3.308333],
              [106.394157, 3.289441],
              [106.392776, 3.306391],
              [106.407776, 3.308333],
            ],
          ],
          [
            [
              [106.449928, 3.250835],
              [106.454933, 3.225108],
              [106.437233, 3.24],
              [106.449928, 3.250835],
            ],
          ],
          [
            [
              [106.202011, 3.228541],
              [106.226669, 3.235834],
              [106.288063, 3.179441],
              [106.278267, 3.07611],
              [106.248611, 3.121111],
              [106.236664, 3.095555],
              [106.210556, 3.120833],
              [106.202011, 3.228541],
            ],
          ],
          [
            [
              [106.304733, 3.234441],
              [106.297379, 3.215611],
              [106.291664, 3.230277],
              [106.304733, 3.234441],
            ],
          ],
          [
            [
              [106.486107, 3.21139],
              [106.501877, 3.202296],
              [106.498055, 3.183612],
              [106.47683, 3.19026],
              [106.486107, 3.21139],
            ],
          ],
          [
            [
              [106.316948, 3.163056],
              [106.311386, 3.135834],
              [106.333611, 3.158612],
              [106.343544, 3.123333],
              [106.308411, 3.083893],
              [106.284447, 3.123055],
              [106.316948, 3.163056],
            ],
          ],
          [
            [
              [106.086945, 3.158334],
              [106.099167, 3.13861],
              [106.089157, 3.12278],
              [106.073891, 3.146389],
              [106.086945, 3.158334],
            ],
          ],
          [
            [
              [106.419167, 3.150555],
              [106.436386, 3.128612],
              [106.402779, 3.134444],
              [106.419167, 3.150555],
            ],
          ],
          [
            [
              [106.395554, 3.15139],
              [106.396942, 3.136391],
              [106.379448, 3.138332],
              [106.395554, 3.15139],
            ],
          ],
          [
            [
              [106.118614, 3.133888],
              [106.122498, 3.116945],
              [106.109726, 3.124999],
              [106.118614, 3.133888],
            ],
          ],
          [
            [
              [105.652222, 3.120833],
              [105.674446, 3.090347],
              [105.639168, 3.090277],
              [105.652222, 3.120833],
            ],
          ],
          [
            [
              [105.687767, 3.118059],
              [105.694717, 3.102219],
              [105.673889, 3.109444],
              [105.687767, 3.118059],
            ],
          ],
          [
            [
              [105.960831, 3.102222],
              [105.961388, 3.091111],
              [105.946663, 3.098055],
              [105.960831, 3.102222],
            ],
          ],
          [
            [
              [105.701668, 3.10028],
              [105.735275, 3.083056],
              [105.711388, 3.073609],
              [105.701668, 3.10028],
            ],
          ],
          [
            [
              [106.356041, 3.092223],
              [106.353615, 3.048056],
              [106.34111, 3.064445],
              [106.356041, 3.092223],
            ],
          ],
          [
            [
              [105.98278, 3.087781],
              [105.991669, 3.071941],
              [105.977554, 3.016952],
              [105.963333, 3.040277],
              [105.98278, 3.087781],
            ],
          ],
          [
            [
              [105.835556, 2.99167],
              [105.852219, 2.957777],
              [105.82, 2.96889],
              [105.828056, 2.910556],
              [105.79583, 2.908611],
              [105.821945, 2.88639],
              [105.78389, 2.907499],
              [105.76722, 2.871391],
              [105.722557, 2.873294],
              [105.769997, 2.839166],
              [105.72583, 2.816667],
              [105.693054, 2.850277],
              [105.714722, 2.959167],
              [105.713058, 2.983333],
              [105.675003, 3.008611],
              [105.70472, 3.031945],
              [105.690552, 3.057779],
              [105.719032, 3.029859],
              [105.739998, 3.05],
              [105.7425, 2.97222],
              [105.835556, 2.99167],
            ],
          ],
          [
            [
              [108.845383, 3.052106],
              [108.868889, 3.042221],
              [108.864662, 3.013659],
              [108.842628, 3.011941],
              [108.845383, 3.052106],
            ],
          ],
          [
            [
              [106.408333, 3.037223],
              [106.407776, 3.012779],
              [106.392502, 3.029171],
              [106.408333, 3.037223],
            ],
          ],
          [
            [
              [107.785553, 3.02028],
              [107.813263, 2.98029],
              [107.757477, 2.971379],
              [107.747498, 3.006042],
              [107.785553, 3.02028],
            ],
          ],
          [
            [
              [108.867599, 3.010284],
              [108.890396, 2.99946],
              [108.884453, 2.879908],
              [108.817139, 2.843667],
              [108.774979, 2.89059],
              [108.867599, 3.010284],
            ],
          ],
          [
            [
              [106.12722, 2.939444],
              [106.149445, 2.918888],
              [106.111946, 2.92694],
              [106.12722, 2.939444],
            ],
          ],
          [
            [
              [105.68898, 2.924182],
              [105.6875, 2.908889],
              [105.67778, 2.918888],
              [105.68898, 2.924182],
            ],
          ],
          [
            [
              [106.221657, 2.745001],
              [106.200279, 2.75889],
              [106.222221, 2.767223],
              [106.196114, 2.811112],
              [106.228333, 2.804441],
              [106.254448, 2.72389],
              [106.221657, 2.745001],
            ],
          ],
          [
            [
              [108.921387, 2.767501],
              [108.914436, 2.737501],
              [108.886551, 2.726805],
              [108.921387, 2.767501],
            ],
          ],
          [
            [
              [106.167778, 2.762223],
              [106.193336, 2.746109],
              [106.184723, 2.739167],
              [106.167778, 2.762223],
            ],
          ],
          [
            [
              [108.559059, 2.722721],
              [108.583336, 2.686391],
              [108.535835, 2.652683],
              [108.535767, 2.67608],
              [108.569534, 2.680347],
              [108.545631, 2.708569],
              [108.578888, 2.696112],
              [108.559059, 2.722721],
            ],
          ],
          [
            [
              [109.053337, 2.495001],
              [109.006645, 2.489467],
              [109.031776, 2.516169],
              [108.979179, 2.520744],
              [108.975914, 2.555733],
              [109.120514, 2.530496],
              [109.113327, 2.503611],
              [109.053337, 2.495001],
            ],
          ],
          [
            [
              [108.949013, 2.500911],
              [108.974968, 2.49068],
              [108.973106, 2.454099],
              [108.933647, 2.44834],
              [108.906662, 2.501989],
              [108.949013, 2.533502],
              [108.949013, 2.500911],
            ],
          ],
          [
            [
              [108.985863, 2.506519],
              [108.99971, 2.492658],
              [108.988022, 2.48843],
              [108.985863, 2.506519],
            ],
          ],
          [
            [
              [108.99913, 2.465561],
              [108.984047, 2.465561],
              [108.984047, 2.483391],
              [108.99913, 2.483391],
              [108.99913, 2.465561],
            ],
          ],
          [
            [
              [104.392174, 1.015839],
              [104.397118, 0.996733],
              [104.365883, 0.98954],
              [104.392174, 1.015839],
            ],
          ],
        ],
      },
      id: 21,
      properties: {
        ID: 76,
        kode: 21,
        provinsi: "KEPULAUAN RIAU",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [119.16658, -3.487701],
              [119.108658, -3.516343],
              [119.021446, -3.512368],
              [118.996391, -3.564717],
              [118.967438, -3.545067],
              [118.936943, -3.570281],
              [118.906113, -3.525279],
              [118.845711, -3.379756],
              [118.85833, -3.30111],
              [118.828476, -3.168945],
              [118.775139, -3.10422],
              [118.796806, -3.070608],
              [118.838623, -3.081085],
              [118.886108, -2.890834],
              [118.84639, -2.849721],
              [118.769447, -2.867222],
              [118.756668, -2.785],
              [118.818298, -2.61948],
              [118.868889, -2.679672],
              [118.91111, -2.666111],
              [119.030479, -2.58205],
              [119.044724, -2.506667],
              [119.144447, -2.470001],
              [119.121391, -2.319721],
              [119.144722, -2.200281],
              [119.187775, -2.151111],
              [119.211937, -1.99778],
              [119.288063, -1.9525],
              [119.330559, -1.962223],
              [119.363609, -1.853891],
              [119.311111, -1.798611],
              [119.28167, -1.68972],
              [119.325836, -1.589167],
              [119.28833, -1.450555],
              [119.291656, -1.390281],
              [119.332779, -1.349445],
              [119.30278, -1.273612],
              [119.339722, -1.17],
              [119.376663, -1.165556],
              [119.464722, -1.06861],
              [119.553627, -0.860949],
              [119.550926, -1.008439],
              [119.584396, -1.118209],
              [119.610977, -1.12573],
              [119.581657, -1.25812],
              [119.474258, -1.287229],
              [119.467911, -1.306169],
              [119.508636, -1.31016],
              [119.423126, -1.356679],
              [119.529373, -1.427779],
              [119.623283, -1.395169],
              [119.695396, -1.450899],
              [119.659027, -1.50289],
              [119.777779, -1.692499],
              [119.756668, -1.755519],
              [119.867416, -1.76982],
              [119.909172, -1.834719],
              [119.860428, -1.87573],
              [119.873543, -1.948739],
              [119.817101, -2.044529],
              [119.727409, -2.07925],
              [119.61335, -2.204939],
              [119.596573, -2.294341],
              [119.690308, -2.33612],
              [119.715866, -2.39282],
              [119.689026, -2.437739],
              [119.720917, -2.500069],
              [119.700089, -2.553469],
              [119.751106, -2.604909],
              [119.761757, -2.677659],
              [119.73996, -2.71976],
              [119.643578, -2.75641],
              [119.493317, -2.74063],
              [119.5252, -2.793351],
              [119.534187, -2.94152],
              [119.62973, -3.113259],
              [119.539963, -3.133521],
              [119.484596, -3.18489],
              [119.396072, -3.19317],
              [119.490921, -3.48397],
              [119.476357, -3.504407],
              [119.427223, -3.45972],
              [119.373055, -3.463334],
              [119.304726, -3.425277],
              [119.236168, -3.479168],
              [119.16658, -3.487701],
            ],
          ],
          [
            [
              [118.891388, -2.612777],
              [118.888885, -2.653612],
              [118.877777, -2.62639],
              [118.891388, -2.612777],
            ],
          ],
        ],
      },
      id: 76,
      properties: {
        ID: 77,
        kode: 76,
        provinsi: "SULAWESI BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [119.551262, -0.861102],
              [119.620102, -0.827921],
              [119.628067, -0.795006],
              [119.680214, -0.767804],
              [119.672073, -0.701232],
              [119.725906, -0.65805],
              [119.761536, -0.681504],
              [119.810547, -0.824481],
              [119.844048, -0.881364],
              [119.877937, -0.860083],
              [119.876678, -0.800739],
              [119.857048, -0.776077],
              [119.858978, -0.711951],
              [119.82312, -0.687051],
              [119.759331, -0.489319],
              [119.755516, -0.43625],
              [119.777512, -0.278784],
              [119.817886, -0.188819],
              [119.793221, -0.1203],
              [119.730637, -0.144836],
              [119.675064, -0.120693],
              [119.606422, -0.011014],
              [119.719109, -0.007734],
              [119.767677, -0.076805],
              [119.777496, -0.112435],
              [119.836311, -0.110336],
              [119.888161, -0.012285],
              [119.869308, 0.103943],
              [119.773888, 0.195469],
              [119.803307, 0.235098],
              [119.886375, 0.210903],
              [119.906456, 0.230215],
              [119.849724, 0.35105],
              [119.889595, 0.39088],
              [119.87677, 0.437173],
              [119.912537, 0.474808],
              [119.999992, 0.48103],
              [120.045471, 0.508192],
              [120.036507, 0.605598],
              [120.017326, 0.662879],
              [120.07708, 0.73949],
              [120.131271, 0.739655],
              [120.231522, 0.792128],
              [120.245316, 0.836357],
              [120.234756, 0.882558],
              [120.246323, 0.957992],
              [120.347801, 0.986282],
              [120.328423, 0.85386],
              [120.375938, 0.833208],
              [120.388908, 0.801644],
              [120.475189, 0.778041],
              [120.500801, 0.794271],
              [120.577087, 0.769187],
              [120.600052, 0.806312],
              [120.606506, 0.872798],
              [120.67897, 0.960633],
              [120.721901, 0.959311],
              [120.78904, 1.036012],
              [120.797989, 1.093499],
              [120.776329, 1.112198],
              [120.824081, 1.183676],
              [120.808014, 1.271],
              [120.83316, 1.320694],
              [120.92836, 1.329284],
              [120.976059, 1.348508],
              [121.065201, 1.308341],
              [121.100578, 1.321008],
              [121.232872, 1.241835],
              [121.301094, 1.256887],
              [121.355553, 1.253551],
              [121.407257, 1.269449],
              [121.44651, 1.318008],
              [121.470947, 1.272841],
              [121.43441, 1.230314],
              [121.431061, 1.172257],
              [121.483253, 1.112933],
              [121.561028, 1.069681],
              [121.707085, 1.060967],
              [121.858894, 1.099807],
              [121.888367, 1.086147],
              [121.936829, 1.106721],
              [121.960297, 1.046818],
              [121.991379, 1.027292],
              [122.105263, 1.073977],
              [122.166107, 1.037744],
              [122.188141, 1.045298],
              [122.067818, 0.997213],
              [122.02533, 0.949058],
              [121.993927, 0.94102],
              [121.968292, 0.894658],
              [121.925529, 0.946584],
              [121.882187, 0.9727],
              [121.831047, 0.963612],
              [121.754608, 0.926077],
              [121.673096, 0.914232],
              [121.620621, 0.883505],
              [121.499672, 0.850688],
              [121.386032, 0.870693],
              [121.294579, 0.82408],
              [121.260277, 0.78299],
              [121.225578, 0.708211],
              [121.168579, 0.690562],
              [121.247383, 0.597502],
              [121.35453, 0.571319],
              [121.345665, 0.474487],
              [121.296829, 0.496804],
              [121.246132, 0.462963],
              [121.183212, 0.459422],
              [121.152977, 0.409079],
              [121.088135, 0.397582],
              [121.032486, 0.439164],
              [120.905403, 0.393952],
              [120.861519, 0.438808],
              [120.730331, 0.473514],
              [120.698936, 0.508861],
              [120.606247, 0.518789],
              [120.528976, 0.514094],
              [120.364449, 0.452948],
              [120.304108, 0.413597],
              [120.24424, 0.338138],
              [120.211548, 0.269989],
              [120.1577, 0.222198],
              [120.121338, 0.157835],
              [120.132538, 0.125113],
              [120.103745, 0.087791],
              [120.104767, 0.006305],
              [120.089226, -0.040358],
              [120.031914, -0.088148],
              [120.040031, -0.140389],
              [120.008202, -0.176373],
              [120.00975, -0.29075],
              [120.029526, -0.303267],
              [120.039871, -0.39192],
              [120.070221, -0.443157],
              [120.046967, -0.490172],
              [120.054924, -0.630386],
              [120.102646, -0.729293],
              [120.218369, -0.845644],
              [120.245003, -0.892794],
              [120.31295, -0.967754],
              [120.40947, -0.924922],
              [120.458672, -0.993287],
              [120.505188, -0.999639],
              [120.591782, -1.168508],
              [120.569252, -1.203504],
              [120.570587, -1.253602],
              [120.637337, -1.313295],
              [120.6409, -1.37013],
              [120.690422, -1.420703],
              [120.729805, -1.384694],
              [120.842125, -1.368169],
              [120.858665, -1.41577],
              [120.959259, -1.414844],
              [120.978638, -1.403112],
              [121.050652, -1.441153],
              [121.117386, -1.423487],
              [121.201614, -1.279033],
              [121.21608, -1.211487],
              [121.277924, -1.157306],
              [121.300293, -1.103074],
              [121.391403, -1.007929],
              [121.446655, -0.974778],
              [121.472191, -0.905653],
              [121.537224, -0.876336],
              [121.587563, -0.869395],
              [121.606941, -0.829822],
              [121.65081, -0.806444],
              [121.667122, -0.85892],
              [121.654663, -0.911058],
              [121.768211, -0.973061],
              [121.79818, -0.96249],
              [121.949707, -0.997026],
              [122.005463, -0.941112],
              [122.101791, -0.963619],
              [122.140907, -0.926582],
              [122.151131, -0.864294],
              [122.202255, -0.790099],
              [122.312874, -0.79761],
              [122.370705, -0.778494],
              [122.417145, -0.786604],
              [122.455696, -0.763],
              [122.526512, -0.787241],
              [122.627403, -0.767298],
              [122.685989, -0.814966],
              [122.72934, -0.814772],
              [122.77961, -0.777899],
              [122.914139, -0.768896],
              [122.879929, -0.722777],
              [122.762383, -0.702591],
              [122.811676, -0.634691],
              [122.838959, -0.646788],
              [122.936707, -0.627541],
              [122.956444, -0.648756],
              [123.014275, -0.603136],
              [123.113899, -0.574524],
              [123.17347, -0.589315],
              [123.19577, -0.574752],
              [123.273453, -0.591004],
              [123.409821, -0.660818],
              [123.381783, -0.675253],
              [123.452087, -0.765581],
              [123.383072, -0.931395],
              [123.390602, -0.960441],
              [123.34938, -1.03729],
              [123.263397, -1.05125],
              [123.228004, -1.006776],
              [123.144241, -0.943434],
              [123.147484, -0.889334],
              [123.101006, -0.840044],
              [123.061485, -0.869743],
              [123.056534, -0.902925],
              [122.978981, -0.905142],
              [122.890213, -0.933499],
              [122.859497, -0.927227],
              [122.790009, -0.950041],
              [122.794479, -0.999178],
              [122.723732, -1.085598],
              [122.708473, -1.134077],
              [122.666412, -1.135592],
              [122.63237, -1.171871],
              [122.618118, -1.238488],
              [122.560532, -1.262113],
              [122.556595, -1.30897],
              [122.495201, -1.351943],
              [122.483078, -1.388393],
              [122.415749, -1.437588],
              [122.390541, -1.48866],
              [122.316772, -1.522827],
              [122.220932, -1.595521],
              [122.023979, -1.613491],
              [121.959595, -1.675115],
              [121.896263, -1.692171],
              [121.8778, -1.675358],
              [121.809525, -1.730459],
              [121.806778, -1.760933],
              [121.749054, -1.887227],
              [121.684959, -1.943017],
              [121.634857, -1.956984],
              [121.565193, -1.949181],
              [121.525887, -1.893084],
              [121.462646, -1.864683],
              [121.451309, -1.804206],
              [121.372246, -1.809819],
              [121.322395, -1.77549],
              [121.295853, -1.7989],
              [121.291077, -1.858329],
              [121.333565, -1.87836],
              [121.317474, -1.937669],
              [121.375557, -1.963591],
              [121.418983, -1.939971],
              [121.447121, -1.985441],
              [121.525383, -2.049364],
              [121.549866, -2.171898],
              [121.609505, -2.189377],
              [121.680809, -2.181712],
              [121.724426, -2.20448],
              [121.795708, -2.291534],
              [121.821411, -2.294693],
              [121.839111, -2.348679],
              [121.901405, -2.429927],
              [121.957466, -2.521174],
              [121.986511, -2.601621],
              [122.033119, -2.65964],
              [122.004349, -2.712314],
              [122.085533, -2.788894],
              [122.13887, -2.790327],
              [122.181404, -2.823496],
              [122.180618, -2.869903],
              [122.292221, -2.890996],
              [122.319016, -2.914855],
              [122.305008, -2.956492],
              [122.25071, -3.022647],
              [122.33329, -3.083526],
              [122.383438, -3.143221],
              [122.412956, -3.128048],
              [122.486099, -3.180516],
              [122.425407, -3.203624],
              [122.428352, -3.248899],
              [122.384857, -3.258627],
              [122.323967, -3.240767],
              [122.312798, -3.271106],
              [122.285965, -3.253934],
              [122.294449, -3.195179],
              [122.274086, -3.138374],
              [122.241173, -3.138603],
              [122.190437, -3.094346],
              [122.191582, -3.032609],
              [122.130539, -3.015782],
              [122.090057, -2.961801],
              [122.000359, -2.962439],
              [121.940231, -2.932159],
              [121.899376, -2.80432],
              [121.872299, -2.777285],
              [121.81871, -2.763949],
              [121.797012, -2.710249],
              [121.74305, -2.608478],
              [121.700546, -2.548773],
              [121.639519, -2.535414],
              [121.56945, -2.49626],
              [121.510712, -2.495261],
              [121.391274, -2.409437],
              [121.304352, -2.365168],
              [121.22654, -2.352717],
              [121.15377, -2.328169],
              [120.953987, -2.237536],
              [120.821678, -2.207236],
              [120.74411, -2.228615],
              [120.70327, -2.212562],
              [120.595131, -2.138367],
              [120.480461, -1.998821],
              [120.469643, -1.962179],
              [120.401123, -1.888412],
              [120.383064, -1.890121],
              [120.354927, -1.999104],
              [120.329796, -2.054484],
              [120.26606, -2.022335],
              [120.181938, -2.029071],
              [120.11956, -2.008276],
              [120.101303, -1.966918],
              [119.994949, -1.963335],
              [119.963005, -2.000149],
              [119.887428, -2.045559],
              [119.83773, -2.051188],
              [119.815765, -2.015383],
              [119.848412, -1.965073],
              [119.869141, -1.892153],
              [119.907639, -1.835855],
              [119.902878, -1.796736],
              [119.865753, -1.770845],
              [119.762688, -1.764873],
              [119.775932, -1.693306],
              [119.732208, -1.607528],
              [119.669128, -1.545653],
              [119.659355, -1.496283],
              [119.696596, -1.459508],
              [119.639478, -1.405974],
              [119.516769, -1.436377],
              [119.497852, -1.394083],
              [119.450577, -1.395969],
              [119.431, -1.336197],
              [119.505386, -1.30987],
              [119.505157, -1.277503],
              [119.570869, -1.272736],
              [119.603714, -1.166935],
              [119.567673, -1.02293],
              [119.551262, -0.861102],
            ],
            [
              [120.531853, -1.873765],
              [120.528267, -1.913569],
              [120.564026, -1.967635],
              [120.606293, -1.995662],
              [120.631844, -2.059787],
              [120.685783, -2.066975],
              [120.707199, -2.024403],
              [120.672348, -1.972287],
              [120.657585, -1.881136],
              [120.599411, -1.790897],
              [120.530083, -1.7894],
              [120.531853, -1.873765],
            ],
          ],
          [
            [
              [123.169479, -1.634564],
              [123.106308, -1.605504],
              [123.103592, -1.583008],
              [123.164406, -1.543593],
              [123.185196, -1.513129],
              [123.157669, -1.31768],
              [123.103828, -1.349413],
              [123.032669, -1.453553],
              [123.021568, -1.495429],
              [122.952698, -1.550409],
              [122.909073, -1.605003],
              [122.865974, -1.600239],
              [122.820557, -1.480622],
              [122.78537, -1.451908],
              [122.791542, -1.383733],
              [122.833527, -1.271164],
              [122.8769, -1.236489],
              [122.904968, -1.184323],
              [122.97934, -1.202721],
              [123.109581, -1.169781],
              [123.145302, -1.208792],
              [123.186867, -1.162364],
              [123.2453, -1.232014],
              [123.191849, -1.327573],
              [123.248268, -1.394754],
              [123.284081, -1.361707],
              [123.360313, -1.231369],
              [123.440392, -1.235385],
              [123.48597, -1.2709],
              [123.556793, -1.288018],
              [123.534393, -1.366252],
              [123.539093, -1.397947],
              [123.51049, -1.458997],
              [123.459213, -1.518635],
              [123.407463, -1.52446],
              [123.367729, -1.503777],
              [123.300964, -1.414419],
              [123.26075, -1.470734],
              [123.229568, -1.599808],
              [123.169479, -1.634564],
            ],
          ],
          [
            [
              [123.476669, -1.656222],
              [123.498703, -1.588354],
              [123.477654, -1.574449],
              [123.501411, -1.507485],
              [123.547562, -1.509387],
              [123.571487, -1.607135],
              [123.627731, -1.62471],
              [123.615463, -1.694854],
              [123.576256, -1.726763],
              [123.492409, -1.71136],
              [123.476669, -1.656222],
            ],
          ],
          [
            [
              [121.914711, -0.453557],
              [121.917236, -0.519645],
              [121.834412, -0.496036],
              [121.73484, -0.512026],
              [121.701439, -0.564406],
              [121.662193, -0.558711],
              [121.694901, -0.492329],
              [121.754837, -0.431368],
              [121.783325, -0.451543],
              [121.843658, -0.414951],
              [121.914711, -0.453557],
            ],
          ],
          [
            [
              [121.96521, -0.420374],
              [121.916389, -0.440287],
              [121.8722, -0.416031],
              [121.872589, -0.35888],
              [122.054825, -0.352623],
              [122.053284, -0.389249],
              [122.059982, -0.404818],
              [121.96521, -0.420374],
            ],
          ],
          [
            [
              [123.135948, -1.780573],
              [123.154221, -1.820214],
              [123.140778, -1.866415],
              [123.063591, -1.920046],
              [123.062195, -1.831136],
              [123.092239, -1.770375],
              [123.135948, -1.780573],
            ],
          ],
          [
            [
              [122.096016, -0.40342],
              [122.077263, -0.429949],
              [122.056259, -0.36745],
              [122.0662, -0.311042],
              [122.098, -0.295803],
              [122.149895, -0.39855],
              [122.096016, -0.40342],
            ],
          ],
          [
            [
              [123.86039, -1.997033],
              [123.820366, -2.012111],
              [123.789017, -1.979887],
              [123.772453, -1.903466],
              [123.80835, -1.893784],
              [123.850426, -1.945709],
              [123.86039, -1.997033],
            ],
          ],
          [
            [
              [122.362381, -0.362636],
              [122.29538, -0.268201],
              [122.306877, -0.23959],
              [122.375923, -0.284257],
              [122.362381, -0.362636],
            ],
          ],
          [
            [
              [121.620766, -0.211886],
              [121.562981, -0.181929],
              [121.601471, -0.129324],
              [121.644028, -0.13074],
              [121.649246, -0.193653],
              [121.620766, -0.211886],
            ],
          ],
          [
            [
              [123.31263, -1.720765],
              [123.360176, -1.677891],
              [123.39093, -1.708563],
              [123.314911, -1.784292],
              [123.267799, -1.787167],
              [123.31263, -1.720765],
            ],
          ],
          [
            [
              [123.325485, -1.200815],
              [123.313316, -1.265722],
              [123.274651, -1.221891],
              [123.325485, -1.200815],
            ],
          ],
        ],
      },
      id: 72,
      properties: {
        ID: 20,
        kode: 72,
        provinsi: "SULAWESI TENGAH",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [113.918137, 0.979328],
              [113.919106, 0.982897],
              [113.890594, 1.038177],
              [113.938293, 1.06126],
              [113.987701, 1.144419],
              [114.047989, 1.132663],
              [114.081848, 1.161817],
              [114.119576, 1.156378],
              [114.140587, 1.206963],
              [114.137711, 1.21268],
              [114.152161, 1.382885],
              [114.153831, 1.384724],
              [114.204971, 1.407545],
              [114.235268, 1.4426],
              [114.273003, 1.448177],
              [114.377747, 1.491683],
              [114.409302, 1.514634],
              [114.538544, 1.435658],
              [114.571404, 1.435368],
              [114.604622, 1.491522],
              [114.614647, 1.579356],
              [114.649025, 1.595495],
              [114.706841, 1.675499],
              [114.712097, 1.782442],
              [114.696716, 1.813631],
              [114.740334, 1.867859],
              [114.794128, 1.85701],
              [114.821785, 1.896762],
              [114.877747, 1.917274],
              [114.853745, 1.97312],
              [114.8937, 2.010891],
              [114.868645, 2.035361],
              [114.806808, 2.040769],
              [114.813965, 2.108023],
              [114.783752, 2.140973],
              [114.803024, 2.243819],
              [114.917473, 2.260886],
              [114.951164, 2.284624],
              [114.956024, 2.362647],
              [114.995422, 2.353104],
              [115.139877, 2.470896],
              [115.192932, 2.470649],
              [115.237038, 2.493989],
              [115.237389, 2.532009],
              [115.162666, 2.608151],
              [115.11335, 2.589236],
              [115.119492, 2.688252],
              [115.109703, 2.727942],
              [115.142548, 2.752551],
              [115.139648, 2.813438],
              [115.095024, 2.826418],
              [115.149261, 2.882345],
              [115.14698, 2.912522],
              [115.240479, 2.98812],
              [115.287224, 3.053157],
              [115.328346, 2.9866],
              [115.395432, 2.989984],
              [115.430275, 3.029384],
              [115.486443, 3.032288],
              [115.515167, 3.066232],
              [115.513947, 3.108752],
              [115.56398, 3.170708],
              [115.522049, 3.210068],
              [115.536972, 3.327598],
              [115.566292, 3.416362],
              [115.592957, 3.454614],
              [115.625664, 3.419666],
              [115.65303, 3.442058],
              [115.610542, 3.530491],
              [115.605888, 3.580764],
              [115.577797, 3.613187],
              [115.572044, 3.674318],
              [115.593979, 3.792897],
              [115.619545, 3.867123],
              [115.570374, 3.911689],
              [115.579765, 3.944401],
              [115.643265, 3.972893],
              [115.679153, 4.087063],
              [115.68808, 4.156209],
              [115.77063, 4.24003],
              [115.827927, 4.228227],
              [115.836105, 4.261403],
              [115.878021, 4.296675],
              [115.878632, 4.382408],
              [115.936905, 4.352961],
              [116.000031, 4.347539],
              [116.040352, 4.291376],
              [116.083778, 4.276591],
              [116.106705, 4.321579],
              [116.147995, 4.337818],
              [116.167274, 4.383142],
              [116.269272, 4.36123],
              [116.360413, 4.382039],
              [116.472488, 4.298682],
              [116.49086, 4.332563],
              [116.537659, 4.328381],
              [116.535728, 4.370454],
              [116.569977, 4.401027],
              [116.62394, 4.331343],
              [116.716843, 4.340905],
              [116.742256, 4.378986],
              [116.789459, 4.337498],
              [116.828949, 4.326515],
              [116.900375, 4.361372],
              [116.956917, 4.339827],
              [117.046944, 4.343885],
              [117.105186, 4.330876],
              [117.200363, 4.336202],
              [117.248161, 4.372694],
              [117.302917, 4.319976],
              [117.420616, 4.24595],
              [117.468033, 4.176103],
              [117.523514, 4.164959],
              [117.5222, 4.09901],
              [117.4156, 4.14167],
              [117.4309, 4.09446],
              [117.4719, 4.08227],
              [117.5483, 4.01734],
              [117.6014, 3.92868],
              [117.6522, 3.90561],
              [117.734, 3.83082],
              [117.7301, 3.81011],
              [117.7784, 3.78007],
              [117.729195, 3.751446],
              [117.64064, 3.778506],
              [117.517782, 3.778473],
              [117.479153, 3.742878],
              [117.469542, 3.704592],
              [117.5154, 3.61392],
              [117.4949, 3.59062],
              [117.3894, 3.6337],
              [117.261, 3.61355],
              [117.1716, 3.63874],
              [117.0915, 3.63283],
              [117.045083, 3.602293],
              [117.1396, 3.61612],
              [117.2156, 3.60271],
              [117.232579, 3.585285],
              [117.1983, 3.53071],
              [117.2431, 3.47226],
              [117.3577, 3.44279],
              [117.3729, 3.40771],
              [117.4161, 3.37927],
              [117.417, 3.33373],
              [117.3884, 3.31951],
              [117.3555, 3.26435],
              [117.3765, 3.22384],
              [117.3092, 3.20452],
              [117.3211, 3.17175],
              [117.4309, 3.16839],
              [117.4787, 3.09913],
              [117.4449, 3.04862],
              [117.5431, 3.06382],
              [117.5638, 3.04382],
              [117.6202, 3.05427],
              [117.6179, 3.01247],
              [117.574, 2.97733],
              [117.5555, 2.90229],
              [117.7158, 2.88863],
              [117.6173, 2.79039],
              [117.6916, 2.77908],
              [117.7781, 2.74167],
              [117.7851, 2.66235],
              [117.8066, 2.60683],
              [117.8888, 2.52976],
              [117.9305, 2.47401],
              [118.0643, 2.34815],
              [118.0901, 2.2974],
              [118.074, 2.24401],
              [118.014, 2.18865],
              [117.9275, 2.17502],
              [117.8148, 2.19708],
              [117.7299, 2.1846],
              [117.7016, 2.1581],
              [117.7213, 2.13207],
              [117.7173, 2.09919],
              [117.7235, 2.0835],
              [117.7375, 2.07845],
              [117.7956, 2.10288],
              [117.8195, 2.0615],
              [117.7884, 2.00816],
              [117.8379, 1.99989],
              [117.8649, 1.96299],
              [117.8629, 1.87479],
              [117.9103, 1.81216],
              [117.9595, 1.79128],
              [118.0344, 1.78855],
              [118.0499, 1.72371],
              [118.1197, 1.63926],
              [118.158, 1.62829],
              [118.2416, 1.55893],
              [118.2908, 1.54345],
              [118.38, 1.4839],
              [118.4058, 1.48783],
              [118.4336, 1.39582],
              [118.4934, 1.37311],
              [118.5563, 1.37154],
              [118.6434, 1.30613],
              [118.7667, 1.20048],
              [118.7625, 1.16377],
              [118.8728, 1.07013],
              [118.9472, 1.06371],
              [118.9908, 1.02751],
              [118.989792, 0.989455],
              [118.95948, 0.941661],
              [118.888748, 0.874728],
              [118.867989, 0.88197],
              [118.791107, 0.800822],
              [118.708488, 0.829904],
              [118.67495, 0.858952],
              [118.589439, 0.81014],
              [118.547104, 0.808872],
              [118.4441, 0.84539],
              [118.3716, 0.80407],
              [118.3167, 0.85014],
              [118.203391, 0.867535],
              [118.062884, 0.90385],
              [118.048734, 0.94618],
              [118.012575, 0.956512],
              [117.983957, 1.05784],
              [117.890268, 1.127162],
              [117.872475, 1.096863],
              [117.973052, 0.979862],
              [117.969661, 0.954896],
              [118.02739, 0.830761],
              [118.029101, 0.78147],
              [117.972238, 0.774156],
              [117.924001, 0.805105],
              [117.913526, 0.836769],
              [117.82257, 0.802413],
              [117.7508, 0.75383],
              [117.7084, 0.68087],
              [117.7138, 0.63162],
              [117.6745, 0.6152],
              [117.6294, 0.50554],
              [117.603751, 0.484174],
              [117.613058, 0.433703],
              [117.573731, 0.406656],
              [117.552847, 0.335006],
              [117.483113, 0.156458],
              [117.5216, 0.1229],
              [117.474096, 0.088355],
              [117.5198, -0.02957],
              [117.4843, -0.06922],
              [117.4439, -0.20578],
              [117.4173, -0.2454],
              [117.451693, -0.303003],
              [117.452628, -0.35487],
              [117.429409, -0.39466],
              [117.454981, -0.45189],
              [117.410957, -0.539794],
              [117.364597, -0.570177],
              [117.280968, -0.577501],
              [117.302875, -0.675327],
              [117.281934, -0.790019],
              [117.255953, -0.804343],
              [117.248973, -0.906305],
              [117.177134, -0.944905],
              [117.051588, -1.118463],
              [117.02264, -1.140105],
              [117.000952, -1.198912],
              [116.926496, -1.256976],
              [116.809888, -1.281959],
              [116.814287, -1.218122],
              [116.782896, -1.21137],
              [116.777922, -1.143471],
              [116.727644, -1.101795],
              [116.755748, -1.000008],
              [116.720194, -1.049158],
              [116.701447, -1.120656],
              [116.744535, -1.15446],
              [116.761161, -1.360439],
              [116.599933, -1.420734],
              [116.552587, -1.451015],
              [116.528, -1.50367],
              [116.5591, -1.59553],
              [116.487276, -1.645292],
              [116.444372, -1.64974],
              [116.32481, -1.701486],
              [116.278167, -1.734543],
              [116.252894, -1.77868],
              [116.260992, -1.809839],
              [116.379064, -1.761773],
              [116.448673, -1.76839],
              [116.453828, -1.803322],
              [116.416647, -1.86614],
              [116.458097, -1.918914],
              [116.46, -2.03306],
              [116.451, -2.06408],
              [116.3786, -2.09133],
              [116.4309, -2.13318],
              [116.5028, -2.10942],
              [116.5211, -2.15574],
              [116.5928, -2.19593],
              [116.5742, -2.33618],
              [116.554062, -2.409357],
              [116.493124, -2.381091],
              [116.320487, -2.341474],
              [116.250001, -2.316857],
              [116.186227, -2.32084],
              [115.984661, -2.312577],
              [115.890968, -2.335292],
              [115.885309, -2.374997],
              [115.837873, -2.389611],
              [115.809844, -2.277218],
              [115.813632, -2.250004],
              [115.813901, -2.25],
              [115.785043, -2.215817],
              [115.793901, -2.13127],
              [115.813393, -2.070402],
              [115.710956, -2.048324],
              [115.710694, -2.048348],
              [115.706121, -1.962304],
              [115.730987, -1.867477],
              [115.726902, -1.805778],
              [115.691899, -1.750616],
              [115.665229, -1.706676],
              [115.668327, -1.631298],
              [115.636133, -1.603781],
              [115.63121, -1.533835],
              [115.653089, -1.497869],
              [115.653402, -1.497092],
              [115.73581, -1.366078],
              [115.751405, -1.316831],
              [115.776921, -1.230763],
              [115.844508, -1.162429],
              [115.800606, -1.113091],
              [115.749481, -1.124644],
              [115.743721, -1.090938],
              [115.693001, -1.054689],
              [115.65976, -1.000104],
              [115.582848, -0.947266],
              [115.495659, -0.848081],
              [115.39312, -0.82201],
              [115.367661, -0.749212],
              [115.352211, -0.579602],
              [115.324715, -0.557164],
              [115.303055, -0.501086],
              [115.246429, -0.4417],
              [115.227875, -0.305798],
              [115.239098, -0.244186],
              [115.26992, -0.185243],
              [115.265564, -0.157903],
              [115.320732, -0.093379],
              [115.297623, -0.03339],
              [115.155769, -0.103698],
              [115.149078, -0.136886],
              [115.082069, -0.152977],
              [115.044418, -0.190297],
              [114.980179, -0.178222],
              [114.948639, -0.1902],
              [114.89846, -0.035127],
              [114.882278, 0.053212],
              [114.792274, 0.093691],
              [114.827431, 0.196637],
              [114.888893, 0.297505],
              [114.94455, 0.330936],
              [114.964165, 0.315193],
              [115.025604, 0.325491],
              [115.040817, 0.303441],
              [115.125549, 0.369575],
              [115.136154, 0.429964],
              [115.093254, 0.47235],
              [115.010025, 0.617119],
              [114.992355, 0.71701],
              [114.944992, 0.775121],
              [114.911812, 0.784313],
              [114.846718, 0.715452],
              [114.827667, 0.751281],
              [114.766129, 0.742571],
              [114.713394, 0.705227],
              [114.653, 0.685335],
              [114.589912, 0.626305],
              [114.54274, 0.631714],
              [114.51963, 0.564921],
              [114.492722, 0.57297],
              [114.429817, 0.545453],
              [114.412323, 0.495826],
              [114.353485, 0.53131],
              [114.280472, 0.540742],
              [114.211525, 0.53291],
              [114.150124, 0.584852],
              [114.172874, 0.628675],
              [114.149551, 0.67515],
              [114.105927, 0.698564],
              [114.047279, 0.67466],
              [113.962456, 0.657218],
              [113.842865, 0.665291],
              [113.843277, 0.702985],
              [113.898712, 0.745404],
              [113.889313, 0.783661],
              [113.926888, 0.843717],
              [113.881111, 0.883935],
              [113.880379, 0.925269],
              [113.918137, 0.979328],
            ],
          ],
          [
            [
              [117.735307, 3.741319],
              [117.8202, 3.71651],
              [117.773, 3.67986],
              [117.7458, 3.63324],
              [117.6693, 3.61266],
              [117.5928, 3.6191],
              [117.5217, 3.66706],
              [117.483339, 3.714001],
              [117.519964, 3.769611],
              [117.639856, 3.769512],
              [117.735307, 3.741319],
            ],
          ],
          [
            [
              [117.9081, 4.166],
              [117.9295, 4.12521],
              [117.9293, 4.06491],
              [117.8668, 4.03088],
              [117.7258, 4.1273],
              [117.7035, 4.15333],
              [117.8374, 4.19882],
              [117.9081, 4.166],
            ],
          ],
          [
            [
              [117.284, 3.578187],
              [117.4018, 3.54291],
              [117.5191, 3.47023],
              [117.4584, 3.44747],
              [117.3287, 3.48716],
              [117.2348, 3.49181],
              [117.2071, 3.53601],
              [117.2219, 3.56569],
              [117.284, 3.578187],
            ],
          ],
          [
            [
              [117.7285, 4],
              [117.6711, 3.9614],
              [117.6013, 4.01686],
              [117.5884, 4.08314],
              [117.6351, 4.14141],
              [117.6766, 4.14007],
              [117.7531, 4.06601],
              [117.7285, 4],
            ],
          ],
          [
            [
              [117.571336, 3.432597],
              [117.6196, 3.4339],
              [117.666, 3.40938],
              [117.6548, 3.24906],
              [117.6126, 3.26639],
              [117.5458, 3.31948],
              [117.5175, 3.39243],
              [117.571336, 3.432597],
            ],
          ],
          [
            [
              [117.284722, -0.583047],
              [117.350362, -0.589675],
              [117.465791, -0.555884],
              [117.505521, -0.570556],
              [117.485323, -0.609513],
              [117.455531, -0.630099],
              [117.408543, -0.694381],
              [117.284722, -0.583047],
            ],
          ],
          [
            [
              [117.478676, -0.709411],
              [117.518743, -0.736203],
              [117.552795, -0.725524],
              [117.617752, -0.745762],
              [117.612911, -0.776006],
              [117.554837, -0.784862],
              [117.520822, -0.812279],
              [117.481489, -0.798026],
              [117.441019, -0.755536],
              [117.422027, -0.708756],
              [117.478676, -0.709411],
            ],
          ],
          [
            [
              [117.328086, -0.634215],
              [117.368036, -0.663977],
              [117.375031, -0.718214],
              [117.427001, -0.831578],
              [117.401959, -0.860938],
              [117.333803, -0.758161],
              [117.300443, -0.63267],
              [117.328086, -0.634215],
            ],
          ],
          [
            [
              [118.793643, 1.373142],
              [118.849082, 1.390535],
              [118.846873, 1.264392],
              [118.868597, 1.206755],
              [118.84141, 1.157823],
              [118.799051, 1.273097],
              [118.806679, 1.344867],
              [118.793643, 1.373142],
            ],
          ],
          [
            [
              [117.8503, 3.52706],
              [117.873, 3.46497],
              [117.8436, 3.44712],
              [117.7598, 3.50474],
              [117.7535, 3.55367],
              [117.8002, 3.58004],
              [117.8503, 3.52706],
            ],
          ],
          [
            [
              [117.301046, -0.6952],
              [117.328931, -0.766548],
              [117.373548, -0.84016],
              [117.3574, -0.897701],
              [117.314924, -0.878245],
              [117.290932, -0.782899],
              [117.301046, -0.6952],
            ],
          ],
          [
            [
              [117.5268, 3.483],
              [117.4571, 3.50896],
              [117.4863, 3.54168],
              [117.6184, 3.49164],
              [117.6091, 3.46713],
              [117.5268, 3.483],
            ],
          ],
          [
            [
              [117.487074, -0.562406],
              [117.477669, -0.527304],
              [117.548595, -0.528936],
              [117.584949, -0.568485],
              [117.517488, -0.602572],
              [117.511297, -0.571849],
              [117.487074, -0.562406],
            ],
          ],
          [
            [
              [117.8831, 2.148],
              [117.9406, 2.12806],
              [117.9146, 2.08978],
              [117.8615, 2.14024],
              [117.8102, 2.11437],
              [117.8007, 2.17909],
              [117.8753, 2.17145],
              [117.8831, 2.148],
            ],
          ],
          [
            [
              [117.414723, -0.538925],
              [117.542898, -0.441968],
              [117.580298, -0.485445],
              [117.454401, -0.535222],
              [117.414723, -0.538925],
            ],
          ],
          [
            [
              [117.4578, 3.27099],
              [117.3947, 3.27317],
              [117.4018, 3.31067],
              [117.4496, 3.33527],
              [117.5084, 3.31657],
              [117.5201, 3.27196],
              [117.4578, 3.27099],
            ],
          ],
          [
            [
              [117.7183, 3.86904],
              [117.7415, 3.8705],
              [117.8322, 3.80283],
              [117.8272, 3.77821],
              [117.7471, 3.80087],
              [117.7183, 3.86904],
            ],
          ],
          [
            [
              [117.7864, 2.10276],
              [117.762, 2.09673],
              [117.7361, 2.0812],
              [117.7277, 2.0873],
              [117.728, 2.1219],
              [117.7225, 2.14282],
              [117.7329, 2.16196],
              [117.8016, 2.1653],
              [117.7864, 2.10276],
            ],
          ],
          [
            [
              [117.6719, 2.96311],
              [117.6894, 2.93645],
              [117.6007, 2.92052],
              [117.5818, 2.96184],
              [117.6676, 2.98306],
              [117.6719, 2.96311],
            ],
          ],
          [
            [
              [117.5386, 3.5684],
              [117.5755, 3.57872],
              [117.64, 3.56106],
              [117.6197, 3.53016],
              [117.5386, 3.5684],
            ],
          ],
          [
            [
              [117.303908, 3.575188],
              [117.3973, 3.60582],
              [117.4086, 3.58156],
              [117.303908, 3.575188],
            ],
          ],
          [
            [
              [117.5041, 3.3812],
              [117.503, 3.3371],
              [117.4524, 3.34706],
              [117.4489, 3.39335],
              [117.5041, 3.3812],
            ],
          ],
          [
            [
              [117.493822, -0.346391],
              [117.453203, -0.437958],
              [117.434913, -0.396641],
              [117.493822, -0.346391],
            ],
          ],
          [
            [
              [117.6295, 2.89943],
              [117.6911, 2.92742],
              [117.6996, 2.8961],
              [117.6295, 2.89943],
            ],
          ],
        ],
      },
      id: 64,
      properties: {
        ID: 21,
        kode: 64,
        provinsi: "KALIMANTAN TIMUR",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [123.465736, 0.330308],
              [123.51918, 0.449638],
              [123.527229, 0.57175],
              [123.494171, 0.636227],
              [123.368813, 0.661965],
              [123.257477, 0.749624],
              [123.240799, 0.83596],
              [123.1465, 0.881753],
              [123.117294, 0.92862],
              [123.183815, 0.906404],
              [123.222198, 0.951997],
              [123.266968, 0.919489],
              [123.381279, 0.916597],
              [123.395981, 0.90392],
              [123.553619, 0.891023],
              [123.605904, 0.906905],
              [123.732872, 0.865901],
              [123.784668, 0.835112],
              [123.920517, 0.849172],
              [124.075935, 0.923523],
              [124.137665, 0.928344],
              [124.197304, 0.986574],
              [124.2836, 1.003263],
              [124.308136, 1.021709],
              [124.357475, 1.136346],
              [124.345238, 1.158185],
              [124.41391, 1.196132],
              [124.489716, 1.18741],
              [124.544029, 1.214211],
              [124.583717, 1.194596],
              [124.610794, 1.234678],
              [124.589989, 1.269574],
              [124.51638, 1.302175],
              [124.533218, 1.356623],
              [124.57637, 1.400202],
              [124.626411, 1.418952],
              [124.674355, 1.396016],
              [124.746124, 1.4518],
              [124.829369, 1.468621],
              [124.845001, 1.523865],
              [124.806114, 1.5772],
              [124.86174, 1.604014],
              [124.923584, 1.665811],
              [124.961983, 1.730148],
              [124.994385, 1.754779],
              [125.026825, 1.735152],
              [125.014381, 1.693482],
              [125.111847, 1.663243],
              [125.154076, 1.579512],
              [125.210403, 1.550894],
              [125.242546, 1.505849],
              [125.229156, 1.461808],
              [125.192459, 1.438576],
              [125.147789, 1.439471],
              [125.07621, 1.367611],
              [125.063248, 1.296257],
              [125.020775, 1.146533],
              [124.969742, 1.069223],
              [124.898026, 0.999992],
              [124.883057, 0.963803],
              [124.788437, 0.943151],
              [124.763794, 0.888915],
              [124.725716, 0.893974],
              [124.689034, 0.829098],
              [124.625069, 0.7633],
              [124.63192, 0.712631],
              [124.599297, 0.706245],
              [124.554062, 0.635617],
              [124.560966, 0.58909],
              [124.495369, 0.548974],
              [124.512131, 0.473545],
              [124.376762, 0.446159],
              [124.32338, 0.442996],
              [124.281578, 0.404371],
              [124.08503, 0.38917],
              [124.065895, 0.36997],
              [123.998734, 0.376837],
              [123.978569, 0.360976],
              [123.814941, 0.337797],
              [123.781235, 0.312628],
              [123.74054, 0.324472],
              [123.683281, 0.30451],
              [123.590683, 0.310139],
              [123.548042, 0.324057],
              [123.49649, 0.30875],
              [123.465736, 0.330308],
            ],
          ],
          [
            [
              [126.688919, 4.37135],
              [126.715935, 4.46499],
              [126.720451, 4.525645],
              [126.750732, 4.560368],
              [126.805336, 4.546466],
              [126.855713, 4.498095],
              [126.868073, 4.445125],
              [126.851578, 4.38552],
              [126.9142, 4.283608],
              [126.792336, 4.169112],
              [126.80732, 4.123262],
              [126.799889, 4.058125],
              [126.761673, 4.012424],
              [126.699921, 4.021832],
              [126.664978, 4.057411],
              [126.733093, 4.127583],
              [126.788681, 4.253698],
              [126.714409, 4.282143],
              [126.688919, 4.37135],
            ],
          ],
          [
            [
              [125.650261, 3.509186],
              [125.678253, 3.424114],
              [125.640015, 3.37788],
              [125.523735, 3.433616],
              [125.485748, 3.47762],
              [125.51297, 3.5587],
              [125.482903, 3.598102],
              [125.442543, 3.615681],
              [125.398689, 3.663957],
              [125.422775, 3.724515],
              [125.509193, 3.716769],
              [125.597404, 3.60578],
              [125.573135, 3.580348],
              [125.623062, 3.517487],
              [125.650261, 3.509186],
            ],
          ],
          [
            [
              [125.379097, 2.797428],
              [125.422615, 2.805127],
              [125.449631, 2.75286],
              [125.407181, 2.726557],
              [125.357231, 2.737662],
              [125.379097, 2.797428],
            ],
          ],
          [
            [
              [126.723343, 3.903965],
              [126.678856, 3.872737],
              [126.667656, 3.946121],
              [126.704918, 3.95399],
              [126.723343, 3.903965],
            ],
          ],
          [
            [
              [126.82341, 3.745728],
              [126.790398, 3.759194],
              [126.753197, 3.806978],
              [126.742836, 3.864257],
              [126.798347, 3.854081],
              [126.834442, 3.81489],
              [126.849304, 3.770062],
              [126.82341, 3.745728],
            ],
          ],
          [
            [
              [125.37558, 2.35449],
              [125.434448, 2.386659],
              [125.4674, 2.352841],
              [125.439598, 2.319543],
              [125.37558, 2.35449],
            ],
          ],
          [
            [
              [125.129044, 1.830128],
              [125.181602, 1.774388],
              [125.132607, 1.753805],
              [125.129044, 1.830128],
            ],
          ],
        ],
      },
      id: 71,
      properties: {
        ID: 22,
        kode: 71,
        provinsi: "SULAWESI UTARA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [134.233337, -1.741944],
              [134.22139, -1.79278],
              [134.198441, -1.791215],
              [134.217102, -1.831198],
              [134.165833, -1.951112],
              [134.13472, -1.907501],
              [134.149719, -1.90222],
              [134.148331, -1.826945],
              [134.203339, -1.736939],
              [134.233337, -1.741944],
            ],
          ],
          [
            [
              [134.661392, -2.823219],
              [134.426788, -3.006559],
              [134.425034, -3.110369],
              [134.27594, -3.23835],
              [134.205246, -3.391239],
              [135.25766, -3.75588],
              [134.87616, -4.251943],
              [134.815277, -4.252777],
              [134.81604, -4.229375],
              [134.723328, -4.198055],
              [134.718613, -4.16],
              [134.735275, -4.171738],
              [134.713333, -4.13028],
              [134.740234, -4.122816],
              [134.656387, -4.12889],
              [134.688614, -4.134166],
              [134.69696, -4.119509],
              [134.712494, -4.133612],
              [134.687775, -4.141108],
              [134.629166, -4.118611],
              [134.65416, -4.052778],
              [134.648819, -4.099074],
              [134.656387, -4.07361],
              [134.675201, -4.088319],
              [134.72139, -4.057779],
              [134.675003, -4.04389],
              [134.661392, -3.982499],
              [134.684601, -3.985601],
              [134.686951, -3.969166],
              [134.734665, -3.96432],
              [134.739716, -3.950554],
              [134.746674, -3.97333],
              [134.765839, -3.94222],
              [134.761459, -3.970805],
              [134.815201, -3.986519],
              [134.768448, -3.96234],
              [134.76889, -3.934001],
              [134.833359, -3.95104],
              [134.830399, -3.964681],
              [134.850372, -3.991606],
              [134.865906, -3.981649],
              [134.868347, -3.999378],
              [134.870102, -3.9765],
              [134.946579, -3.982702],
              [134.963226, -3.948615],
              [134.91806, -3.965],
              [134.933716, -3.936239],
              [134.674438, -3.920278],
              [134.604172, -3.999722],
              [134.506393, -4.044443],
              [134.446457, -3.981382],
              [134.474854, -3.972669],
              [134.438339, -3.919166],
              [134.332489, -3.879719],
              [134.360718, -3.915693],
              [134.34967, -3.966287],
              [134.269501, -3.937431],
              [134.334351, -4.020581],
              [134.291107, -4.048056],
              [134.249115, -3.976414],
              [134.163391, -3.92699],
              [134.167755, -3.894139],
              [134.105377, -3.89813],
              [134.190826, -3.83283],
              [134.172089, -3.776201],
              [134.136383, -3.741941],
              [134.098358, -3.766667],
              [134.117065, -3.792155],
              [134.055283, -3.821945],
              [134.041534, -3.78193],
              [133.997223, -3.816256],
              [134.034973, -3.814554],
              [134.040817, -3.8414],
              [133.998611, -3.852777],
              [133.985596, -3.822526],
              [133.959717, -3.8625],
              [133.913696, -3.784431],
              [133.917694, -3.750667],
              [133.94194, -3.773333],
              [133.933197, -3.749494],
              [133.839478, -3.631398],
              [133.832779, -3.556],
              [133.787811, -3.597464],
              [133.774185, -3.574173],
              [133.816177, -3.727199],
              [133.751892, -3.645586],
              [133.690689, -3.671041],
              [133.707214, -3.60352],
              [133.621094, -3.47574],
              [133.636154, -3.4471],
              [133.69072, -3.410664],
              [133.701111, -3.43861],
              [133.664291, -3.31969],
              [133.676376, -3.316964],
              [133.668091, -3.22749],
              [133.701096, -3.208869],
              [133.701843, -3.17016],
              [133.764084, -3.177371],
              [133.778549, -3.213245],
              [133.771439, -3.114444],
              [133.798782, -3.119128],
              [133.827225, -3.088335],
              [133.835022, -3.018876],
              [133.896698, -3.076146],
              [133.885284, -3.114722],
              [133.891922, -3.100387],
              [133.902847, -3.120379],
              [133.922653, -3.12164],
              [133.900909, -3.09315],
              [133.921387, -3.070279],
              [133.897507, -3.068333],
              [133.914993, -3.056112],
              [133.885895, -3.071519],
              [133.850159, -2.969469],
              [133.90744, -2.932629],
              [133.85527, -2.953029],
              [133.854446, -2.924166],
              [133.79805, -2.902699],
              [133.825806, -2.942955],
              [133.793335, -3.028612],
              [133.73053, -3.030303],
              [133.648102, -3.123012],
              [133.672165, -3.209457],
              [133.648178, -3.234598],
              [133.664597, -3.340282],
              [133.634171, -3.41527],
              [133.538422, -3.428124],
              [133.514999, -3.33222],
              [133.488617, -3.307779],
              [133.513199, -3.333668],
              [133.495377, -3.375529],
              [133.518051, -3.434166],
              [133.483383, -3.441008],
              [133.441391, -3.407778],
              [133.417496, -3.414167],
              [133.442215, -3.35833],
              [133.419449, -3.38361],
              [133.430832, -3.359167],
              [133.402771, -3.32694],
              [133.417221, -3.34778],
              [133.389999, -3.336945],
              [133.428894, -3.362779],
              [133.405838, -3.394167],
              [133.427505, -3.428334],
              [133.439163, -3.41583],
              [133.487686, -3.454665],
              [133.550522, -3.454699],
              [133.596909, -3.526084],
              [133.58223, -3.571995],
              [133.409897, -3.691449],
              [133.439117, -3.59356],
              [133.428284, -3.571705],
              [133.471664, -3.538334],
              [133.459717, -3.528889],
              [133.467499, -3.515278],
              [133.421112, -3.51167],
              [133.461105, -3.542778],
              [133.44809, -3.561629],
              [133.425552, -3.544444],
              [133.443054, -3.552499],
              [133.42337, -3.571976],
              [133.432709, -3.596908],
              [133.377609, -3.592874],
              [133.330551, -3.54444],
              [133.269165, -3.605559],
              [133.246948, -3.583329],
              [133.231949, -3.594444],
              [133.269165, -3.606945],
              [133.328339, -3.554167],
              [133.368378, -3.594658],
              [133.402466, -3.595294],
              [133.394775, -3.74674],
              [133.458252, -3.85824],
              [133.400955, -3.887039],
              [133.367279, -3.873406],
              [133.352539, -3.90133],
              [133.312469, -3.841423],
              [133.272568, -3.834909],
              [133.283615, -3.783056],
              [133.236389, -3.740831],
              [133.216385, -3.754166],
              [133.236664, -3.742219],
              [133.243332, -3.758888],
              [133.260559, -3.756388],
              [133.284729, -3.8075],
              [133.26889, -3.82889],
              [133.281952, -3.848055],
              [133.233887, -3.838056],
              [133.242783, -3.850833],
              [133.297318, -3.840675],
              [133.346725, -3.905551],
              [133.402802, -3.903609],
              [133.324722, -3.983333],
              [133.289993, -3.948888],
              [133.329849, -3.989291],
              [133.25, -4.07361],
              [133.075562, -4.054166],
              [133.028061, -4.07667],
              [133.01889, -4.119169],
              [132.956924, -4.104989],
              [132.91243, -4.08514],
              [132.917496, -4.0475],
              [132.841507, -3.99035],
              [132.838837, -3.957399],
              [132.808365, -3.945114],
              [132.811829, -3.92068],
              [132.845184, -3.955489],
              [132.725403, -3.636369],
              [132.89035, -3.644141],
              [132.903168, -3.573576],
              [132.939285, -3.552016],
              [132.907013, -3.546569],
              [132.895554, -3.462307],
              [132.853043, -3.477164],
              [132.816193, -3.44364],
              [132.797775, -3.355281],
              [132.843002, -3.299095],
              [132.7733, -3.256519],
              [132.728226, -3.280229],
              [132.728088, -3.337392],
              [132.663101, -3.315729],
              [132.596161, -3.229589],
              [132.645004, -3.191944],
              [132.556488, -3.151881],
              [132.561325, -3.109818],
              [132.419998, -2.990829],
              [132.350281, -2.964999],
              [132.350555, -2.937219],
              [132.20694, -2.906389],
              [132.152771, -2.94139],
              [132.101105, -2.928889],
              [132.121384, -2.94167],
              [132.087494, -2.960001],
              [132.057785, -2.887778],
              [132.046387, -2.923334],
              [132.008331, -2.888329],
              [131.98027, -2.901945],
              [131.98172, -2.924059],
              [131.976044, -2.879119],
              [132.028885, -2.87583],
              [132.037506, -2.83806],
              [131.978149, -2.82965],
              [132.064728, -2.787222],
              [132.041107, -2.769999],
              [131.950562, -2.76694],
              [132.049728, -2.729719],
              [132.067215, -2.748055],
              [132.074173, -2.724719],
              [132.096664, -2.745555],
              [132.095276, -2.708334],
              [132.200562, -2.704166],
              [132.111115, -2.690833],
              [132.196671, -2.651666],
              [132.438614, -2.677778],
              [132.418411, -2.695058],
              [132.458328, -2.712223],
              [132.43158, -2.735032],
              [132.494446, -2.71111],
              [132.464996, -2.692221],
              [132.483719, -2.677746],
              [132.579727, -2.689167],
              [132.71611, -2.798055],
              [132.791946, -2.78972],
              [133.042374, -2.49503],
              [133.215057, -2.411247],
              [133.303406, -2.443925],
              [133.30986, -2.509443],
              [133.280548, -2.498611],
              [133.286942, -2.525001],
              [133.259171, -2.51611],
              [133.259018, -2.529652],
              [133.235275, -2.52333],
              [133.209167, -2.547222],
              [133.238327, -2.524167],
              [133.276108, -2.5425],
              [133.293335, -2.51139],
              [133.3125, -2.523888],
              [133.306396, -2.544722],
              [133.325409, -2.51521],
              [133.323822, -2.46779],
              [133.362228, -2.504723],
              [133.324997, -2.531111],
              [133.345276, -2.53889],
              [133.330276, -2.519166],
              [133.364182, -2.500979],
              [133.381012, -2.528588],
              [133.375763, -2.581443],
              [133.342773, -2.607501],
              [133.373032, -2.587],
              [133.373611, -2.618334],
              [133.358887, -2.611667],
              [133.352707, -2.625625],
              [133.373886, -2.621112],
              [133.353333, -2.653334],
              [133.376663, -2.634445],
              [133.371948, -2.671668],
              [133.291458, -2.671319],
              [133.29834, -2.644168],
              [133.264725, -2.680834],
              [133.280716, -2.690391],
              [133.229721, -2.722223],
              [133.284164, -2.70861],
              [133.31218, -2.667299],
              [133.308884, -2.701112],
              [133.319107, -2.671611],
              [133.354446, -2.689169],
              [133.38916, -2.669167],
              [133.38028, -2.72278],
              [133.390549, -2.741111],
              [133.402496, -2.73041],
              [133.410965, -2.764287],
              [133.424362, -2.760695],
              [133.381393, -2.701112],
              [133.407501, -2.693609],
              [133.408615, -2.725555],
              [133.399765, -2.667089],
              [133.435837, -2.6025],
              [133.419724, -2.541944],
              [133.401413, -2.537306],
              [133.424225, -2.50341],
              [133.449448, -2.51639],
              [133.458054, -2.616389],
              [133.427216, -2.67667],
              [133.458618, -2.711666],
              [133.475006, -2.701939],
              [133.488052, -2.727222],
              [133.477219, -2.700556],
              [133.438889, -2.686391],
              [133.438614, -2.643609],
              [133.472504, -2.638055],
              [133.457504, -2.6575],
              [133.479996, -2.68],
              [133.464554, -2.650738],
              [133.490555, -2.643329],
              [133.502502, -2.6825],
              [133.504166, -2.639167],
              [133.523056, -2.688059],
              [133.513062, -2.64639],
              [133.559174, -2.667499],
              [133.527771, -2.641389],
              [133.534927, -2.610388],
              [133.55722, -2.605279],
              [133.575272, -2.632501],
              [133.605835, -2.624439],
              [133.600006, -2.64556],
              [133.626389, -2.64306],
              [133.603607, -2.613055],
              [133.575272, -2.629444],
              [133.568832, -2.592563],
              [133.595001, -2.613609],
              [133.608612, -2.605559],
              [133.568771, -2.568179],
              [133.589981, -2.557057],
              [133.604996, -2.584723],
              [133.591934, -2.554992],
              [133.614258, -2.538354],
              [133.603928, -2.562764],
              [133.618896, -2.57028],
              [133.625549, -2.557777],
              [133.636108, -2.578059],
              [133.626938, -2.55694],
              [133.603653, -2.557449],
              [133.641525, -2.531818],
              [133.658585, -2.584484],
              [133.650558, -2.617499],
              [133.666656, -2.554531],
              [133.664993, -2.685001],
              [133.63916, -2.675278],
              [133.675827, -2.704722],
              [133.656662, -2.738891],
              [133.636948, -2.717221],
              [133.604446, -2.726668],
              [133.63916, -2.719441],
              [133.648331, -2.741325],
              [133.642502, -2.789166],
              [133.632507, -2.797779],
              [133.617996, -2.761741],
              [133.60611, -2.778333],
              [133.631104, -2.800277],
              [133.603333, -2.80778],
              [133.625, -2.809719],
              [133.627777, -2.848889],
              [133.648056, -2.868056],
              [133.625839, -2.813056],
              [133.654449, -2.803333],
              [133.649719, -2.746941],
              [133.71167, -2.7825],
              [133.666382, -2.733061],
              [133.683105, -2.713164],
              [133.694443, -2.738332],
              [133.685272, -2.70389],
              [133.709381, -2.704859],
              [133.669449, -2.67639],
              [133.69017, -2.61626],
              [133.752502, -2.624444],
              [133.731674, -2.702222],
              [133.741394, -2.664167],
              [133.758606, -2.675],
              [133.757782, -2.720833],
              [133.776382, -2.75389],
              [133.759995, -2.723333],
              [133.760559, -2.672221],
              [133.798615, -2.64861],
              [133.830276, -2.67028],
              [133.810837, -2.735],
              [133.836609, -2.66672],
              [133.852493, -2.676112],
              [133.851395, -2.709444],
              [133.92778, -2.713332],
              [133.849167, -2.703612],
              [133.85611, -2.674168],
              [133.895828, -2.67778],
              [133.845276, -2.663611],
              [133.864441, -2.63333],
              [133.88916, -2.650834],
              [133.863739, -2.605839],
              [133.843887, -2.661945],
              [133.799164, -2.638889],
              [133.807739, -2.543266],
              [133.78389, -2.487222],
              [133.821396, -2.506389],
              [133.859375, -2.49312],
              [133.871048, -2.507089],
              [133.858612, -2.49194],
              [133.792007, -2.482524],
              [133.820694, -2.4666],
              [133.821396, -2.445279],
              [133.853333, -2.473055],
              [133.871948, -2.455829],
              [133.903061, -2.482219],
              [133.964447, -2.469166],
              [133.972229, -2.483334],
              [133.947815, -2.500559],
              [133.974762, -2.548512],
              [134.01416, -2.579723],
              [133.949799, -2.50006],
              [133.974716, -2.485556],
              [133.986389, -2.446945],
              [133.948059, -2.420309],
              [133.988327, -2.389445],
              [133.998337, -2.343609],
              [134.031387, -2.338055],
              [134.020203, -2.316109],
              [134.02861, -2.343611],
              [133.996674, -2.34194],
              [133.986664, -2.363332],
              [133.958054, -2.348612],
              [133.949173, -2.32528],
              [133.991394, -2.299722],
              [134.000488, -2.241946],
              [133.98555, -2.225],
              [133.94278, -2.231945],
              [133.963058, -2.181945],
              [133.937225, -2.195609],
              [133.959717, -2.147501],
              [134.003326, -2.16528],
              [134.011322, -2.155835],
              [133.986115, -2.141666],
              [133.937225, -2.160277],
              [133.969162, -2.108334],
              [133.939438, -2.127777],
              [133.968887, -2.093059],
              [133.96611, -2.076109],
              [133.935623, -2.126735],
              [133.901642, -2.135758],
              [133.926941, -2.112222],
              [133.925827, -2.09083],
              [133.947784, -2.08139],
              [133.949158, -2.04542],
              [133.923889, -2.088888],
              [133.934723, -2.051667],
              [133.91861, -2.054719],
              [133.904999, -2.104167],
              [133.888611, -2.080556],
              [133.907227, -2.0575],
              [133.886948, -2.08028],
              [133.893326, -2.097223],
              [133.878616, -2.079719],
              [133.875275, -2.108609],
              [133.83667, -2.094445],
              [133.841949, -2.066666],
              [133.824402, -2.130756],
              [133.781387, -2.151111],
              [133.814728, -2.098333],
              [133.781311, -2.112055],
              [133.761322, -2.088129],
              [133.776947, -2.125065],
              [133.734161, -2.099167],
              [133.734161, -2.113056],
              [133.77594, -2.12671],
              [133.769608, -2.16131],
              [133.754166, -2.163334],
              [133.764999, -2.141388],
              [133.752716, -2.169155],
              [133.717285, -2.156594],
              [133.736389, -2.145281],
              [133.732498, -2.122779],
              [133.696869, -2.195697],
              [133.660599, -2.20266],
              [133.643616, -2.193612],
              [133.679443, -2.17111],
              [133.648331, -2.175554],
              [133.679443, -2.153889],
              [133.665833, -2.15667],
              [133.672745, -2.140027],
              [133.639725, -2.193056],
              [133.657349, -2.209099],
              [133.620285, -2.19361],
              [133.623215, -2.232686],
              [133.61055, -2.213609],
              [133.580276, -2.22361],
              [133.575562, -2.190556],
              [133.657776, -2.156389],
              [133.668884, -2.131109],
              [133.640274, -2.158055],
              [133.626938, -2.149167],
              [133.646393, -2.139444],
              [133.642502, -2.127499],
              [133.615005, -2.178889],
              [133.581665, -2.151667],
              [133.623062, -2.136109],
              [133.579315, -2.143179],
              [133.57135, -2.174381],
              [133.524567, -2.111629],
              [133.499939, -2.124657],
              [133.454163, -2.094167],
              [133.500076, -2.12599],
              [133.525162, -2.113699],
              [133.568054, -2.175279],
              [133.58017, -2.160141],
              [133.555054, -2.223849],
              [133.508606, -2.230172],
              [133.497498, -2.193612],
              [133.529022, -2.204816],
              [133.543091, -2.172551],
              [133.523605, -2.164444],
              [133.540558, -2.17865],
              [133.527573, -2.203779],
              [133.479172, -2.187219],
              [133.478729, -2.172865],
              [133.500473, -2.186073],
              [133.511093, -2.164902],
              [133.488647, -2.158529],
              [133.488831, -2.131351],
              [133.475006, -2.123889],
              [133.460007, -2.14],
              [133.476395, -2.125277],
              [133.487411, -2.159286],
              [133.508896, -2.164444],
              [133.500427, -2.184388],
              [133.474167, -2.174723],
              [133.487305, -2.23156],
              [133.45166, -2.199166],
              [133.454727, -2.227779],
              [133.415833, -2.224722],
              [133.430252, -2.215015],
              [133.40921, -2.200785],
              [133.420273, -2.2],
              [133.426117, -2.157499],
              [133.419235, -2.199747],
              [133.407776, -2.200238],
              [133.428345, -2.216499],
              [133.382889, -2.211253],
              [133.372223, -2.202501],
              [133.385483, -2.192149],
              [133.325668, -2.218295],
              [133.277267, -2.201835],
              [133.317551, -2.168719],
              [133.298935, -2.193211],
              [133.262772, -2.177779],
              [133.274445, -2.157777],
              [133.261108, -2.17694],
              [133.282623, -2.190207],
              [133.263107, -2.20194],
              [133.158218, -2.197325],
              [132.960007, -2.293055],
              [132.944443, -2.262499],
              [132.897217, -2.28111],
              [132.825424, -2.2425],
              [132.714722, -2.29778],
              [132.64917, -2.289999],
              [132.574524, -2.189304],
              [132.315552, -2.283611],
              [132.19722, -2.15194],
              [132.141388, -2.148611],
              [132.134171, -2.083329],
              [132.107498, -2.089444],
              [132.134171, -2.14028],
              [132.038605, -2.070001],
              [132.115204, -1.99272],
              [132.136383, -2.023611],
              [132.231949, -1.962309],
              [132.238815, -1.934907],
              [132.245895, -1.945861],
              [132.272705, -1.934654],
              [132.238266, -1.934189],
              [132.181229, -1.9905],
              [132.113312, -1.985411],
              [132.085007, -2.021667],
              [132.102493, -1.970555],
              [132.074722, -1.949722],
              [132.095276, -1.901666],
              [132.08194, -1.89306],
              [132.086563, -1.870383],
              [132.133606, -1.89722],
              [132.163971, -1.881699],
              [132.170273, -1.8993],
              [132.202835, -1.869528],
              [132.223038, -1.884167],
              [132.259964, -1.85276],
              [132.257721, -1.83868],
              [132.291748, -1.84095],
              [132.288437, -1.817299],
              [132.310471, -1.826728],
              [132.323944, -1.813297],
              [132.324417, -1.827086],
              [132.339996, -1.81417],
              [132.325989, -1.82558],
              [132.324722, -1.811939],
              [132.288116, -1.816461],
              [132.292892, -1.839029],
              [132.257645, -1.837499],
              [132.222351, -1.88199],
              [132.204422, -1.867981],
              [132.169983, -1.898204],
              [132.163239, -1.879998],
              [132.134171, -1.895834],
              [132.08667, -1.868329],
              [132.054184, -1.966268],
              [132.061111, -2.017501],
              [132.04306, -2.026943],
              [132.020554, -2.004444],
              [132.03334, -1.974165],
              [132.01001, -2.006187],
              [131.967209, -1.965001],
              [131.997498, -1.910831],
              [132.033707, -1.930064],
              [132.002701, -1.908547],
              [131.987778, -1.929722],
              [131.973328, -1.913889],
              [131.984726, -1.875556],
              [131.97084, -1.8475],
              [131.986389, -1.861667],
              [131.988617, -1.84611],
              [132.008865, -1.860058],
              [132.030762, -1.836219],
              [132.035492, -1.853579],
              [132.041595, -1.8419],
              [132.073334, -1.84528],
              [132.032043, -1.834575],
              [132.009308, -1.858568],
              [131.99028, -1.844439],
              [131.984161, -1.859999],
              [131.973618, -1.84361],
              [131.950836, -1.86278],
              [131.958893, -1.826667],
              [132.017746, -1.814355],
              [132.014908, -1.80432],
              [131.958054, -1.82444],
              [131.947922, -1.844259],
              [131.920944, -1.813186],
              [131.995148, -1.73766],
              [132.008072, -1.771559],
              [132.038574, -1.791144],
              [132.009491, -1.76774],
              [132.026947, -1.71501],
              [132.067825, -1.765203],
              [132.08667, -1.754163],
              [132.074203, -1.769335],
              [132.089127, -1.769547],
              [132.091644, -1.789774],
              [132.08812, -1.752583],
              [132.039963, -1.729309],
              [132.089722, -1.702777],
              [132.063065, -1.696742],
              [132.054718, -1.722499],
              [132.004608, -1.684923],
              [132.078308, -1.670291],
              [132.074951, -1.650911],
              [132.096176, -1.649316],
              [132.076401, -1.647827],
              [132.071838, -1.666731],
              [132.068665, -1.631956],
              [132.121613, -1.61576],
              [132.137741, -1.599489],
              [132.124725, -1.582779],
              [132.148895, -1.574444],
              [132.122223, -1.582501],
              [132.133224, -1.603972],
              [132.101486, -1.604793],
              [132.049942, -1.644265],
              [132.073654, -1.616485],
              [132.069809, -1.597887],
              [132.106369, -1.56858],
              [132.07605, -1.51959],
              [132.071335, -1.551363],
              [132.096527, -1.54285],
              [132.103378, -1.568281],
              [132.047653, -1.627985],
              [132.053116, -1.662997],
              [132.015976, -1.658186],
              [132.014526, -1.641959],
              [132.038483, -1.645047],
              [132.038208, -1.631901],
              [132.014725, -1.640616],
              [132.026917, -1.667155],
              [131.91156, -1.719559],
              [131.900589, -1.673671],
              [131.94194, -1.676668],
              [131.942215, -1.65972],
              [131.961304, -1.6558],
              [131.942215, -1.657778],
              [131.942215, -1.675277],
              [131.896179, -1.672173],
              [131.880676, -1.638016],
              [131.918213, -1.58029],
              [131.948059, -1.593611],
              [131.936859, -1.573067],
              [132.001724, -1.554855],
              [131.962372, -1.479219],
              [132.01062, -1.448485],
              [131.981949, -1.46639],
              [131.986115, -1.41694],
              [131.958328, -1.425833],
              [131.974655, -1.447619],
              [131.957504, -1.482499],
              [131.969452, -1.549171],
              [131.933334, -1.542499],
              [131.953888, -1.555557],
              [131.869995, -1.583611],
              [131.887161, -1.550018],
              [131.871765, -1.527441],
              [131.920837, -1.524722],
              [131.876389, -1.508055],
              [131.864166, -1.527222],
              [131.882294, -1.553396],
              [131.809998, -1.614445],
              [131.779449, -1.596668],
              [131.807785, -1.545834],
              [131.794724, -1.49111],
              [131.824173, -1.507221],
              [131.834167, -1.498888],
              [131.818893, -1.450279],
              [131.796921, -1.447015],
              [131.82309, -1.44144],
              [131.821487, -1.429119],
              [131.796234, -1.440886],
              [131.81778, -1.45083],
              [131.821396, -1.474166],
              [131.790558, -1.491666],
              [131.79834, -1.548612],
              [131.726898, -1.583829],
              [131.694778, -1.555593],
              [131.741592, -1.50602],
              [131.744675, -1.453821],
              [131.712875, -1.414859],
              [131.686661, -1.43801],
              [131.653366, -1.40664],
              [131.679443, -1.410834],
              [131.733887, -1.366944],
              [131.72139, -1.352499],
              [131.734726, -1.311388],
              [131.717773, -1.289999],
              [131.734161, -1.315001],
              [131.720001, -1.352221],
              [131.733337, -1.36444],
              [131.65152, -1.402579],
              [131.669174, -1.465],
              [131.611389, -1.411666],
              [131.63916, -1.372223],
              [131.633331, -1.360278],
              [131.609726, -1.410556],
              [131.641296, -1.448009],
              [131.577408, -1.454696],
              [131.561386, -1.433055],
              [131.575882, -1.470919],
              [131.524445, -1.479721],
              [131.539444, -1.425566],
              [131.526382, -1.396389],
              [131.556671, -1.381668],
              [131.537506, -1.353055],
              [131.588608, -1.342501],
              [131.588882, -1.275],
              [131.569443, -1.241109],
              [131.585007, -1.345559],
              [131.536179, -1.348839],
              [131.550278, -1.385278],
              [131.514236, -1.376528],
              [131.515411, -1.47501],
              [131.475006, -1.456667],
              [131.500702, -1.468124],
              [131.464996, -1.488329],
              [131.44722, -1.44111],
              [131.450562, -1.472781],
              [131.460556, -1.465278],
              [131.460831, -1.486667],
              [131.478943, -1.487039],
              [131.449127, -1.5144],
              [131.379562, -1.451961],
              [131.426468, -1.425751],
              [131.430557, -1.403055],
              [131.452225, -1.399999],
              [131.432495, -1.377499],
              [131.422012, -1.425539],
              [131.389603, -1.41061],
              [131.412018, -1.358509],
              [131.435272, -1.347779],
              [131.420273, -1.34194],
              [131.380554, -1.401945],
              [131.361511, -1.36567],
              [131.336395, -1.366391],
              [131.354721, -1.321389],
              [131.33667, -1.324439],
              [131.348892, -1.28611],
              [131.324722, -1.351109],
              [131.296951, -1.35528],
              [131.301666, -1.327499],
              [131.279449, -1.31472],
              [131.301117, -1.32889],
              [131.29361, -1.35389],
              [131.313614, -1.373333],
              [131.258667, -1.371336],
              [131.272217, -1.36833],
              [131.29277, -1.4125],
              [131.337219, -1.438056],
              [131.283615, -1.504167],
              [131.208664, -1.523113],
              [131.166672, -1.462778],
              [130.996048, -1.459965],
              [130.931381, -1.426291],
              [130.999207, -1.38162],
              [131.051117, -1.254166],
              [131.176544, -1.220246],
              [131.248886, -1.082777],
              [131.240097, -1.028044],
              [131.283783, -0.990725],
              [131.265518, -0.992109],
              [131.278793, -0.974999],
              [131.267975, -0.921084],
              [131.300446, -0.917804],
              [131.241806, -0.876727],
              [131.225891, -0.821073],
              [131.508682, -0.729509],
              [131.54393, -0.740925],
              [131.507767, -0.774713],
              [131.847595, -0.705874],
              [131.977356, -0.577887],
              [132.070786, -0.539999],
              [132.094193, -0.479821],
              [132.170563, -0.425557],
              [132.419174, -0.34333],
              [132.719208, -0.362848],
              [132.798798, -0.416224],
              [132.766495, -0.493181],
              [132.798859, -0.416281],
              [132.904938, -0.463862],
              [132.953613, -0.452833],
              [132.972412, -0.49383],
              [133.151016, -0.54533],
              [133.3965, -0.740975],
              [133.547165, -0.746956],
              [133.572876, -0.720641],
              [133.721848, -0.751336],
              [133.756668, -0.719219],
              [133.81662, -0.749301],
              [133.872284, -0.714018],
              [133.972809, -0.719501],
              [134.014206, -0.781619],
              [134.136871, -0.863292],
              [134.052551, -0.868969],
              [134.046051, -0.926905],
              [134.010406, -0.959727],
              [134.070816, -1.030581],
              [134.102615, -1.128109],
              [134.190002, -1.20111],
              [134.278992, -1.343317],
              [134.213638, -1.407771],
              [134.200836, -1.55],
              [134.067322, -1.673561],
              [134.095322, -1.684829],
              [134.102814, -1.860669],
              [134.121948, -1.86278],
              [134.13591, -1.960028],
              [134.156525, -1.966227],
              [134.102783, -2.051111],
              [134.172775, -2.347221],
              [134.213882, -2.418611],
              [134.259171, -2.429439],
              [134.279099, -2.481319],
              [134.320007, -2.507321],
              [134.286942, -2.518334],
              [134.339722, -2.551667],
              [134.318893, -2.584999],
              [134.375549, -2.644443],
              [134.367218, -2.668889],
              [134.461395, -2.863056],
              [134.514725, -2.831111],
              [134.524231, -2.79222],
              [134.460281, -2.550001],
              [134.513885, -2.483609],
              [134.569168, -2.484439],
              [134.512833, -2.473574],
              [134.551117, -2.471945],
              [134.531952, -2.449719],
              [134.601669, -2.488334],
              [134.630829, -2.474167],
              [134.661575, -2.611106],
              [134.661392, -2.823219],
            ],
          ],
          [
            [
              [134.348053, -2.165],
              [134.315552, -2.078889],
              [134.388184, -1.99321],
              [134.411667, -2.073333],
              [134.348053, -2.165],
            ],
          ],
          [
            [
              [134.737503, -2.016111],
              [134.738892, -2.053055],
              [134.723892, -2.025829],
              [134.737503, -2.016111],
            ],
          ],
          [
            [
              [134.575348, -2.337501],
              [134.590775, -2.395468],
              [134.562027, -2.403001],
              [134.564194, -2.44134],
              [134.502853, -2.360739],
              [134.562027, -2.36854],
              [134.563309, -2.280778],
              [134.575348, -2.337501],
            ],
          ],
          [
            [
              [134.521225, -2.34373],
              [134.530029, -2.351376],
              [134.501572, -2.342704],
              [134.521225, -2.34373],
            ],
          ],
          [
            [
              [134.377228, -2.521666],
              [134.39389, -2.53639],
              [134.387772, -2.57611],
              [134.36972, -2.549444],
              [134.377228, -2.521666],
            ],
          ],
          [
            [
              [132.471497, -2.624542],
              [132.50528, -2.633611],
              [132.508774, -2.653585],
              [132.460342, -2.668185],
              [132.441116, -2.641111],
              [132.471497, -2.624542],
            ],
          ],
          [
            [
              [132.556946, -2.641109],
              [132.574997, -2.651666],
              [132.536392, -2.646939],
              [132.556946, -2.641109],
            ],
          ],
          [
            [
              [132.286942, -2.985559],
              [132.169586, -2.968609],
              [132.249451, -2.967777],
              [132.321152, -2.992014],
              [132.286942, -2.985559],
            ],
          ],
          [
            [
              [132.132507, -2.965555],
              [132.143616, -2.970556],
              [132.110001, -2.970834],
              [132.132507, -2.965555],
            ],
          ],
          [
            [
              [132.442215, -3.098333],
              [132.547226, -3.135],
              [132.545273, -3.150277],
              [132.472504, -3.13028],
              [132.442215, -3.098333],
            ],
          ],
          [
            [
              [132.745026, -3.42548],
              [132.743271, -3.392599],
              [132.75528, -3.414509],
              [132.745026, -3.42548],
            ],
          ],
          [
            [
              [132.708725, -3.46011],
              [132.724411, -3.495833],
              [132.699402, -3.511349],
              [132.681183, -3.450738],
              [132.629837, -3.405946],
              [132.663986, -3.403756],
              [132.708725, -3.46011],
            ],
          ],
          [
            [
              [132.752228, -3.443889],
              [132.747772, -3.475833],
              [132.740555, -3.441667],
              [132.752228, -3.443889],
            ],
          ],
          [
            [
              [133.776947, -3.05389],
              [133.792496, -3.109722],
              [133.75972, -3.076112],
              [133.776947, -3.05389],
            ],
          ],
          [
            [
              [133.613937, -3.420899],
              [133.628311, -3.428546],
              [133.616882, -3.452399],
              [133.596985, -3.431069],
              [133.613937, -3.420899],
            ],
          ],
          [
            [
              [133.912811, -3.85633],
              [133.883392, -3.796141],
              [133.872772, -3.715555],
              [133.925018, -3.874051],
              [133.912811, -3.85633],
            ],
          ],
          [
            [
              [134.035431, -3.848358],
              [134.023331, -3.868332],
              [134.005981, -3.857598],
              [134.035431, -3.848358],
            ],
          ],
          [
            [
              [134.051834, -3.924399],
              [134.098984, -3.915533],
              [134.1772, -4.00864],
              [134.211349, -4.02673],
              [134.083618, -3.983841],
              [134.051834, -3.924399],
            ],
          ],
          [
            [
              [134.683655, -3.936996],
              [134.738419, -3.953898],
              [134.69278, -3.96389],
              [134.683655, -3.936996],
            ],
          ],
          [
            [
              [134.842865, -3.952499],
              [134.865402, -3.970419],
              [134.86055, -3.984723],
              [134.83139, -3.963612],
              [134.842865, -3.952499],
            ],
          ],
          [
            [
              [134.413757, -4.029144],
              [134.362503, -4.032501],
              [134.376709, -3.977389],
              [134.452011, -4.0193],
              [134.413757, -4.029144],
            ],
          ],
          [
            [
              [134.229965, -4.015519],
              [134.228058, -4.002801],
              [134.246048, -4.005008],
              [134.262711, -4.046109],
              [134.229965, -4.015519],
            ],
          ],
          [
            [
              [134.354019, -4.023539],
              [134.36055, -4.033611],
              [134.339447, -4.027222],
              [134.354019, -4.023539],
            ],
          ],
          [
            [
              [133.507156, -4.199229],
              [133.555069, -4.21874],
              [133.63562, -4.295962],
              [133.63472, -4.314309],
              [133.548859, -4.234501],
              [133.460098, -4.251956],
              [133.417084, -4.205079],
              [133.331375, -4.182169],
              [133.347946, -4.163886],
              [133.318481, -4.098261],
              [133.507156, -4.199229],
            ],
          ],
          [
            [
              [131.26123, -0.938987],
              [131.246231, -0.947331],
              [131.25647, -0.924368],
              [131.26123, -0.938987],
            ],
          ],
          [
            [
              [134.098724, -0.888909],
              [134.110764, -0.92172],
              [134.089935, -0.896301],
              [134.098724, -0.888909],
            ],
          ],
          [
            [
              [131.055069, 0.378053],
              [131.066177, 0.36676],
              [131.049698, 0.361611],
              [131.032379, 0.387192],
              [131.055069, 0.378053],
            ],
          ],
          [
            [
              [129.860672, 0.324739],
              [129.907227, 0.318011],
              [129.925873, 0.281691],
              [129.882324, 0.277128],
              [129.860672, 0.324739],
            ],
          ],
          [
            [
              [130.037506, 0.186941],
              [130.073059, 0.158611],
              [129.997498, 0.180001],
              [130.037506, 0.186941],
            ],
          ],
          [
            [
              [130.076111, 0.149722],
              [130.080765, 0.12944],
              [130.063034, 0.138165],
              [130.076111, 0.149722],
            ],
          ],
          [
            [
              [130.225571, 0.105692],
              [130.230438, 0.093781],
              [130.212143, 0.110941],
              [130.225571, 0.105692],
            ],
          ],
          [
            [
              [130.249466, 0.109571],
              [130.276596, 0.099476],
              [130.249146, 0.098547],
              [130.249466, 0.109571],
            ],
          ],
          [
            [
              [130.872772, 0.0425],
              [130.894058, 0.04013],
              [130.904861, 0.018996],
              [130.880386, 0.01578],
              [130.872772, 0.0425],
            ],
          ],
          [
            [
              [130.104645, -0.06848],
              [130.088333, 0.002499],
              [130.141388, 0.015],
              [130.110275, 0.00389],
              [130.142288, -0.017031],
              [130.116226, -0.035371],
              [130.155273, -0.03592],
              [130.16571, -0.066144],
              [130.131912, -0.097147],
              [130.104645, -0.06848],
            ],
          ],
          [
            [
              [130.429993, -0.201666],
              [130.451111, -0.197221],
              [130.42778, -0.17611],
              [130.376663, -0.182222],
              [130.424438, -0.166111],
              [130.425278, -0.12944],
              [130.38916, -0.171944],
              [130.371948, -0.137777],
              [130.366394, -0.160279],
              [130.335556, -0.141667],
              [130.373062, -0.1825],
              [130.353561, -0.192139],
              [130.301117, -0.172778],
              [130.281281, -0.111369],
              [130.29744, -0.092657],
              [130.345276, -0.109721],
              [130.352783, -0.078889],
              [130.362503, -0.134999],
              [130.368683, -0.07578],
              [130.404984, -0.076803],
              [130.414169, -0.113889],
              [130.437775, -0.073888],
              [130.446945, -0.100281],
              [130.525864, -0.068019],
              [130.512131, -0.049782],
              [130.578049, -0.075],
              [130.569473, -0.039024],
              [130.633896, -0.062499],
              [130.726669, -0.027221],
              [130.708328, -0.061939],
              [130.769775, -0.05362],
              [130.739716, -0.025279],
              [130.797775, -0.004999],
              [130.93837, -0.04075],
              [130.956085, -0.03378],
              [130.967407, -0.061795],
              [130.977158, -0.03512],
              [131.048615, -0.020278],
              [131.033615, -0.060277],
              [131.133499, -0.070622],
              [131.194, -0.130536],
              [131.299164, -0.159734],
              [131.318298, -0.198056],
              [131.295715, -0.238772],
              [131.340775, -0.290732],
              [131.276535, -0.34576],
              [131.245956, -0.34062],
              [131.241455, -0.381259],
              [131.103653, -0.307919],
              [131.023697, -0.357139],
              [131.007202, -0.33551],
              [130.959106, -0.351223],
              [130.919434, -0.30087],
              [130.89505, -0.299295],
              [130.868683, -0.235299],
              [130.799652, -0.241049],
              [130.789993, -0.168889],
              [130.679993, -0.098451],
              [130.698608, -0.07833],
              [130.621017, -0.080327],
              [130.620605, -0.104208],
              [130.666092, -0.116912],
              [130.622772, -0.120556],
              [130.62056, -0.145353],
              [130.675797, -0.173181],
              [130.731461, -0.294659],
              [130.815231, -0.311892],
              [130.826172, -0.2881],
              [130.85527, -0.310556],
              [130.919556, -0.305492],
              [130.944687, -0.354012],
              [130.879807, -0.420643],
              [130.727036, -0.439642],
              [130.672501, -0.339166],
              [130.705002, -0.324721],
              [130.679718, -0.29222],
              [130.578339, -0.321111],
              [130.560013, -0.367291],
              [130.59137, -0.378951],
              [130.552979, -0.43076],
              [130.527466, -0.246599],
              [130.436951, -0.290281],
              [130.429306, -0.2614],
              [130.317703, -0.273057],
              [130.291382, -0.22889],
              [130.21817, -0.208118],
              [130.331116, -0.218609],
              [130.358063, -0.200556],
              [130.395004, -0.23],
              [130.429993, -0.201666],
            ],
          ],
          [
            [
              [130.94278, -0.01583],
              [130.956345, -0.022414],
              [130.947495, -0.033333],
              [130.94278, -0.01583],
            ],
          ],
          [
            [
              [131.081421, -0.038067],
              [131.08017, -0.049059],
              [131.064194, -0.040531],
              [131.081421, -0.038067],
            ],
          ],
          [
            [
              [130.064453, -0.064405],
              [130.064148, -0.076769],
              [130.013748, -0.07078],
              [130.064453, -0.064405],
            ],
          ],
          [
            [
              [130.269058, -0.106489],
              [130.261581, -0.122509],
              [130.250992, -0.109274],
              [130.269058, -0.106489],
            ],
          ],
          [
            [
              [130.256943, -0.148329],
              [130.297226, -0.191945],
              [130.256607, -0.188025],
              [130.256943, -0.148329],
            ],
          ],
          [
            [
              [130.239166, -0.165662],
              [130.250275, -0.180278],
              [130.204163, -0.181388],
              [130.239166, -0.165662],
            ],
          ],
          [
            [
              [130.223724, -0.277919],
              [130.242355, -0.302928],
              [130.230957, -0.32022],
              [130.200058, -0.305715],
              [130.223724, -0.277919],
            ],
          ],
          [
            [
              [130.870697, -0.293889],
              [130.900497, -0.308881],
              [130.852783, -0.3075],
              [130.870697, -0.293889],
            ],
          ],
          [
            [
              [130.499634, -0.302474],
              [130.520157, -0.303769],
              [130.525558, -0.321667],
              [130.498611, -0.332778],
              [130.499634, -0.302474],
            ],
          ],
          [
            [
              [130.668701, -0.307126],
              [130.680466, -0.320065],
              [130.669388, -0.332299],
              [130.65799, -0.322116],
              [130.668701, -0.307126],
            ],
          ],
          [
            [
              [130.14856, -0.309423],
              [130.149689, -0.330528],
              [130.134171, -0.314743],
              [130.14856, -0.309423],
            ],
          ],
          [
            [
              [130.184723, -0.317186],
              [130.225327, -0.326553],
              [130.229416, -0.345949],
              [130.184723, -0.317186],
            ],
          ],
          [
            [
              [130.524445, -0.46778],
              [130.614716, -0.395278],
              [130.69722, -0.44778],
              [130.660553, -0.510001],
              [130.592773, -0.534445],
              [130.571198, -0.517119],
              [130.614716, -0.486667],
              [130.577225, -0.463055],
              [130.544998, -0.511945],
              [130.456711, -0.509812],
              [130.513062, -0.487499],
              [130.468613, -0.483611],
              [130.477219, -0.43889],
              [130.524445, -0.46778],
            ],
          ],
          [
            [
              [129.854721, -0.42],
              [129.890366, -0.397428],
              [129.924683, -0.412727],
              [129.874451, -0.498334],
              [129.854721, -0.42],
            ],
          ],
          [
            [
              [130.454437, -0.430277],
              [130.454727, -0.446939],
              [130.4375, -0.445],
              [130.454437, -0.430277],
            ],
          ],
          [
            [
              [130.26973, -0.561667],
              [130.27861, -0.585832],
              [130.250549, -0.545555],
              [130.26973, -0.561667],
            ],
          ],
          [
            [
              [130.650284, -0.568055],
              [130.660553, -0.57278],
              [130.556107, -0.60778],
              [130.650284, -0.568055],
            ],
          ],
          [
            [
              [130.279999, -0.593889],
              [130.290558, -0.594723],
              [130.281387, -0.607438],
              [130.279999, -0.593889],
            ],
          ],
          [
            [
              [130.22084, -0.740556],
              [130.21611, -0.727777],
              [130.236664, -0.72194],
              [130.22084, -0.740556],
            ],
          ],
          [
            [
              [130.889587, -0.772389],
              [130.927017, -0.784391],
              [130.863983, -0.805019],
              [130.900223, -0.832679],
              [130.850052, -0.860466],
              [130.62883, -0.90996],
              [130.508804, -0.920535],
              [130.523148, -0.897598],
              [130.471329, -0.89566],
              [130.47171, -0.917752],
              [130.454559, -0.898081],
              [130.387772, -0.92278],
              [130.4505, -0.893901],
              [130.433334, -0.861776],
              [130.484329, -0.789238],
              [130.50618, -0.797555],
              [130.486481, -0.829595],
              [130.544174, -0.839999],
              [130.566559, -0.793749],
              [130.585312, -0.833034],
              [130.635941, -0.790829],
              [130.663498, -0.82606],
              [130.688599, -0.82039],
              [130.671143, -0.797819],
              [130.717178, -0.829693],
              [130.797607, -0.793161],
              [130.786148, -0.813076],
              [130.809723, -0.802286],
              [130.815277, -0.825834],
              [130.804077, -0.751899],
              [130.861191, -0.800967],
              [130.850967, -0.766],
              [130.889587, -0.772389],
            ],
          ],
          [
            [
              [130.783142, -0.756945],
              [130.792221, -0.781667],
              [130.773056, -0.801391],
              [130.7603, -0.77286],
              [130.783142, -0.756945],
            ],
          ],
          [
            [
              [130.748337, -0.7803],
              [130.732666, -0.799159],
              [130.717148, -0.77464],
              [130.749695, -0.766659],
              [130.748337, -0.7803],
            ],
          ],
          [
            [
              [130.526215, -0.798327],
              [130.552475, -0.795921],
              [130.538895, -0.827778],
              [130.511948, -0.8175],
              [130.526215, -0.798327],
            ],
          ],
          [
            [
              [130.640656, -0.970106],
              [130.90155, -0.888422],
              [130.927383, -0.893019],
              [130.936493, -0.939985],
              [131.03035, -0.911651],
              [131.051208, -0.931365],
              [131.087753, -1.012213],
              [131.04805, -1.185559],
              [131.033691, -1.19709],
              [131.044449, -1.24167],
              [131.000839, -1.281944],
              [130.973907, -1.35391],
              [130.907471, -1.322],
              [130.858017, -1.345639],
              [130.810043, -1.26672],
              [130.755585, -1.248669],
              [130.737045, -1.165127],
              [130.680222, -1.108429],
              [130.717178, -1.078529],
              [130.640656, -0.970106],
            ],
          ],
          [
            [
              [131.104111, -0.943588],
              [131.096207, -0.95061],
              [131.114868, -0.935128],
              [131.104111, -0.943588],
            ],
          ],
          [
            [
              [130.647385, -0.937229],
              [130.661636, -0.94984],
              [130.636673, -0.944445],
              [130.647385, -0.937229],
            ],
          ],
          [
            [
              [131.079468, -1.07547],
              [131.096985, -1.00298],
              [131.145508, -0.997522],
              [131.103058, -1.066944],
              [131.114166, -1.078333],
              [131.079468, -1.07547],
            ],
          ],
          [
            [
              [131.162384, -1.037279],
              [131.170502, -1.061511],
              [131.157288, -1.078201],
              [131.162384, -1.037279],
            ],
          ],
          [
            [
              [131.126389, -1.050277],
              [131.137222, -1.06139],
              [131.121948, -1.076669],
              [131.110001, -1.055833],
              [131.126389, -1.050277],
            ],
          ],
          [
            [
              [131.172394, -1.071803],
              [131.161728, -1.082853],
              [131.174484, -1.060615],
              [131.172394, -1.071803],
            ],
          ],
          [
            [
              [129.765549, -1.170556],
              [129.866943, -1.143888],
              [129.978333, -1.171944],
              [129.832779, -1.25111],
              [129.887573, -1.197153],
              [129.742218, -1.219721],
              [129.732498, -1.193334],
              [129.765549, -1.170556],
            ],
          ],
          [
            [
              [129.771118, -1.14694],
              [129.782227, -1.153054],
              [129.763062, -1.159999],
              [129.771118, -1.14694],
            ],
          ],
          [
            [
              [129.746948, -1.156389],
              [129.715836, -1.199166],
              [129.67305, -1.198056],
              [129.703568, -1.203722],
              [129.672913, -1.17882],
              [129.746948, -1.156389],
            ],
          ],
          [
            [
              [129.334717, -1.154445],
              [129.353058, -1.161667],
              [129.300552, -1.178057],
              [129.334717, -1.154445],
            ],
          ],
          [
            [
              [129.357483, -1.161041],
              [129.373672, -1.169423],
              [129.372223, -1.187777],
              [129.345276, -1.182499],
              [129.357483, -1.161041],
            ],
          ],
          [
            [
              [129.390549, -1.162219],
              [129.396942, -1.19639],
              [129.383606, -1.1975],
              [129.37645, -1.175764],
              [129.390549, -1.162219],
            ],
          ],
          [
            [
              [129.463608, -1.167778],
              [129.475555, -1.186389],
              [129.446945, -1.194168],
              [129.44278, -1.171939],
              [129.463608, -1.167778],
            ],
          ],
          [
            [
              [129.660828, -1.25944],
              [129.663605, -1.275834],
              [129.651382, -1.27167],
              [129.660828, -1.25944],
            ],
          ],
          [
            [
              [129.755554, -1.265277],
              [129.769165, -1.27167],
              [129.751663, -1.276666],
              [129.755554, -1.265277],
            ],
          ],
          [
            [
              [129.719727, -1.269999],
              [129.714722, -1.279444],
              [129.730835, -1.278888],
              [129.719727, -1.269999],
            ],
          ],
          [
            [
              [128.925278, -1.377777],
              [128.916672, -1.398609],
              [128.911667, -1.38389],
              [128.925278, -1.377777],
            ],
          ],
          [
            [
              [130.261948, -1.458889],
              [130.258606, -1.476111],
              [130.20723, -1.483889],
              [130.261948, -1.458889],
            ],
          ],
          [
            [
              [129.910553, -1.62722],
              [129.923615, -1.638611],
              [129.914444, -1.65139],
              [129.910553, -1.62722],
            ],
          ],
          [
            [
              [129.862778, -1.66472],
              [129.871109, -1.670833],
              [129.858612, -1.674445],
              [129.862778, -1.66472],
            ],
          ],
          [
            [
              [130.186661, -2.06472],
              [130.09166, -2.043611],
              [130.117493, -2.038888],
              [130.085007, -2.02806],
              [130.101669, -2.018055],
              [130.016113, -2.022779],
              [129.862778, -1.976666],
              [129.719162, -1.879169],
              [130.058838, -1.724479],
              [130.258179, -1.729099],
              [130.252975, -1.704291],
              [130.3703, -1.676137],
              [130.352402, -1.736864],
              [130.455826, -1.834167],
              [130.429718, -1.872222],
              [130.410004, -1.859719],
              [130.408188, -1.89784],
              [130.340088, -1.922295],
              [130.432495, -1.952778],
              [130.427536, -1.972821],
              [130.444717, -1.954166],
              [130.439438, -1.9825],
              [130.407227, -1.970829],
              [130.382782, -1.981944],
              [130.478882, -2.00778],
              [130.371674, -2.042223],
              [130.405273, -2.000278],
              [130.326309, -1.985992],
              [130.343887, -1.95611],
              [130.304443, -2.01083],
              [130.26416, -2.01111],
              [130.285202, -2.031591],
              [130.265839, -2.05389],
              [130.186661, -2.06472],
            ],
          ],
          [
            [
              [129.70195, -1.773055],
              [129.700562, -1.78778],
              [129.691605, -1.755847],
              [129.70195, -1.773055],
            ],
          ],
          [
            [
              [129.625, -1.772779],
              [129.628891, -1.794166],
              [129.613327, -1.779167],
              [129.625, -1.772779],
            ],
          ],
          [
            [
              [129.655853, -1.80393],
              [129.656952, -1.839179],
              [129.641388, -1.822519],
              [129.655853, -1.80393],
            ],
          ],
          [
            [
              [130.451385, -1.954166],
              [130.466949, -1.97917],
              [130.45694, -1.98722],
              [130.451385, -1.954166],
            ],
          ],
          [
            [
              [130.483612, -1.97028],
              [130.492493, -1.981671],
              [130.471939, -1.98611],
              [130.483612, -1.97028],
            ],
          ],
          [
            [
              [130.549438, -1.985559],
              [130.599716, -2.004305],
              [130.544724, -1.995833],
              [130.549438, -1.985559],
            ],
          ],
          [
            [
              [130.614716, -1.999721],
              [130.638611, -2.006388],
              [130.600616, -2.004653],
              [130.614716, -1.999721],
            ],
          ],
          [
            [
              [130.661667, -2.00944],
              [130.673615, -2.012779],
              [130.663055, -2.022219],
              [130.661667, -2.00944],
            ],
          ],
          [
            [
              [130.439163, -2.053609],
              [130.440277, -2.066388],
              [130.424728, -2.06361],
              [130.439163, -2.053609],
            ],
          ],
          [
            [
              [130.449722, -2.066391],
              [130.476105, -2.06583],
              [130.409729, -2.089444],
              [130.400284, -2.080909],
              [130.449722, -2.066391],
            ],
          ],
          [
            [
              [130.196106, -2.14083],
              [130.211945, -2.144171],
              [130.169998, -2.14361],
              [130.196106, -2.14083],
            ],
          ],
          [
            [
              [130.310562, -2.193056],
              [130.271118, -2.195556],
              [130.279449, -2.212499],
              [130.2117, -2.193263],
              [130.310562, -2.193056],
            ],
          ],
          [
            [
              [130.41333, -2.205279],
              [130.49028, -2.222778],
              [130.410004, -2.215278],
              [130.41333, -2.205279],
            ],
          ],
          [
            [
              [130.544174, -2.218056],
              [130.553894, -2.221112],
              [130.500443, -2.225796],
              [130.544174, -2.218056],
            ],
          ],
          [
            [
              [130.602219, -2.244439],
              [130.623642, -2.253854],
              [130.571106, -2.2525],
              [130.602219, -2.244439],
            ],
          ],
          [
            [
              [131.957993, -1.837777],
              [131.948608, -1.86306],
              [131.983337, -1.874444],
              [131.97171, -1.923842],
              [131.923889, -1.870834],
              [131.957993, -1.837777],
            ],
          ],
          [
            [
              [132.086395, -1.95444],
              [132.10083, -1.970833],
              [132.063049, -2.024999],
              [132.058136, -1.96633],
              [132.086395, -1.95444],
            ],
          ],
          [
            [
              [131.057785, -1.193612],
              [131.046387, -1.213331],
              [131.037781, -1.197222],
              [131.057785, -1.193612],
            ],
          ],
          [
            [
              [131.181107, -1.20028],
              [131.168884, -1.22139],
              [131.14444, -1.22139],
              [131.185837, -1.189719],
              [131.181107, -1.20028],
            ],
          ],
          [
            [
              [131.022217, -1.298055],
              [131.01358, -1.308412],
              [131.011108, -1.289723],
              [131.022217, -1.298055],
            ],
          ],
          [
            [
              [131.336533, -1.352317],
              [131.362946, -1.397369],
              [131.31813, -1.423989],
              [131.272385, -1.38123],
              [131.305161, -1.380453],
              [131.318268, -1.370726],
              [131.299835, -1.355891],
              [131.336533, -1.352317],
            ],
          ],
          [
            [
              [131.713577, -1.428579],
              [131.740555, -1.457071],
              [131.718613, -1.520834],
              [131.638779, -1.544687],
              [131.58696, -1.490177],
              [131.594162, -1.46389],
              [131.623611, -1.484167],
              [131.605881, -1.463616],
              [131.655273, -1.44333],
              [131.669449, -1.46722],
              [131.713577, -1.428579],
            ],
          ],
          [
            [
              [133.872208, -2.126975],
              [133.836166, -2.130742],
              [133.837692, -2.106504],
              [133.863007, -2.102526],
              [133.872208, -2.126975],
            ],
          ],
          [
            [
              [133.896286, -2.104794],
              [133.914978, -2.118496],
              [133.874084, -2.134626],
              [133.873978, -2.110467],
              [133.896286, -2.104794],
            ],
          ],
          [
            [
              [133.931396, -2.13389],
              [133.929718, -2.16139],
              [133.871109, -2.161939],
              [133.881393, -2.14361],
              [133.931396, -2.13389],
            ],
          ],
          [
            [
              [133.837708, -2.146894],
              [133.859116, -2.152401],
              [133.835831, -2.159443],
              [133.840256, -2.189849],
              [133.775406, -2.194772],
              [133.837708, -2.146894],
            ],
          ],
          [
            [
              [133.853683, -2.157839],
              [133.862961, -2.171997],
              [133.850632, -2.195109],
              [133.836441, -2.162299],
              [133.853683, -2.157839],
            ],
          ],
          [
            [
              [133.921387, -2.168056],
              [133.934174, -2.187777],
              [133.895279, -2.183055],
              [133.921387, -2.168056],
            ],
          ],
          [
            [
              [133.877823, -2.17168],
              [133.889481, -2.191091],
              [133.852081, -2.198414],
              [133.877823, -2.17168],
            ],
          ],
          [
            [
              [133.723892, -2.175554],
              [133.766113, -2.177501],
              [133.699448, -2.234167],
              [133.674438, -2.231945],
              [133.73056, -2.202779],
              [133.723892, -2.175554],
            ],
          ],
          [
            [
              [133.828888, -2.241109],
              [133.806671, -2.237499],
              [133.79277, -2.2775],
              [133.763062, -2.239721],
              [133.842239, -2.20143],
              [133.864716, -2.230279],
              [133.854294, -2.205279],
              [133.904449, -2.193329],
              [133.882507, -2.240833],
              [133.888885, -2.265833],
              [133.849716, -2.283889],
              [133.848053, -2.24028],
              [133.871674, -2.2475],
              [133.85083, -2.235828],
              [133.843887, -2.285279],
              [133.815323, -2.290874],
              [133.804993, -2.252222],
              [133.829437, -2.263333],
              [133.806671, -2.24028],
              [133.828888, -2.241109],
            ],
          ],
          [
            [
              [133.921112, -2.186946],
              [133.934448, -2.2475],
              [133.91777, -2.272219],
              [133.884171, -2.243609],
              [133.912506, -2.240833],
              [133.921112, -2.186946],
            ],
          ],
          [
            [
              [133.751938, -2.214439],
              [133.747498, -2.25028],
              [133.674728, -2.26417],
              [133.751938, -2.214439],
            ],
          ],
          [
            [
              [133.620895, -2.233558],
              [133.596176, -2.225513],
              [133.60466, -2.21703],
              [133.620895, -2.233558],
            ],
          ],
          [
            [
              [133.986664, -2.267221],
              [133.989716, -2.299444],
              [133.945282, -2.32389],
              [133.82695, -2.330278],
              [133.926117, -2.305278],
              [133.964996, -2.245699],
              [133.954727, -2.233055],
              [133.987503, -2.228889],
              [133.986664, -2.267221],
            ],
          ],
          [
            [
              [133.727783, -2.24861],
              [133.746674, -2.258611],
              [133.720276, -2.269443],
              [133.712784, -2.257777],
              [133.727783, -2.24861],
            ],
          ],
          [
            [
              [133.907791, -2.267632],
              [133.924438, -2.304036],
              [133.866943, -2.290279],
              [133.907791, -2.267632],
            ],
          ],
          [
            [
              [133.94194, -2.32722],
              [133.986115, -2.386669],
              [133.895538, -2.38916],
              [133.851395, -2.36],
              [133.94194, -2.32722],
            ],
          ],
          [
            [
              [133.814728, -2.335001],
              [133.847198, -2.34589],
              [133.804718, -2.353612],
              [133.814728, -2.335001],
            ],
          ],
          [
            [
              [133.946106, -2.466666],
              [133.901108, -2.477777],
              [133.838882, -2.394723],
              [133.940002, -2.394999],
              [133.946945, -2.431666],
              [133.985001, -2.449445],
              [133.974442, -2.476111],
              [133.946106, -2.466666],
            ],
          ],
          [
            [
              [133.726669, -2.434444],
              [133.833893, -2.408888],
              [133.869446, -2.455829],
              [133.853882, -2.471945],
              [133.822495, -2.44361],
              [133.768616, -2.481946],
              [133.726669, -2.434444],
            ],
          ],
          [
            [
              [133.295517, -2.411639],
              [133.358612, -2.444445],
              [133.368332, -2.496388],
              [133.295517, -2.411639],
            ],
          ],
          [
            [
              [133.617493, -2.497779],
              [133.56395, -2.514045],
              [133.48555, -2.41722],
              [133.543381, -2.437881],
              [133.545273, -2.473055],
              [133.559357, -2.444075],
              [133.597504, -2.45639],
              [133.617493, -2.497779],
            ],
          ],
          [
            [
              [133.431396, -2.4875],
              [133.442505, -2.49583],
              [133.425003, -2.500555],
              [133.419449, -2.486112],
              [133.431396, -2.4875],
            ],
          ],
          [
            [
              [133.662216, -2.492222],
              [133.684677, -2.51224],
              [133.663269, -2.54998],
              [133.646942, -2.514722],
              [133.606659, -2.515301],
              [133.662216, -2.492222],
            ],
          ],
          [
            [
              [133.696945, -2.49833],
              [133.734161, -2.504167],
              [133.750549, -2.556667],
              [133.70639, -2.54861],
              [133.696945, -2.49833],
            ],
          ],
          [
            [
              [133.469162, -2.563333],
              [133.473831, -2.502535],
              [133.514816, -2.587125],
              [133.481674, -2.607501],
              [133.513885, -2.621944],
              [133.497498, -2.64306],
              [133.463608, -2.62139],
              [133.469162, -2.563333],
            ],
          ],
          [
            [
              [133.765839, -2.512219],
              [133.800278, -2.538612],
              [133.799164, -2.633054],
              [133.761108, -2.550279],
              [133.765839, -2.512219],
            ],
          ],
          [
            [
              [133.556335, -2.52021],
              [133.568878, -2.590512],
              [133.531143, -2.608399],
              [133.499847, -2.54526],
              [133.556335, -2.52021],
            ],
          ],
          [
            [
              [133.788895, -2.627781],
              [133.796112, -2.648056],
              [133.75, -2.671109],
              [133.753891, -2.62167],
              [133.693054, -2.610559],
              [133.71167, -2.58806],
              [133.693604, -2.538329],
              [133.73027, -2.57722],
              [133.752502, -2.55694],
              [133.788895, -2.627781],
            ],
          ],
          [
            [
              [133.399719, -2.549166],
              [133.43306, -2.599444],
              [133.41806, -2.641109],
              [133.401108, -2.62028],
              [133.411942, -2.612223],
              [133.399719, -2.549166],
            ],
          ],
          [
            [
              [133.405533, -2.615578],
              [133.394867, -2.664128],
              [133.389877, -2.580671],
              [133.405533, -2.615578],
            ],
          ],
          [
            [
              [133.516907, -2.594562],
              [133.528336, -2.610833],
              [133.512497, -2.64528],
              [133.514725, -2.621112],
              [133.498611, -2.606391],
              [133.516907, -2.594562],
            ],
          ],
        ],
      },
      id: 92,
      properties: {
        ID: 23,
        kode: 92,
        provinsi: "PAPUA BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [98.25574, 4.290953],
              [98.251678, 4.20263],
              [98.168282, 4.159943],
              [98.171654, 4.108615],
              [98.234329, 4.129492],
              [98.272324, 4.119934],
              [98.30899, 4.072206],
              [98.387726, 4.076143],
              [98.435066, 4.039406],
              [98.528557, 4.011974],
              [98.558937, 3.939592],
              [98.609138, 3.914186],
              [98.672783, 3.9084],
              [98.697937, 3.874467],
              [98.70237, 3.811335],
              [98.788483, 3.718319],
              [98.991402, 3.652537],
              [99.073792, 3.610853],
              [99.131668, 3.565329],
              [99.205673, 3.535731],
              [99.272652, 3.473173],
              [99.372841, 3.402371],
              [99.485054, 3.348217],
              [99.487228, 3.322032],
              [99.546608, 3.244231],
              [99.670906, 3.209138],
              [99.737755, 3.170621],
              [99.828384, 3.06429],
              [99.917145, 2.979943],
              [99.998863, 2.93651],
              [99.990746, 2.856591],
              [100.000282, 2.799706],
              [99.981476, 2.742654],
              [100.006645, 2.724051],
              [100.060226, 2.733359],
              [100.098732, 2.676424],
              [100.136818, 2.672004],
              [100.176842, 2.706297],
              [100.222885, 2.703859],
              [100.241371, 2.637462],
              [100.33075, 2.534235],
              [100.302208, 2.413565],
              [100.309578, 2.34065],
              [100.360146, 2.220377],
              [100.322708, 2.014011],
              [100.322128, 1.919015],
              [100.2864, 1.830302],
              [100.292068, 1.802315],
              [100.408333, 1.777267],
              [100.455269, 1.629147],
              [100.415886, 1.537141],
              [100.434021, 1.51129],
              [100.408829, 1.470363],
              [100.315857, 1.416456],
              [100.27504, 1.421141],
              [100.242752, 1.392655],
              [100.077881, 1.387209],
              [100.086632, 1.337513],
              [100.123497, 1.254924],
              [100.130478, 1.174596],
              [100.16082, 1.151491],
              [100.108658, 1.071883],
              [100.161377, 0.999156],
              [100.136681, 0.949117],
              [100.092819, 0.915075],
              [100.132614, 0.891546],
              [100.140305, 0.797662],
              [100.183716, 0.761895],
              [100.083336, 0.791869],
              [99.957077, 0.875112],
              [99.881943, 0.90572],
              [99.835236, 0.889678],
              [99.845215, 0.83873],
              [99.845169, 0.686254],
              [99.914688, 0.680979],
              [99.919365, 0.605901],
              [99.964767, 0.554445],
              [99.908188, 0.474805],
              [99.82309, 0.461878],
              [99.765022, 0.481917],
              [99.716553, 0.454064],
              [99.670876, 0.481021],
              [99.640007, 0.547226],
              [99.587463, 0.516625],
              [99.499702, 0.538817],
              [99.407265, 0.493468],
              [99.331474, 0.362899],
              [99.297096, 0.337691],
              [99.235527, 0.327712],
              [99.16198, 0.231812],
              [99.153839, 0.308747],
              [99.109512, 0.342637],
              [99.135689, 0.435732],
              [99.093124, 0.60576],
              [99.071304, 0.629137],
              [99.057587, 0.726479],
              [99.017548, 0.813711],
              [98.991776, 0.822795],
              [98.969215, 0.931165],
              [98.927269, 1.041666],
              [98.910728, 1.122399],
              [98.839851, 1.286661],
              [98.844856, 1.333901],
              [98.777878, 1.434891],
              [98.759827, 1.528909],
              [98.772934, 1.561786],
              [98.840958, 1.628664],
              [98.82769, 1.677764],
              [98.797264, 1.683911],
              [98.769341, 1.7595],
              [98.707138, 1.789281],
              [98.67894, 1.740839],
              [98.611458, 1.838434],
              [98.501572, 1.941459],
              [98.466949, 1.987465],
              [98.389442, 2.007457],
              [98.338593, 2.045849],
              [98.271065, 2.049494],
              [98.224586, 2.096319],
              [98.153148, 2.146027],
              [98.18766, 2.319383],
              [98.155571, 2.413039],
              [98.112091, 2.424448],
              [98.109344, 2.47093],
              [98.083992, 2.50935],
              [98.075233, 2.57553],
              [98.085129, 2.63422],
              [98.12426, 2.655123],
              [98.086838, 2.7349],
              [98.088196, 2.821929],
              [98.042084, 2.828039],
              [98.006783, 2.889557],
              [97.954605, 2.900333],
              [97.958275, 2.961847],
              [97.939224, 3.071936],
              [97.983467, 3.083911],
              [97.978615, 3.127329],
              [97.942329, 3.164997],
              [97.925278, 3.226437],
              [97.872261, 3.249049],
              [97.984924, 3.275573],
              [98.029823, 3.329871],
              [98.003082, 3.369784],
              [97.949715, 3.391531],
              [97.906899, 3.553616],
              [97.869896, 3.57131],
              [97.843933, 3.660525],
              [97.803185, 3.731739],
              [97.908562, 3.820508],
              [97.89991, 3.89141],
              [97.944946, 3.89686],
              [97.95816, 3.928891],
              [98.023132, 3.969775],
              [98.059311, 4.190727],
              [98.090927, 4.19672],
              [98.145401, 4.287369],
              [98.25574, 4.290953],
            ],
            [
              [98.92707, 2.662123],
              [98.922714, 2.694872],
              [98.833435, 2.747945],
              [98.79274, 2.79301],
              [98.692108, 2.850813],
              [98.625786, 2.878684],
              [98.531593, 2.892692],
              [98.527939, 2.792798],
              [98.593155, 2.730381],
              [98.624992, 2.681004],
              [98.616501, 2.648208],
              [98.683029, 2.637003],
              [98.695267, 2.72581],
              [98.723587, 2.754783],
              [98.777992, 2.739367],
              [98.854713, 2.665531],
              [98.921768, 2.541882],
              [98.971985, 2.50286],
              [98.98819, 2.455078],
              [98.922638, 2.428574],
              [98.874153, 2.425913],
              [98.778, 2.504612],
              [98.72554, 2.532148],
              [98.69825, 2.601211],
              [98.667595, 2.545009],
              [98.733681, 2.51731],
              [98.804596, 2.424474],
              [98.817467, 2.378578],
              [98.854034, 2.333492],
              [98.917976, 2.348454],
              [98.991257, 2.324367],
              [99.029228, 2.357742],
              [99.055664, 2.329031],
              [99.151482, 2.391701],
              [99.148209, 2.430922],
              [99.062157, 2.391961],
              [99.04792, 2.48477],
              [99.027946, 2.516789],
              [98.924484, 2.584452],
              [98.909531, 2.623648],
              [98.92707, 2.662123],
            ],
          ],
          [
            [
              [97.500496, 0.916113],
              [97.471382, 0.935922],
              [97.399849, 0.942146],
              [97.358147, 1.075364],
              [97.253624, 1.231068],
              [97.182999, 1.289336],
              [97.136726, 1.3638],
              [97.073105, 1.417242],
              [97.122917, 1.424893],
              [97.19696, 1.395284],
              [97.257141, 1.410369],
              [97.340027, 1.4905],
              [97.386353, 1.493314],
              [97.428909, 1.468561],
              [97.476486, 1.468499],
              [97.530159, 1.407647],
              [97.530495, 1.382853],
              [97.583405, 1.330732],
              [97.678436, 1.177108],
              [97.787994, 1.149787],
              [97.854446, 1.053744],
              [97.889046, 1.051632],
              [97.935623, 0.960954],
              [97.893776, 0.898828],
              [97.885437, 0.823092],
              [97.89946, 0.793721],
              [97.875778, 0.743668],
              [97.8918, 0.628914],
              [97.827011, 0.568907],
              [97.795334, 0.558244],
              [97.733276, 0.577961],
              [97.704224, 0.559856],
              [97.658752, 0.659734],
              [97.645798, 0.737644],
              [97.58802, 0.838179],
              [97.500496, 0.916113],
            ],
          ],
          [
            [
              [98.409668, -0.596789],
              [98.341278, -0.512249],
              [98.370155, -0.452895],
              [98.367058, -0.377264],
              [98.380356, -0.337618],
              [98.436165, -0.295887],
              [98.442184, -0.244816],
              [98.516144, -0.35539],
              [98.501068, -0.394909],
              [98.498665, -0.490648],
              [98.476936, -0.518796],
              [98.498367, -0.555216],
              [98.409668, -0.596789],
            ],
          ],
          [
            [
              [98.371108, 0.005866],
              [98.414833, -0.025506],
              [98.465797, -0.0922],
              [98.488098, -0.203953],
              [98.568024, -0.27773],
              [98.56321, -0.328114],
              [98.51564, -0.321089],
              [98.427185, -0.20239],
              [98.384697, -0.132913],
              [98.356728, -0.054339],
              [98.314896, -0.011829],
              [98.371108, 0.005866],
            ],
          ],
          [
            [
              [98.598198, 0.094976],
              [98.5308, 0.106037],
              [98.522354, 0.144102],
              [98.60891, 0.183891],
              [98.717834, 0.159357],
              [98.796844, 0.171431],
              [98.850594, 0.117946],
              [98.844627, 0.082099],
              [98.777519, 0.098079],
              [98.74559, 0.073061],
              [98.598198, 0.094976],
            ],
          ],
          [
            [
              [98.460686, 1.702748],
              [98.486298, 1.698948],
              [98.50116, 1.625],
              [98.444466, 1.652204],
              [98.460686, 1.702748],
            ],
          ],
        ],
      },
      id: 12,
      properties: {
        ID: 24,
        kode: 12,
        provinsi: "SUMATERA UTARA",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [105.106688, -2.022016],
              [105.124608, -1.957248],
              [105.165632, -1.925504],
              [105.221056, -1.913472],
              [105.34688, -1.841024],
              [105.393152, -1.779392],
              [105.369664, -1.717056],
              [105.334016, -1.693568],
              [105.360896, -1.649792],
              [105.464384, -1.560448],
              [105.534464, -1.563456],
              [105.600512, -1.545152],
              [105.644352, -1.641792],
              [105.714752, -1.655552],
              [105.65472, -1.716672],
              [105.674432, -1.761728],
              [105.731264, -1.780544],
              [105.792768, -1.755264],
              [105.744704, -1.68576],
              [105.764864, -1.648128],
              [105.72064, -1.57952],
              [105.753664, -1.531264],
              [105.876224, -1.51872],
              [105.929792, -1.54816],
              [106.008896, -1.567616],
              [106.029824, -1.616448],
              [106.04224, -1.698368],
              [106.146688, -1.85952],
              [106.192512, -1.896128],
              [106.163776, -1.92672],
              [106.153344, -2.016064],
              [106.175616, -2.150848],
              [106.225216, -2.258176],
              [106.23424, -2.328064],
              [106.281152, -2.397888],
              [106.340864, -2.45632],
              [106.380672, -2.47392],
              [106.444928, -2.470464],
              [106.515712, -2.511936],
              [106.689408, -2.541632],
              [106.798336, -2.5664],
              [106.705984, -2.641472],
              [106.65664, -2.72064],
              [106.587264, -2.916224],
              [106.595136, -2.953152],
              [106.737536, -3.004288],
              [106.742592, -3.053824],
              [106.704064, -3.09504],
              [106.647424, -3.081152],
              [106.562496, -3.0832],
              [106.520832, -3.112192],
              [106.497728, -3.064704],
              [106.412288, -2.966656],
              [106.330944, -2.963264],
              [106.276224, -2.902592],
              [106.236928, -2.899648],
              [106.176896, -2.868672],
              [106.140864, -2.8736],
              [106.097408, -2.833472],
              [105.996096, -2.820352],
              [105.962816, -2.805312],
              [105.91584, -2.735872],
              [105.884544, -2.635776],
              [105.932224, -2.473024],
              [105.909376, -2.44128],
              [105.831104, -2.40768],
              [105.801792, -2.35872],
              [105.82368, -2.30688],
              [105.785856, -2.244864],
              [105.776192, -2.156288],
              [105.733952, -2.128384],
              [105.655808, -2.114432],
              [105.590464, -2.119936],
              [105.55904, -2.08192],
              [105.503616, -2.080512],
              [105.437184, -2.133312],
              [105.358336, -2.12],
              [105.301184, -2.142848],
              [105.253312, -2.083648],
              [105.217216, -2.06432],
              [105.128064, -2.082688],
              [105.106688, -2.022016],
            ],
          ],
          [
            [
              [107.62494, -2.74277],
              [107.618688, -2.695936],
              [107.648512, -2.627072],
              [107.630976, -2.59584],
              [107.662464, -2.5584],
              [107.72224, -2.547584],
              [107.769664, -2.556928],
              [107.81536, -2.53632],
              [107.909824, -2.575872],
              [107.994752, -2.57472],
              [108.00992, -2.596864],
              [108.083328, -2.606464],
              [108.183744, -2.6768],
              [108.26048, -2.766976],
              [108.290432, -2.85312],
              [108.245184, -2.908544],
              [108.235328, -2.95712],
              [108.199616, -3.011008],
              [108.209472, -3.048064],
              [108.173632, -3.109184],
              [108.169472, -3.14816],
              [108.135808, -3.1664],
              [108.073408, -3.166144],
              [108.062976, -3.235776],
              [107.96832, -3.237568],
              [107.961664, -3.149376],
              [107.85152, -3.053248],
              [107.839552, -3.146784],
              [107.758144, -3.1864],
              [107.713856, -3.18752],
              [107.642048, -3.23136],
              [107.589952, -3.197696],
              [107.628416, -3.142848],
              [107.58528, -3.079872],
              [107.569728, -3.027648],
              [107.610816, -2.926144],
              [107.545408, -2.902208],
              [107.600064, -2.858496],
              [107.598656, -2.788224],
              [107.62494, -2.74277],
            ],
          ],
          [
            [
              [106.881216, -2.999872],
              [106.872896, -3.028288],
              [106.793344, -3.019648],
              [106.707712, -2.962624],
              [106.729344, -2.9296],
              [106.803776, -2.885888],
              [106.900608, -2.935168],
              [106.881216, -2.999872],
            ],
          ],
          [
            [
              [107.488, -2.853568],
              [107.472128, -2.908416],
              [107.416256, -2.94496],
              [107.362176, -2.896256],
              [107.38624, -2.850304],
              [107.426752, -2.828096],
              [107.488, -2.853568],
            ],
          ],
          [
            [
              [107.094272, -2.87296],
              [107.0608, -2.907392],
              [107.020736, -2.873088],
              [107.054208, -2.81888],
              [107.094272, -2.87296],
            ],
          ],
        ],
      },
      id: 19,
      properties: {
        ID: 25,
        kode: 19,
        provinsi: "BANGKA BELITUNG",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [99.16198, 0.231812],
              [99.235527, 0.327712],
              [99.297096, 0.337691],
              [99.331474, 0.362899],
              [99.407265, 0.493468],
              [99.499702, 0.538817],
              [99.587463, 0.516625],
              [99.640007, 0.547226],
              [99.670876, 0.481021],
              [99.716553, 0.454064],
              [99.765022, 0.481917],
              [99.82309, 0.461878],
              [99.908188, 0.474805],
              [99.964767, 0.554445],
              [99.919365, 0.605901],
              [99.914688, 0.680979],
              [99.845169, 0.686254],
              [99.845215, 0.83873],
              [99.835236, 0.889678],
              [99.881943, 0.90572],
              [99.957077, 0.875112],
              [100.083336, 0.791869],
              [100.183716, 0.761895],
              [100.25573, 0.709395],
              [100.205925, 0.593234],
              [100.219559, 0.524918],
              [100.282326, 0.408069],
              [100.281677, 0.332958],
              [100.361946, 0.354324],
              [100.394623, 0.339763],
              [100.43718, 0.247852],
              [100.464088, 0.222191],
              [100.605743, 0.183473],
              [100.687881, 0.177849],
              [100.727119, 0.193165],
              [100.778122, 0.169268],
              [100.792191, 0.120829],
              [100.753342, 0.048535],
              [100.770103, -0.033094],
              [100.748398, -0.065219],
              [100.781006, -0.23042],
              [100.838776, -0.290596],
              [100.833672, -0.318377],
              [100.910423, -0.370743],
              [100.94133, -0.312437],
              [100.996368, -0.314363],
              [101.031708, -0.340868],
              [101.024826, -0.398442],
              [101.06768, -0.498227],
              [101.181267, -0.549494],
              [101.256569, -0.626754],
              [101.359833, -0.659254],
              [101.407272, -0.736848],
              [101.500015, -0.807856],
              [101.595917, -0.8512],
              [101.6539, -0.935173],
              [101.747887, -0.967631],
              [101.821533, -0.977189],
              [101.830315, -1.10193],
              [101.878525, -1.110225],
              [101.858885, -1.158166],
              [101.815407, -1.209807],
              [101.709229, -1.237597],
              [101.689585, -1.295043],
              [101.719172, -1.344921],
              [101.691318, -1.397239],
              [101.720899, -1.42113],
              [101.694035, -1.480637],
              [101.567154, -1.572305],
              [101.526581, -1.616804],
              [101.492464, -1.681019],
              [101.431198, -1.696775],
              [101.415512, -1.671203],
              [101.319626, -1.693206],
              [101.258324, -1.693337],
              [101.21579, -1.714355],
              [101.18763, -1.677177],
              [101.125816, -1.679094],
              [101.124443, -1.78474],
              [101.144699, -1.917723],
              [101.194092, -1.989151],
              [101.243668, -2.021798],
              [101.291611, -2.133106],
              [101.306076, -2.23891],
              [101.294159, -2.280203],
              [101.244644, -2.344946],
              [101.155373, -2.390157],
              [101.027755, -2.482182],
              [100.992081, -2.431542],
              [100.897308, -2.337769],
              [100.877205, -2.247514],
              [100.831245, -2.188847],
              [100.82914, -2.147044],
              [100.869568, -2.104535],
              [100.884331, -2.042843],
              [100.858192, -1.919218],
              [100.78273, -1.819229],
              [100.684204, -1.661846],
              [100.64151, -1.618727],
              [100.633499, -1.562898],
              [100.555435, -1.403785],
              [100.576469, -1.376961],
              [100.544067, -1.308304],
              [100.492241, -1.299992],
              [100.458786, -1.26039],
              [100.402206, -1.268252],
              [100.417633, -1.200178],
              [100.382729, -1.178114],
              [100.410194, -1.037552],
              [100.364952, -0.995286],
              [100.342545, -0.882115],
              [100.269402, -0.782622],
              [100.117134, -0.631379],
              [100.080696, -0.549656],
              [99.971771, -0.443441],
              [99.918625, -0.404366],
              [99.886421, -0.349305],
              [99.820641, -0.306837],
              [99.806374, -0.245461],
              [99.750984, -0.153287],
              [99.765541, -0.065272],
              [99.735329, -0.027319],
              [99.610626, 0.069696],
              [99.471992, 0.134715],
              [99.394257, 0.152445],
              [99.353981, 0.230505],
              [99.312424, 0.238678],
              [99.253555, 0.211412],
              [99.16198, 0.231812],
            ],
            [
              [100.148926, -0.294198],
              [100.165466, -0.310519],
              [100.165375, -0.388144],
              [100.218018, -0.396025],
              [100.226418, -0.288869],
              [100.194832, -0.252879],
              [100.148926, -0.294198],
            ],
            [
              [100.500008, -0.534535],
              [100.487389, -0.577913],
              [100.540764, -0.666713],
              [100.59713, -0.680994],
              [100.544914, -0.55475],
              [100.500008, -0.534535],
            ],
          ],
          [
            [
              [99.263031, -1.718946],
              [99.241554, -1.791817],
              [99.170258, -1.775342],
              [99.104195, -1.809051],
              [99.009583, -1.762335],
              [98.872444, -1.675564],
              [98.81971, -1.61324],
              [98.831772, -1.58409],
              [98.798141, -1.519863],
              [98.686104, -1.357201],
              [98.628815, -1.283929],
              [98.597008, -1.222869],
              [98.64505, -1.10431],
              [98.65641, -0.979386],
              [98.715179, -0.94198],
              [98.786461, -0.954942],
              [98.905327, -0.907312],
              [98.901535, -0.943195],
              [98.930374, -1.056429],
              [98.997421, -1.109993],
              [99.003639, -1.159117],
              [99.029007, -1.183758],
              [99.069817, -1.264657],
              [99.095047, -1.360714],
              [99.162605, -1.427637],
              [99.159073, -1.492668],
              [99.192131, -1.505583],
              [99.193535, -1.554393],
              [99.22258, -1.605247],
              [99.258133, -1.590373],
              [99.280853, -1.628746],
              [99.263031, -1.718946],
            ],
          ],
          [
            [
              [100.432472, -3.000107],
              [100.465523, -3.033659],
              [100.468422, -3.144241],
              [100.394447, -3.149384],
              [100.389984, -3.197419],
              [100.475174, -3.334633],
              [100.421425, -3.310643],
              [100.342789, -3.24575],
              [100.325836, -3.212034],
              [100.332291, -3.129642],
              [100.296883, -3.080192],
              [100.228333, -3.045524],
              [100.186508, -2.986326],
              [100.200531, -2.933076],
              [100.17469, -2.801497],
              [100.23597, -2.778423],
              [100.261101, -2.820208],
              [100.354225, -2.895449],
              [100.432472, -3.000107],
            ],
          ],
          [
            [
              [99.995766, -2.749434],
              [100.004059, -2.723478],
              [99.970131, -2.509001],
              [99.994774, -2.498358],
              [100.070412, -2.575727],
              [100.168579, -2.640264],
              [100.221405, -2.740431],
              [100.11644, -2.831824],
              [100.015343, -2.805559],
              [99.995766, -2.749434],
            ],
          ],
          [
            [
              [99.822586, -2.306719],
              [99.833534, -2.360941],
              [99.793526, -2.368245],
              [99.74221, -2.344413],
              [99.673538, -2.286497],
              [99.598953, -2.281999],
              [99.52739, -2.152481],
              [99.571342, -2.143682],
              [99.545197, -2.067696],
              [99.565895, -2.036215],
              [99.618942, -2.025629],
              [99.689621, -2.074452],
              [99.710625, -2.154402],
              [99.783386, -2.28467],
              [99.822586, -2.306719],
            ],
          ],
        ],
      },
      id: 13,
      properties: {
        ID: 26,
        kode: 13,
        provinsi: "SUMATERA BARAT",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [110.7221, -3.00548],
            [110.747238, -2.952027],
            [110.797234, -2.912337],
            [110.886566, -2.874295],
            [110.967964, -2.856296],
            [111.010681, -2.794681],
            [111.063812, -2.785731],
            [111.138382, -2.7492],
            [111.166374, -2.710246],
            [111.16468, -2.672753],
            [111.118469, -2.653161],
            [111.136215, -2.611802],
            [111.105408, -2.484712],
            [111.104942, -2.433837],
            [111.068977, -2.298775],
            [111.0326, -2.247475],
            [111.077835, -2.153214],
            [111.049252, -2.069462],
            [111.085697, -2.007968],
            [111.046007, -1.95951],
            [110.978226, -1.95324],
            [110.995881, -1.900829],
            [110.969867, -1.866475],
            [110.971994, -1.812174],
            [111.018458, -1.760494],
            [111.001907, -1.691915],
            [110.974731, -1.667775],
            [110.913635, -1.717645],
            [110.857147, -1.667797],
            [110.855583, -1.633108],
            [110.912148, -1.583816],
            [110.94973, -1.578825],
            [110.980354, -1.538065],
            [111.039024, -1.539377],
            [111.077415, -1.562303],
            [111.123306, -1.544106],
            [111.111994, -1.487714],
            [111.157883, -1.470608],
            [111.188332, -1.490991],
            [111.21228, -1.411965],
            [111.261569, -1.387914],
            [111.348486, -1.285983],
            [111.417722, -1.249998],
            [111.489815, -1.279386],
            [111.494591, -1.221164],
            [111.560516, -1.210964],
            [111.571541, -1.14573],
            [111.55349, -1.117017],
            [111.570969, -1.075839],
            [111.623978, -1.031922],
            [111.624825, -0.984459],
            [111.717972, -0.945031],
            [111.733315, -0.923568],
            [111.832191, -0.914291],
            [111.906021, -0.869211],
            [111.906593, -0.775333],
            [111.954544, -0.818529],
            [112.000516, -0.782459],
            [111.999829, -0.72664],
            [112.039477, -0.702334],
            [112.107172, -0.688612],
            [112.199463, -0.614976],
            [112.244011, -0.634966],
            [112.302696, -0.732715],
            [112.449364, -0.679314],
            [112.538094, -0.699546],
            [112.595421, -0.687516],
            [112.634483, -0.654555],
            [112.688972, -0.652312],
            [112.731289, -0.624087],
            [112.754036, -0.568419],
            [112.852104, -0.568786],
            [112.888245, -0.5348],
            [113.032639, -0.487246],
            [113.059326, -0.500177],
            [113.131927, -0.450832],
            [113.229156, -0.474128],
            [113.265274, -0.432963],
            [113.260048, -0.386946],
            [113.221898, -0.340063],
            [113.333961, -0.188953],
            [113.424301, 0.01172],
            [113.405693, 0.138666],
            [113.326904, 0.178387],
            [113.269646, 0.237864],
            [113.322639, 0.27277],
            [113.437424, 0.265147],
            [113.513199, 0.320208],
            [113.587898, 0.405597],
            [113.656631, 0.438104],
            [113.672333, 0.505215],
            [113.738724, 0.544104],
            [113.842865, 0.665291],
            [113.962456, 0.657218],
            [114.047279, 0.67466],
            [114.105927, 0.698564],
            [114.149551, 0.67515],
            [114.172874, 0.628675],
            [114.150124, 0.584852],
            [114.211525, 0.53291],
            [114.280472, 0.540742],
            [114.353485, 0.53131],
            [114.412323, 0.495826],
            [114.429817, 0.545453],
            [114.492722, 0.57297],
            [114.51963, 0.564921],
            [114.54274, 0.631714],
            [114.589912, 0.626305],
            [114.653, 0.685335],
            [114.713394, 0.705227],
            [114.766129, 0.742571],
            [114.827667, 0.751281],
            [114.846718, 0.715452],
            [114.911812, 0.784313],
            [114.944992, 0.775121],
            [114.992355, 0.71701],
            [115.010025, 0.617119],
            [115.093254, 0.47235],
            [115.136154, 0.429964],
            [115.125549, 0.369575],
            [115.040817, 0.303441],
            [115.025604, 0.325491],
            [114.964165, 0.315193],
            [114.94455, 0.330936],
            [114.888893, 0.297505],
            [114.827431, 0.196637],
            [114.792274, 0.093691],
            [114.882278, 0.053212],
            [114.89846, -0.035127],
            [114.948639, -0.1902],
            [114.980179, -0.178222],
            [115.044418, -0.190297],
            [115.082069, -0.152977],
            [115.149078, -0.136886],
            [115.155769, -0.103698],
            [115.297623, -0.03339],
            [115.320732, -0.093379],
            [115.265564, -0.157903],
            [115.26992, -0.185243],
            [115.239098, -0.244186],
            [115.227875, -0.305798],
            [115.246429, -0.4417],
            [115.303055, -0.501086],
            [115.324715, -0.557164],
            [115.352211, -0.579602],
            [115.367661, -0.749212],
            [115.39312, -0.82201],
            [115.495659, -0.848081],
            [115.582848, -0.947266],
            [115.65976, -1.000104],
            [115.693001, -1.054689],
            [115.743721, -1.090938],
            [115.749481, -1.124644],
            [115.800606, -1.113091],
            [115.844508, -1.162429],
            [115.776921, -1.230763],
            [115.751405, -1.316831],
            [115.750001, -1.314339],
            [115.75, -1.314338],
            [115.669192, -1.333779],
            [115.556666, -1.395118],
            [115.414142, -1.424074],
            [115.351248, -1.633594],
            [115.324479, -1.809402],
            [115.33758, -1.851955],
            [115.402261, -1.954247],
            [115.371055, -2.010274],
            [115.406859, -2.060095],
            [115.322177, -2.072651],
            [115.297228, -2.143794],
            [115.29124, -2.224027],
            [115.248471, -2.211515],
            [115.040507, -2.352388],
            [114.987968, -2.413859],
            [114.919861, -2.455716],
            [114.886746, -2.50283],
            [114.806774, -2.578846],
            [114.787004, -2.682251],
            [114.761401, -2.722209],
            [114.672453, -2.747],
            [114.664366, -2.800567],
            [114.598846, -2.815611],
            [114.617653, -2.883607],
            [114.567871, -2.866444],
            [114.546252, -2.947693],
            [114.496324, -3.015414],
            [114.545967, -3.067971],
            [114.429722, -3.174344],
            [114.450182, -3.209987],
            [114.383407, -3.26764],
            [114.347025, -3.350136],
            [114.358683, -3.386272],
            [114.349449, -3.456847],
            [114.3211, -3.44867],
            [114.244545, -3.386611],
            [114.1825, -3.39577],
            [114.075844, -3.350414],
            [113.9525, -3.36466],
            [113.8419, -3.4356],
            [113.8007, -3.45275],
            [113.6978, -3.46773],
            [113.5807, -3.44965],
            [113.6295, -3.3223],
            [113.6281, -3.26023],
            [113.596, -3.16723],
            [113.5531, -3.15856],
            [113.4589, -3.17963],
            [113.4371, -3.22352],
            [113.3492, -3.28269],
            [113.2787, -3.19723],
            [113.2133, -3.13482],
            [113.1866, -3.0871],
            [113.1096, -3.04946],
            [113.0286, -2.98744],
            [113.0193, -3.02321],
            [112.9457, -3.10261],
            [112.955, -3.1394],
            [113.0109, -3.16073],
            [112.9319, -3.23328],
            [112.8091, -3.30329],
            [112.6798, -3.36703],
            [112.6415, -3.40226],
            [112.5488, -3.44531],
            [112.4781, -3.4142],
            [112.4349, -3.36454],
            [112.3207, -3.31361],
            [112.2506, -3.31554],
            [112.1808, -3.34316],
            [112.0923, -3.39754],
            [111.9173, -3.5453],
            [111.8821, -3.5622],
            [111.8101, -3.55057],
            [111.7749, -3.5178],
            [111.8024, -3.47417],
            [111.8246, -3.39013],
            [111.8225, -3.31093],
            [111.8031, -3.19602],
            [111.832, -3.07153],
            [111.8056, -2.9831],
            [111.7367, -2.87741],
            [111.6985, -2.86289],
            [111.6686, -2.89805],
            [111.6874, -2.94647],
            [111.6336, -2.96257],
            [111.6012, -2.99998],
            [111.5433, -3.01695],
            [111.5187, -2.97853],
            [111.456, -2.93012],
            [111.3598, -2.91315],
            [111.2952, -2.93317],
            [111.2114, -2.98162],
            [111.0547, -3.04916],
            [110.9794, -3.06996],
            [110.9077, -3.04345],
            [110.8092, -2.98021],
            [110.7221, -3.00548],
          ],
        ],
      },
      id: 62,
      properties: {
        ID: 27,
        kode: 62,
        provinsi: "KALIMANTAN TENGAH",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [105.785599, -4.117105],
            [105.736504, -4.14257],
            [105.705254, -4.098131],
            [105.651817, -4.087366],
            [105.609012, -3.941194],
            [105.51181, -3.870661],
            [105.476404, -3.821803],
            [105.432106, -3.826865],
            [105.414685, -3.776846],
            [105.353288, -3.794026],
            [105.339727, -3.729057],
            [105.281975, -3.798395],
            [105.290791, -3.839618],
            [105.245973, -3.907812],
            [105.201302, -3.892022],
            [105.173737, -3.91232],
            [105.133827, -3.991517],
            [105.112688, -3.999992],
            [105.0635, -4.119611],
            [105.063462, -4.11991],
            [105.011985, -4.173651],
            [104.966435, -4.170873],
            [104.815692, -4.241028],
            [104.788078, -4.261929],
            [104.737687, -4.251162],
            [104.734169, -4.251686],
            [104.655515, -4.250796],
            [104.601004, -4.232642],
            [104.448685, -4.298732],
            [104.330181, -4.424722],
            [104.311634, -4.521019],
            [104.332608, -4.612251],
            [104.294205, -4.647204],
            [104.303461, -4.764368],
            [104.325085, -4.806065],
            [104.32542, -4.808589],
            [104.347231, -4.822632],
            [104.348493, -4.822822],
            [104.349944, -4.85207],
            [104.348405, -4.853417],
            [104.311096, -4.885782],
            [104.309891, -4.88541],
            [104.190925, -4.865033],
            [104.160093, -4.922752],
            [104.110733, -4.923104],
            [104.060074, -4.894125],
            [104.020423, -4.905076],
            [104.019723, -4.90522],
            [103.955718, -4.904517],
            [103.95543, -4.904254],
            [103.93436, -4.886683],
            [103.86399, -4.918034],
            [103.864089, -4.847539],
            [103.823976, -4.802083],
            [103.777597, -4.796539],
            [103.777253, -4.79643],
            [103.762881, -4.7421],
            [103.704562, -4.697992],
            [103.693762, -4.652768],
            [103.638473, -4.598905],
            [103.630332, -4.554627],
            [103.590699, -4.52343],
            [103.521138, -4.57475],
            [103.476627, -4.564854],
            [103.405136, -4.499798],
            [103.428073, -4.40753],
            [103.468517, -4.348306],
            [103.453716, -4.3315],
            [103.329801, -4.292813],
            [103.307721, -4.256566],
            [103.200666, -4.247289],
            [103.185598, -4.163748],
            [103.155336, -4.110564],
            [103.128459, -4.025171],
            [102.956093, -4.012947],
            [102.914916, -3.97235],
            [102.886803, -3.989239],
            [102.79337, -3.954387],
            [102.746036, -3.892661],
            [102.686069, -3.858048],
            [102.63594, -3.812298],
            [102.655215, -3.772596],
            [102.728362, -3.75001],
            [102.735313, -3.702301],
            [102.7655, -3.644093],
            [102.809992, -3.608159],
            [102.813889, -3.534643],
            [102.847676, -3.536874],
            [102.921399, -3.593359],
            [102.952011, -3.531126],
            [102.981817, -3.526327],
            [102.998046, -3.466969],
            [102.989653, -3.370434],
            [102.888499, -3.375246],
            [102.881726, -3.345414],
            [102.816825, -3.333799],
            [102.773751, -3.280437],
            [102.742687, -3.315027],
            [102.686779, -3.317826],
            [102.640813, -3.349581],
            [102.596323, -3.333274],
            [102.512752, -3.274333],
            [102.491776, -3.244821],
            [102.485085, -3.1067],
            [102.441376, -3.057934],
            [102.389915, -3.044319],
            [102.322517, -3.068047],
            [102.247734, -3.027864],
            [102.223949, -2.929184],
            [102.132041, -2.87452],
            [102.12852, -2.834456],
            [102.070271, -2.779745],
            [102.070121, -2.779601],
            [102.066829, -2.766654],
            [102.125106, -2.729362],
            [102.23631, -2.687767],
            [102.25, -2.631226],
            [102.279852, -2.615552],
            [102.33295, -2.65582],
            [102.387126, -2.648317],
            [102.405707, -2.688557],
            [102.490935, -2.70477],
            [102.517768, -2.677439],
            [102.597958, -2.677392],
            [102.64112, -2.609328],
            [102.73603, -2.577646],
            [102.79447, -2.533695],
            [102.793521, -2.505252],
            [102.875275, -2.407647],
            [102.839739, -2.358138],
            [102.878348, -2.304883],
            [102.98499, -2.338936],
            [103.035798, -2.33815],
            [103.054261, -2.312252],
            [103.123599, -2.357747],
            [103.211938, -2.312515],
            [103.194719, -2.25453],
            [103.164581, -2.219417],
            [103.219055, -2.171653],
            [103.273361, -2.154748],
            [103.303619, -2.238668],
            [103.392789, -2.295459],
            [103.409337, -2.332503],
            [103.449943, -2.343645],
            [103.465737, -2.249964],
            [103.441574, -2.213186],
            [103.453247, -2.177541],
            [103.526903, -2.167123],
            [103.513543, -2.084383],
            [103.55055, -2.049371],
            [103.56171, -2.000056],
            [103.441719, -1.913766],
            [103.500085, -1.857687],
            [103.552617, -1.891252],
            [103.597851, -1.813841],
            [103.683861, -1.804445],
            [103.863641, -1.803907],
            [103.925284, -1.750187],
            [103.980489, -1.809214],
            [104.072833, -1.805048],
            [104.11097, -1.786794],
            [104.272829, -1.743732],
            [104.30012, -1.774048],
            [104.351075, -1.741535],
            [104.362201, -1.642867],
            [104.418398, -1.628021],
            [104.515165, -1.67627],
            [104.544899, -1.725683],
            [104.536062, -1.796749],
            [104.482233, -1.837572],
            [104.475063, -1.913292],
            [104.519772, -1.925953],
            [104.552302, -1.854772],
            [104.649983, -1.913998],
            [104.657544, -1.963975],
            [104.686527, -1.992045],
            [104.847588, -2.007696],
            [104.899483, -2.091442],
            [104.908005, -2.147511],
            [104.853889, -2.239455],
            [104.853081, -2.288282],
            [104.913132, -2.283812],
            [104.934425, -2.343508],
            [104.997681, -2.337891],
            [105.122139, -2.382225],
            [105.227684, -2.334802],
            [105.294975, -2.370025],
            [105.415565, -2.389337],
            [105.531751, -2.395946],
            [105.55791, -2.419285],
            [105.615726, -2.390048],
            [105.625537, -2.432843],
            [105.601795, -2.553382],
            [105.633308, -2.645045],
            [105.701469, -2.686577],
            [105.756975, -2.689149],
            [105.787621, -2.712982],
            [105.78997, -2.874425],
            [105.811295, -2.915317],
            [105.858688, -2.955325],
            [106.007011, -2.965389],
            [106.043472, -2.992686],
            [106.056297, -3.072323],
            [106.046761, -3.109661],
            [106.079933, -3.193721],
            [106.07856, -3.250618],
            [106.015045, -3.287257],
            [105.912909, -3.384527],
            [105.843343, -3.525817],
            [105.815506, -3.649148],
            [105.827038, -3.712559],
            [105.92809, -3.777244],
            [105.956879, -3.848718],
            [105.866005, -4.018025],
            [105.840332, -4.159925],
            [105.82164, -4.166204],
            [105.814331, -4.153293],
            [105.812897, -4.150985],
            [105.792374, -4.119071],
            [105.785599, -4.117105],
          ],
        ],
      },
      id: 16,
      properties: {
        ID: 28,
        kode: 16,
        provinsi: "SUMATERA SELATAN",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [101.294159, -2.280203],
            [101.306076, -2.23891],
            [101.291611, -2.133106],
            [101.243668, -2.021798],
            [101.194092, -1.989151],
            [101.144699, -1.917723],
            [101.124443, -1.78474],
            [101.125816, -1.679094],
            [101.18763, -1.677177],
            [101.21579, -1.714355],
            [101.258324, -1.693337],
            [101.319626, -1.693206],
            [101.415512, -1.671203],
            [101.431198, -1.696775],
            [101.492464, -1.681019],
            [101.526581, -1.616804],
            [101.567154, -1.572305],
            [101.694035, -1.480637],
            [101.720899, -1.42113],
            [101.691318, -1.397239],
            [101.719172, -1.344921],
            [101.689585, -1.295043],
            [101.709229, -1.237597],
            [101.815407, -1.209807],
            [101.858885, -1.158166],
            [101.878525, -1.110225],
            [101.830315, -1.10193],
            [101.821533, -0.977189],
            [101.845284, -0.982566],
            [101.924278, -0.941475],
            [101.983551, -0.880408],
            [102.057976, -0.889922],
            [102.116615, -0.921174],
            [102.16272, -0.898907],
            [102.217072, -0.946344],
            [102.254326, -0.921539],
            [102.304298, -0.916958],
            [102.324387, -0.960805],
            [102.38623, -0.993385],
            [102.393372, -1.03016],
            [102.44252, -1.025452],
            [102.495422, -1.084733],
            [102.616814, -1.094634],
            [102.638, -1.12041],
            [102.687668, -1.078578],
            [102.780602, -1.023676],
            [102.808495, -0.96665],
            [102.90477, -0.894179],
            [103.008949, -0.755179],
            [103.126038, -0.746429],
            [103.342834, -0.785774],
            [103.482338, -0.771407],
            [103.489655, -0.798365],
            [103.544289, -0.81498],
            [103.549156, -0.858699],
            [103.588211, -0.875501],
            [103.669304, -0.952914],
            [103.714386, -0.95547],
            [103.748962, -0.987215],
            [103.870873, -1.000657],
            [103.921692, -0.98653],
            [104.05471, -1.011177],
            [104.127846, -1.049528],
            [104.209656, -1.071357],
            [104.264328, -1.046509],
            [104.336029, -1.043973],
            [104.369728, -1.022185],
            [104.413643, -1.130576],
            [104.40168, -1.230084],
            [104.46064, -1.336228],
            [104.46386, -1.401982],
            [104.444763, -1.469791],
            [104.465553, -1.596184],
            [104.515165, -1.67627],
            [104.418398, -1.628021],
            [104.362201, -1.642867],
            [104.351075, -1.741535],
            [104.30012, -1.774048],
            [104.272829, -1.743732],
            [104.11097, -1.786794],
            [104.072833, -1.805048],
            [103.980489, -1.809214],
            [103.925284, -1.750187],
            [103.863641, -1.803907],
            [103.683861, -1.804445],
            [103.597851, -1.813841],
            [103.552617, -1.891252],
            [103.500085, -1.857687],
            [103.441719, -1.913766],
            [103.56171, -2.000056],
            [103.55055, -2.049371],
            [103.513543, -2.084383],
            [103.526903, -2.167123],
            [103.453247, -2.177541],
            [103.441574, -2.213186],
            [103.465737, -2.249964],
            [103.449943, -2.343645],
            [103.409337, -2.332503],
            [103.392789, -2.295459],
            [103.303619, -2.238668],
            [103.273361, -2.154748],
            [103.219055, -2.171653],
            [103.164581, -2.219417],
            [103.194719, -2.25453],
            [103.211938, -2.312515],
            [103.123599, -2.357747],
            [103.054261, -2.312252],
            [103.035798, -2.33815],
            [102.98499, -2.338936],
            [102.878348, -2.304883],
            [102.839739, -2.358138],
            [102.875275, -2.407647],
            [102.793521, -2.505252],
            [102.79447, -2.533695],
            [102.73603, -2.577646],
            [102.64112, -2.609328],
            [102.597958, -2.677392],
            [102.517768, -2.677439],
            [102.490935, -2.70477],
            [102.405707, -2.688557],
            [102.387126, -2.648317],
            [102.33295, -2.65582],
            [102.279852, -2.615552],
            [102.25, -2.631226],
            [102.23631, -2.687767],
            [102.125106, -2.729362],
            [102.066829, -2.766654],
            [101.989708, -2.723145],
            [101.915871, -2.738421],
            [101.867928, -2.728184],
            [101.733284, -2.607907],
            [101.674995, -2.532605],
            [101.601181, -2.537571],
            [101.546486, -2.560535],
            [101.559204, -2.451228],
            [101.330421, -2.309457],
            [101.294159, -2.280203],
          ],
          [
            [101.466292, -2.163241],
            [101.528671, -2.17382],
            [101.524849, -2.128504],
            [101.46859, -2.129224],
            [101.466292, -2.163241],
          ],
        ],
      },
      id: 15,
      properties: {
        ID: 29,
        kode: 15,
        provinsi: "JAMBI",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [103.777539, -4.79652],
            [103.777597, -4.796539],
            [103.823976, -4.802083],
            [103.864089, -4.847539],
            [103.86399, -4.918034],
            [103.93436, -4.886683],
            [103.95543, -4.904254],
            [103.955718, -4.904517],
            [104.019723, -4.90522],
            [104.020423, -4.905076],
            [104.060074, -4.894125],
            [104.110733, -4.923104],
            [104.160093, -4.922752],
            [104.190925, -4.865033],
            [104.309891, -4.88541],
            [104.311096, -4.885782],
            [104.348405, -4.853417],
            [104.349944, -4.85207],
            [104.348493, -4.822822],
            [104.347231, -4.822632],
            [104.32542, -4.808589],
            [104.325085, -4.806065],
            [104.303461, -4.764368],
            [104.294205, -4.647204],
            [104.332608, -4.612251],
            [104.311634, -4.521019],
            [104.330181, -4.424722],
            [104.448685, -4.298732],
            [104.601004, -4.232642],
            [104.655515, -4.250796],
            [104.734169, -4.251686],
            [104.737687, -4.251162],
            [104.788078, -4.261929],
            [104.815692, -4.241028],
            [104.966435, -4.170873],
            [105.011985, -4.173651],
            [105.063462, -4.11991],
            [105.0635, -4.119611],
            [105.112688, -3.999992],
            [105.133827, -3.991517],
            [105.173737, -3.91232],
            [105.201302, -3.892022],
            [105.245973, -3.907812],
            [105.290791, -3.839618],
            [105.281975, -3.798395],
            [105.339727, -3.729057],
            [105.353288, -3.794026],
            [105.414685, -3.776846],
            [105.432106, -3.826865],
            [105.476404, -3.821803],
            [105.51181, -3.870661],
            [105.609012, -3.941194],
            [105.651817, -4.087366],
            [105.705254, -4.098131],
            [105.736504, -4.14257],
            [105.785599, -4.117105],
            [105.792374, -4.119071],
            [105.812897, -4.150985],
            [105.814331, -4.153293],
            [105.82164, -4.166204],
            [105.817635, -4.316465],
            [105.858208, -4.376366],
            [105.898064, -4.465971],
            [105.903992, -4.543446],
            [105.884163, -4.593911],
            [105.912933, -4.647402],
            [105.879227, -4.69676],
            [105.859253, -4.776061],
            [105.870087, -4.876098],
            [105.903664, -4.938873],
            [105.86618, -4.98373],
            [105.855354, -5.079322],
            [105.863403, -5.259794],
            [105.819687, -5.336089],
            [105.821823, -5.593658],
            [105.809662, -5.68149],
            [105.789368, -5.721141],
            [105.791489, -5.787411],
            [105.774124, -5.837541],
            [105.710793, -5.856688],
            [105.603989, -5.830646],
            [105.581818, -5.802879],
            [105.587814, -5.742107],
            [105.552834, -5.69501],
            [105.407997, -5.623131],
            [105.368057, -5.549149],
            [105.292465, -5.446177],
            [105.250793, -5.471121],
            [105.265236, -5.517141],
            [105.24472, -5.589002],
            [105.205086, -5.576796],
            [105.178093, -5.668644],
            [105.194298, -5.706558],
            [105.157707, -5.747686],
            [105.185173, -5.804526],
            [105.148201, -5.810163],
            [104.986458, -5.715514],
            [104.927589, -5.696409],
            [104.824852, -5.621506],
            [104.775848, -5.605471],
            [104.709152, -5.522681],
            [104.595329, -5.497139],
            [104.529739, -5.541902],
            [104.570694, -5.609401],
            [104.639206, -5.688042],
            [104.646019, -5.748027],
            [104.709442, -5.845267],
            [104.695053, -5.875686],
            [104.721489, -5.934022],
            [104.592552, -5.937325],
            [104.561798, -5.865867],
            [104.45295, -5.764961],
            [104.412384, -5.706299],
            [104.29969, -5.641016],
            [104.318222, -5.60884],
            [104.297874, -5.573801],
            [104.166809, -5.476431],
            [104.119209, -5.456481],
            [103.998734, -5.32204],
            [103.996071, -5.26727],
            [103.905228, -5.207043],
            [103.933052, -5.170211],
            [103.908859, -5.127353],
            [103.864105, -5.110247],
            [103.835388, -5.065404],
            [103.770218, -5.028835],
            [103.715195, -4.967688],
            [103.65519, -4.954104],
            [103.598244, -4.922405],
            [103.603287, -4.89334],
            [103.660652, -4.85998],
            [103.663071, -4.858659],
            [103.71843, -4.802312],
            [103.746193, -4.796777],
            [103.772308, -4.802989],
            [103.77594, -4.798273],
            [103.777539, -4.79652],
          ],
        ],
      },
      id: 18,
      properties: {
        ID: 30,
        kode: 18,
        provinsi: "LAMPUNG",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [103.777253, -4.79643],
              [103.777539, -4.79652],
              [103.77594, -4.798273],
              [103.772308, -4.802989],
              [103.746193, -4.796777],
              [103.71843, -4.802312],
              [103.663071, -4.858659],
              [103.660652, -4.85998],
              [103.603287, -4.89334],
              [103.598244, -4.922405],
              [103.535866, -4.914454],
              [103.500389, -4.875894],
              [103.429695, -4.87312],
              [103.401039, -4.816718],
              [103.309036, -4.781792],
              [103.277702, -4.704457],
              [103.244278, -4.672636],
              [103.113358, -4.578361],
              [103.040985, -4.538898],
              [102.900131, -4.49004],
              [102.883217, -4.442],
              [102.792618, -4.35461],
              [102.692581, -4.272606],
              [102.347687, -4.018148],
              [102.277046, -3.951083],
              [102.307587, -3.900745],
              [102.300446, -3.841087],
              [102.254799, -3.797299],
              [102.265976, -3.764632],
              [102.214775, -3.653597],
              [102.087273, -3.550713],
              [101.933876, -3.477239],
              [101.899567, -3.425596],
              [101.799576, -3.372551],
              [101.620651, -3.239907],
              [101.523598, -3.11352],
              [101.48774, -3.022807],
              [101.405663, -2.925677],
              [101.325256, -2.739109],
              [101.292618, -2.709787],
              [101.154854, -2.639229],
              [101.027755, -2.482182],
              [101.155373, -2.390157],
              [101.244644, -2.344946],
              [101.294159, -2.280203],
              [101.330421, -2.309457],
              [101.559204, -2.451228],
              [101.546486, -2.560535],
              [101.601181, -2.537571],
              [101.674995, -2.532605],
              [101.733284, -2.607907],
              [101.867928, -2.728184],
              [101.915871, -2.738421],
              [101.989708, -2.723145],
              [102.066829, -2.766654],
              [102.070121, -2.779601],
              [102.070271, -2.779745],
              [102.12852, -2.834456],
              [102.132041, -2.87452],
              [102.223949, -2.929184],
              [102.247734, -3.027864],
              [102.322517, -3.068047],
              [102.389915, -3.044319],
              [102.441376, -3.057934],
              [102.485085, -3.1067],
              [102.491776, -3.244821],
              [102.512752, -3.274333],
              [102.596323, -3.333274],
              [102.640813, -3.349581],
              [102.686779, -3.317826],
              [102.742687, -3.315027],
              [102.773751, -3.280437],
              [102.816825, -3.333799],
              [102.881726, -3.345414],
              [102.888499, -3.375246],
              [102.989653, -3.370434],
              [102.998046, -3.466969],
              [102.981817, -3.526327],
              [102.952011, -3.531126],
              [102.921399, -3.593359],
              [102.847676, -3.536874],
              [102.813889, -3.534643],
              [102.809992, -3.608159],
              [102.7655, -3.644093],
              [102.735313, -3.702301],
              [102.728362, -3.75001],
              [102.655215, -3.772596],
              [102.63594, -3.812298],
              [102.686069, -3.858048],
              [102.746036, -3.892661],
              [102.79337, -3.954387],
              [102.886803, -3.989239],
              [102.914916, -3.97235],
              [102.956093, -4.012947],
              [103.128459, -4.025171],
              [103.155336, -4.110564],
              [103.185598, -4.163748],
              [103.200666, -4.247289],
              [103.307721, -4.256566],
              [103.329801, -4.292813],
              [103.453716, -4.3315],
              [103.468517, -4.348306],
              [103.428073, -4.40753],
              [103.405136, -4.499798],
              [103.476627, -4.564854],
              [103.521138, -4.57475],
              [103.590699, -4.52343],
              [103.630332, -4.554627],
              [103.638473, -4.598905],
              [103.693762, -4.652768],
              [103.704562, -4.697992],
              [103.762881, -4.7421],
              [103.777253, -4.79643],
            ],
          ],
          [
            [
              [102.156013, -5.285942],
              [102.169739, -5.277181],
              [102.400116, -5.390039],
              [102.370514, -5.503264],
              [102.294418, -5.47437],
              [102.273949, -5.497576],
              [102.215576, -5.409292],
              [102.104958, -5.351578],
              [102.156013, -5.285942],
            ],
          ],
        ],
      },
      id: 17,
      properties: {
        ID: 31,
        kode: 17,
        provinsi: "BENGKULU",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [98.25574, 4.290953],
              [98.145401, 4.287369],
              [98.090927, 4.19672],
              [98.059311, 4.190727],
              [98.023132, 3.969775],
              [97.95816, 3.928891],
              [97.944946, 3.89686],
              [97.89991, 3.89141],
              [97.908562, 3.820508],
              [97.803185, 3.731739],
              [97.843933, 3.660525],
              [97.869896, 3.57131],
              [97.906899, 3.553616],
              [97.949715, 3.391531],
              [98.003082, 3.369784],
              [98.029823, 3.329871],
              [97.984924, 3.275573],
              [97.872261, 3.249049],
              [97.925278, 3.226437],
              [97.942329, 3.164997],
              [97.978615, 3.127329],
              [97.983467, 3.083911],
              [97.939224, 3.071936],
              [97.958275, 2.961847],
              [97.954605, 2.900333],
              [98.006783, 2.889557],
              [98.042084, 2.828039],
              [98.088196, 2.821929],
              [98.086838, 2.7349],
              [98.12426, 2.655123],
              [98.085129, 2.63422],
              [98.075233, 2.57553],
              [98.083992, 2.50935],
              [98.109344, 2.47093],
              [98.112091, 2.424448],
              [98.155571, 2.413039],
              [98.18766, 2.319383],
              [98.153148, 2.146027],
              [98.100174, 2.193217],
              [97.949188, 2.268416],
              [97.847656, 2.247731],
              [97.807373, 2.267888],
              [97.786621, 2.235493],
              [97.660049, 2.402731],
              [97.650513, 2.668232],
              [97.614929, 2.833094],
              [97.58123, 2.890189],
              [97.540428, 2.885374],
              [97.491165, 2.921352],
              [97.446991, 2.924328],
              [97.391426, 2.965523],
              [97.31015, 3.068522],
              [97.265831, 3.209728],
              [97.193413, 3.258642],
              [97.169327, 3.256543],
              [97.124481, 3.346619],
              [97.084641, 3.394672],
              [97.001579, 3.545805],
              [96.904762, 3.60113],
              [96.863861, 3.693694],
              [96.768112, 3.739015],
              [96.669891, 3.745795],
              [96.527695, 3.732057],
              [96.416214, 3.818041],
              [96.358871, 3.885816],
              [96.287979, 3.992574],
              [96.208038, 4.088209],
              [96.143906, 4.141568],
              [96.124184, 4.13581],
              [96.054756, 4.206528],
              [96.014725, 4.214571],
              [95.882767, 4.362245],
              [95.804428, 4.431233],
              [95.730766, 4.513642],
              [95.594887, 4.626799],
              [95.550133, 4.654496],
              [95.503654, 4.70863],
              [95.492639, 4.750018],
              [95.423939, 4.817422],
              [95.380723, 4.964445],
              [95.300005, 5.116235],
              [95.308858, 5.162571],
              [95.268826, 5.198396],
              [95.213608, 5.311016],
              [95.251068, 5.368226],
              [95.243118, 5.460232],
              [95.195138, 5.528332],
              [95.236732, 5.557039],
              [95.267699, 5.550661],
              [95.325329, 5.593556],
              [95.359057, 5.597326],
              [95.440803, 5.657204],
              [95.487781, 5.613286],
              [95.606527, 5.628805],
              [95.684627, 5.585057],
              [95.74082, 5.572229],
              [95.890839, 5.499509],
              [95.904404, 5.441279],
              [95.945007, 5.401387],
              [96.05159, 5.325978],
              [96.085419, 5.287781],
              [96.186943, 5.260334],
              [96.264411, 5.260112],
              [96.392037, 5.209993],
              [96.460292, 5.234842],
              [96.537407, 5.195907],
              [96.635086, 5.209005],
              [96.717148, 5.242064],
              [96.824829, 5.271552],
              [96.911911, 5.249453],
              [97.010216, 5.258295],
              [97.143356, 5.20007],
              [97.156075, 5.147558],
              [97.192665, 5.1418],
              [97.428207, 5.221479],
              [97.494469, 5.248788],
              [97.553452, 5.213005],
              [97.577263, 5.168141],
              [97.647247, 5.083181],
              [97.822609, 4.919947],
              [97.900314, 4.886347],
              [97.960312, 4.727588],
              [97.959435, 4.672001],
              [98.012398, 4.615899],
              [97.970482, 4.559347],
              [97.994522, 4.527931],
              [98.088074, 4.522916],
              [98.169907, 4.50053],
              [98.286339, 4.41748],
              [98.283165, 4.34913],
              [98.25574, 4.290953],
            ],
          ],
          [
            [
              [96.000046, 2.587204],
              [95.937935, 2.571712],
              [95.885063, 2.602638],
              [95.862289, 2.637353],
              [95.813866, 2.644832],
              [95.757629, 2.694828],
              [95.745186, 2.73048],
              [95.690453, 2.772583],
              [95.718544, 2.821893],
              [95.762878, 2.857512],
              [95.77079, 2.901087],
              [95.804932, 2.927299],
              [95.903023, 2.889753],
              [95.866943, 2.850055],
              [95.998611, 2.782477],
              [96.10466, 2.737498],
              [96.093048, 2.651589],
              [96.170616, 2.62701],
              [96.197578, 2.642474],
              [96.245384, 2.584614],
              [96.335121, 2.548106],
              [96.36515, 2.485914],
              [96.424355, 2.488191],
              [96.462692, 2.455348],
              [96.490204, 2.362194],
              [96.424072, 2.32803],
              [96.379951, 2.350147],
              [96.308983, 2.357318],
              [96.300812, 2.422866],
              [96.221466, 2.440987],
              [96.209869, 2.463408],
              [96.123451, 2.517214],
              [96.068642, 2.567691],
              [96.000046, 2.587204],
            ],
          ],
          [
            [
              [97.293701, 2.079459],
              [97.256218, 2.133173],
              [97.133141, 2.200681],
              [97.162033, 2.235634],
              [97.215462, 2.202798],
              [97.271385, 2.222774],
              [97.336807, 2.15933],
              [97.329483, 2.118278],
              [97.293701, 2.079459],
            ],
          ],
          [
            [
              [95.32904, 5.771702],
              [95.286805, 5.779638],
              [95.287225, 5.841259],
              [95.32245, 5.877151],
              [95.375166, 5.846886],
              [95.32904, 5.771702],
            ],
          ],
          [
            [
              [97.111031, 2.111826],
              [97.153557, 2.066705],
              [97.104469, 2.014735],
              [97.069054, 2.070064],
              [97.111031, 2.111826],
            ],
          ],
          [
            [
              [96.629654, 2.119773],
              [96.679573, 2.087339],
              [96.639084, 2.057627],
              [96.607002, 2.083901],
              [96.629654, 2.119773],
            ],
          ],
        ],
      },
      id: 11,
      properties: {
        ID: 32,
        kode: 11,
        provinsi: "ACEH",
      },
    },
  ],
};
